export const tPopularItems = [
  {
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    isPopular: "YES",
    key: "-M9Y1WO275HFH9pHbU8S",
    photos: [
      {
        imageName: "9c4fbc90-c105-11ea-8470-83fbeadd4a74.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F9c4fbc90-c105-11ea-8470-83fbeadd4a74.jpg?alt=media&token=652de7ef-294d-4561-b258-c1e2405bdd78"
      }
    ],
    productNameEnglish: "Green chilli ",
    productPrice: "2.00",
    productSupplier: "BCS SHOP",
    searchText: "কাঁচা মরিচ ",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "200gm",
    updateDateTime: "Sun 20-12-20 11:30 pm",
    count: 828
  },
  {
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    isPopular: "YES",
    key: "-M9XzYPESx_Db7uv0jTY",
    photos: [
      {
        imageName: "253a8c50-abd1-11ea-b76c-0b360dd92c32.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F253a8c50-abd1-11ea-b76c-0b360dd92c32.jpg?alt=media&token=9e5d3417-818c-4a1e-ad72-bc1a2cd428db"
      }
    ],
    productNameEnglish: "Onion bag",
    productPrice: "6",
    productSupplier: "BCS SHOP",
    searchText: "পেঁয়াজ পেয়াজ onion piaz piaj",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1 bag (3 kg)",
    updateDateTime: "Sun 20-12-20 11:29 pm",
    count: 507
  },
  {
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    isPopular: "YES",
    key: "-M9Y5jNlVNJ0uW1ec5mh",
    photos: [
      {
        imageName: "379757a0-b204-11ea-aac4-61b5279351b7.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F379757a0-b204-11ea-aac4-61b5279351b7.jpg?alt=media&token=35add90b-6fbe-4299-883c-394530faf678"
      }
    ],
    productNameEnglish: "Tomatoes ",
    productPrice: "3.50",
    productSupplier: "BCS SHOP",
    searchText: "টমেটো ",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1KG",
    updateDateTime: "17/07/2020 08:30:35",
    count: 429
  },
  {
    author: "+6594562455",
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    isPopular: "YES",
    key: "-M9cN73SCaTMPoEWcX6s",
    photos: [
      {
        imageName: "47401e70-c7f9-11ea-9d1d-d9f4bc315562.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F47401e70-c7f9-11ea-9d1d-d9f4bc315562.jpg?alt=media&token=74597a21-45ff-4906-ab66-9ae3d1f5e84a"
      }
    ],
    productNameEnglish: "GINGER",
    productPrice: "1.40",
    productSupplier: "BCS SHOP",
    searchText: "আদা",
    sortOrder: "a",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "200gm",
    updateDateTime: "30/07/2020 12:11:30",
    count: 418
  },
  {
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    isPopular: "YES",
    key: "-MA4UQ6KFh5415O1ZtaT",
    photos: [
      {
        imageName: "c17e83e0-bdac-11ea-8ba8-ddb60ef370d4.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fc17e83e0-bdac-11ea-8ba8-ddb60ef370d4.jpg?alt=media&token=8a79f382-93c1-4836-8ae4-a80f4acdba89"
      }
    ],
    productNameEnglish: "Cucumber",
    productPrice: "1.30",
    productSupplier: "BCS SHOP",
    searchText: "shosha sosa shoshi salad",
    sortOrder: "a",
    sourceSupplier: "Sheng siong ",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "500gm",
    updateDateTime: "03/08/2020 04:21:46",
    count: 371
  },
  {
    author: "+6594562455",
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    isPopular: "YES",
    key: "-M9YWCesWwfEYegG51K-",
    photos: [
      {
        imageName: "a5b99b00-c81e-11ea-99a6-3f4f89ed7cd9.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fa5b99b00-c81e-11ea-99a6-3f4f89ed7cd9.jpg?alt=media&token=fe01e8d1-51c3-4c4a-a8d1-18b0009544b7"
      }
    ],
    productNameEnglish: "Garlic ",
    productPrice: "1.40",
    productSupplier: "BCS SHOP",
    searchText: "রসুন রসূন রশুন ",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "200gms",
    updateDateTime: "30/07/2020 12:13:08",
    count: 356
  },
  {
    author: "+6589050302",
    availability: "AVAILABLE",
    category: "EGGS DAIRY",
    isPopular: "YES",
    key: "-M9ay5D0iIseTdskzY0e",
    photos: [
      {
        imageName: "20cb1dc0-afc2-11ea-a37e-bd24eb8f726f.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F20cb1dc0-afc2-11ea-a37e-bd24eb8f726f.jpg?alt=media&token=c06cd2ef-a9e3-4e75-9225-398ef140c872"
      }
    ],
    productNameEnglish: "Egg ",
    productPrice: "5.90",
    productSupplier: "BCS SHOP",
    searchText: "ডিম ",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "30pcs",
    updateDateTime: "Wed 05-08-20 5:07 pm",
    count: 351
  },
  {
    author: "+6594562455",
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    isPopular: "YES",
    key: "-MDNgqX2N9uYblwrgjBF",
    photos: [
      {
        imageName: "33f95940-d928-11ea-b868-6be4132c903f.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F33f95940-d928-11ea-b868-6be4132c903f.jpg?alt=media&token=73f1c40f-992b-4680-8550-d3b417923214"
      }
    ],
    productNameEnglish: "Lime",
    productPrice: "1.50",
    productSupplier: "BCS SHOP",
    searchText: "lemon lime lamon লেবু লেভূ লেবো ",
    sortOrder: "a",
    supplierContactName: "Ahmed Fayyaz",
    supplierContactPhone: "97861239",
    unit: "250gm",
    updateDateTime: "Sat 08-08-20 11:43 am",
    count: 290
  },
  {
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    isPopular: "YES",
    key: "-M9Xz1UTYCxt-drlSFrg",
    photos: [
      {
        imageName: "94fa4b80-abd0-11ea-b76c-0b360dd92c32.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F94fa4b80-abd0-11ea-b76c-0b360dd92c32.jpg?alt=media&token=2a1daa66-e53c-440b-82a3-47cd3dd2e2cf"
      }
    ],
    productNameEnglish: "Potato bag ",
    productPrice: "5.5",
    productSupplier: "BCS SHOP",
    searchText: "আলু ",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "4kg",
    updateDateTime: "08/07/2020 06:05:43",
    count: 281
  },
  {
    availability: "AVAILABLE",
    category: "MEAT FISH",
    isPopular: "YES",
    key: "-M9YXmiqrCkl2UACh3XY",
    photos: [
      {
        imageName: "0db6e000-b2a8-11ea-a456-b52272a954da.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F0db6e000-b2a8-11ea-a456-b52272a954da.jpg?alt=media&token=22522c58-0786-4c5c-8673-9ec22520f0bf"
      }
    ],
    productNameEnglish: "Mutton Marrow ",
    productPrice: "6.50",
    productSupplier: "BCS SHOP",
    searchText: "খাসির পায়া ",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1kg",
    updateDateTime: "23/07/2020 01:01:18",
    count: 269
  },
  {
    author: "+6589050302",
    availability: "AVAILABLE",
    category: "MEAT FISH",
    isPopular: "YES",
    key: "-M9YYE7XExSI-8nZhIvy",
    photos: [
      {
        imageName: "63d1a8e0-d3fe-11ea-a0e0-7d366b7a98ae.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F63d1a8e0-d3fe-11ea-a0e0-7d366b7a98ae.jpg?alt=media&token=d7fa02b4-e3af-46cf-b6d4-75212ec12a19"
      }
    ],
    productNameEnglish: "Mutton  (price vary depending on quality)",
    productPrice: "11.50",
    productSupplier: "BCS SHOP",
    searchText: "খাসির মাংস ",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1kg",
    updateDateTime: "Mon 10-08-20 2:37 pm",
    count: 263
  },
  {
    availability: "AVAILABLE",
    category: "MEAT FISH",
    isPopular: "YES",
    key: "-M9YYpBjUhHmun6KH3hq",
    photos: [
      {
        imageName: "33253800-c81f-11ea-99a6-3f4f89ed7cd9.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F33253800-c81f-11ea-99a6-3f4f89ed7cd9.jpg?alt=media&token=56442d8a-c2c3-4408-81d8-991dff35744f"
      }
    ],
    productNameEnglish: "Duck frozen",
    productPrice: "11",
    productSupplier: "BCS SHOP",
    searchText: "হাঁস ",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1 packet",
    updateDateTime: "17/07/2020 07:18:46",
    count: 246
  },
  {
    author: "+6589050302",
    availability: "AVAILABLE",
    category: "SNACKS DRY FOOD",
    key: "-M9bShlvpc1WRxgKblin",
    photos: [
      {
        imageName: "c9d077b0-c7fc-11ea-9d1d-d9f4bc315562.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fc9d077b0-c7fc-11ea-9d1d-d9f4bc315562.jpg?alt=media&token=afd126af-c8e3-4bcc-b3f9-a79c3b21654f"
      }
    ],
    productNameEnglish: "Pran puffed rice 1packet",
    productPrice: "0.90",
    productSupplier: "BCS SHOP",
    searchText: "মুড়ি মুরি ",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1",
    updateDateTime: "23/07/2020 07:29:23",
    count: 245
  },
  {
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    isPopular: "YES",
    key: "-MAB_ZvZGKR0d9NJnjha",
    photos: [
      {
        imageName: "cdaf1c30-b229-11ea-9201-9d4c56efae0c.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fcdaf1c30-b229-11ea-9201-9d4c56efae0c.jpg?alt=media&token=89515213-7acd-4581-badb-c1e2514e16c8"
      }
    ],
    productNameEnglish: "Banana",
    productPrice: "2.50",
    productSupplier: "BCS SHOP",
    searchText: "kola kala kela benana কলা কেলা ",
    sortOrder: "a",
    supplierContactName: "Ahmed Fayyaz",
    supplierContactPhone: "97861239",
    unit: "5 to 6 pcs",
    updateDateTime: "03/08/2020 03:55:59",
    count: 233
  },
  {
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    isPopular: "YES",
    key: "-M9a0bvd5rTsA52SgzV4",
    photos: [
      {
        imageName: "e3140940-f898-11ea-aaa8-a9cfb87a7f3a.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Fe3140940-f898-11ea-aaa8-a9cfb87a7f3a.jpg?alt=media&token=dd62c212-4dd4-4927-9f9b-6fe69504e258"
      }
    ],
    productNameEnglish: "Dates ",
    productPrice: "5",
    productSupplier: "BCS SHOP",
    searchText: "খেজুর ",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "500gm",
    updateDateTime: "Thu 17-09-20 11:50 am",
    count: 230
  },
  {
    availability: "AVAILABLE",
    category: "MEAT FISH",
    isPopular: "YES",
    key: "-M9YY1Vs-DmZEPBdZ7Py",
    photos: [
      {
        imageName: "de857390-bf78-11ea-aa1e-9169bb2ab543.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fde857390-bf78-11ea-aa1e-9169bb2ab543.jpg?alt=media&token=4e793d06-81c3-4017-859b-7dc6d76e3ebe"
      }
    ],
    productNameEnglish: "Beef ",
    productPrice: "9.50",
    productSupplier: "BCS SHOP",
    searchText: "গরুর মাংস",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1kg",
    updateDateTime: "23/07/2020 01:00:56",
    count: 218
  },
  {
    author: "+6594562455",
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    isPopular: "YES",
    key: "-MA0G8ynMhI4HuYx49i8",
    photos: [
      {
        imageName: "590236d0-bc59-11ea-b7df-33e703b87300.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F590236d0-bc59-11ea-b7df-33e703b87300.jpg?alt=media&token=5d090713-f8a2-4eab-b103-a5fb23518b29"
      }
    ],
    productNameEnglish: "Coriander",
    productPrice: "2",
    productSupplier: "BCS SHOP",
    searchText: "ধনিয়া পাতা ",
    sortOrder: "a",
    sourceSupplier: "FAHIM ENTERPRISE PTE LTD",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "100gm",
    updateDateTime: "Sat 08-08-20 11:48 am",
    count: 191
  },
  {
    availability: "AVAILABLE",
    category: "RICE DAAL NOODLES",
    isPopular: "YES",
    key: "-M9bErwUjb0ZFLlRHkYo",
    photos: [
      {
        imageName: "2adcfe70-bd9e-11ea-9c87-8df410c3c074.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F2adcfe70-bd9e-11ea-9c87-8df410c3c074.jpg?alt=media&token=46f3c241-9144-437b-866d-44ee601590f8"
      }
    ],
    productNameEnglish: "Masoor dhal lentils spit 500gm",
    productPrice: "2.5",
    productSupplier: "BCS SHOP",
    searchText: "মশুর মসুর মুশুরি ডাল dhal dal",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "500gm",
    updateDateTime: "17/07/2020 08:56:23",
    count: 180
  },
  {
    availability: "AVAILABLE",
    category: "MEAT FISH",
    isPopular: "YES",
    key: "-M9zpdyjH06nAqwc_-f7",
    photos: [
      {
        imageName: "be0749e0-b037-11ea-9e6b-fd3fc5d44f8f.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fbe0749e0-b037-11ea-9e6b-fd3fc5d44f8f.jpg?alt=media&token=33798c90-e1ae-418d-a0e5-22033d0d0584"
      }
    ],
    productDescription: "3 pcs is 1kg",
    productNameEnglish: "Ilish Fish - Small ",
    productPrice: "4",
    productSupplier: "BCS SHOP",
    searchText: "ilish elish elis ilis ইলিশ ",
    sortOrder: "a",
    sourceSupplier: "TERRY TRADING CO PTE LTD",
    supplierContactName: "arif",
    supplierContactPhone: "84124637",
    unit: "1 PC",
    updateDateTime: "03/08/2020 05:23:58",
    count: 169
  },
  {
    category: "COOKING OIL INGREDIENTS",
    isPopular: "YES",
    key: "-M9aX0eXXs2r-3O7c1OV",
    photos: [
      {
        imageName: "0a4ef8a0-f7cf-11ea-9ca4-275d4c37dc1b.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F0a4ef8a0-f7cf-11ea-9ca4-275d4c37dc1b.jpg?alt=media&token=a0cd1cab-f6c4-43c4-85eb-64e1773c957a"
      }
    ],
    productNameEnglish: "PRAN MUSTARD SEEDS OIL ",
    productPrice: "2.60 ",
    productSupplier: "BCS SHOP",
    searchText: "সরিষার তেল ",
    sortOrder: "d",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "250ml",
    updateDateTime: "Wed 16-09-20 11:45 am",
    count: 160
  },
  {
    category: "MEAT FISH",
    isPopular: "YES",
    key: "-M9a3auhPEiHX8_zYJ8T",
    photos: [
      {
        imageName: "c22b5180-afbd-11ea-a37e-bd24eb8f726f.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fc22b5180-afbd-11ea-a37e-bd24eb8f726f.jpg?alt=media&token=e57daca0-c1dd-4eff-acfa-416ea81009ce"
      }
    ],
    productNameEnglish: "Chicken wings ",
    productPrice: "5",
    productSupplier: "BCS SHOP",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1kg ",
    updateDateTime: "04/07/2020 09:29:39",
    count: 148
  },
  {
    category: "SNACKS DRY FOOD",
    isPopular: "YES",
    key: "-M9aaXMmcESUiLyIFlYy",
    photos: [
      {
        imageName: "5abc8280-ddee-11ea-a50a-71ea37251d72.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F5abc8280-ddee-11ea-a50a-71ea37251d72.jpg?alt=media&token=6b453a6d-88da-433e-b338-508941e8076a"
      }
    ],
    productNameEnglish: "DRY CAKE pran",
    productPrice: "2.80",
    productSupplier: "BCS SHOP",
    sortOrder: "d",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1 pkt 350g",
    updateDateTime: "Fri 14-08-20 1:24 pm",
    count: 146
  },
  {
    availability: "AVAILABLE",
    category: "TUPPERWARE CONTAINER",
    isPopular: "YES",
    key: "-M9a0sA0Y0KbX1e3hP5d",
    photos: [
      {
        imageName: "70c59220-e8f1-11ea-b634-e7e7c4cb042d.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F70c59220-e8f1-11ea-b634-e7e7c4cb042d.jpg?alt=media&token=abcd4376-9b86-4528-91b2-fec809d6969d"
      }
    ],
    productNameEnglish: "Curry Plastic String Bag",
    productPrice: "0.70",
    productSupplier: "BCS SHOP",
    searchText: "কারী পেপার কারি ব্যাগ ",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1 roll ",
    updateDateTime: "Fri 28-08-20 1:43 pm",
    count: 139
  },
  {
    availability: "AVAILABLE",
    category: "MEAT FISH",
    isPopular: "YES",
    key: "-M9Y_GalhAf1EZpTmHm_",
    photos: [
      {
        imageName: "4cd98e20-afbc-11ea-a37e-bd24eb8f726f.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F4cd98e20-afbc-11ea-a37e-bd24eb8f726f.jpg?alt=media&token=5d46c383-874d-448b-9321-1d4cb2e4bd48"
      }
    ],
    productNameEnglish: "Rui fish ",
    productPrice: "6.50",
    productSupplier: "BCS SHOP",
    searchText: "রুই মাছ ",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1kg",
    updateDateTime: "Tue 29-09-20 4:41 pm",
    count: 139
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    isPopular: "YES",
    key: "-M9a0LDvo6faRtgYPazt",
    photos: [
      {
        imageName: "7327d800-e8e4-11ea-b634-e7e7c4cb042d.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F7327d800-e8e4-11ea-b634-e7e7c4cb042d.jpg?alt=media&token=01659db6-d97f-4b29-877b-f2dc6a154c60"
      }
    ],
    productNameEnglish: "Salt ",
    productPrice: "1.40",
    productSupplier: "BCS SHOP",
    searchText: "লবণ লবন",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1kg",
    updateDateTime: "Fri 28-08-20 12:10 pm",
    count: 136
  },
  {
    availability: "AVAILABLE",
    category: "রান্না করা খাবার",
    key: "-MCR8fQQxxiYmMT6iqAp",
    photos: [
      {
        imageName: "91ea92d0-c811-11ea-99a6-3f4f89ed7cd9.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F91ea92d0-c811-11ea-99a6-3f4f89ed7cd9.jpg?alt=media&token=b933cde8-e062-4c09-b5df-24a8f3aa6838"
      }
    ],
    productNameEnglish:
      "কচু ভর্তা mashed taro - Delivery by taxi, pay as meter-fare. ",
    productPrice: "1",
    productSupplier: "BCS SHOP",
    sortOrder: "a",
    supplierContactName: "Ahmed Fayyaz",
    supplierContactPhone: "97861239",
    unit: "1 serving ",
    updateDateTime: "Tue 11-08-20 6:47 pm",
    count: 131
  },
  {
    author: "+6594562455",
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    isPopular: "YES",
    key: "-M9cNYNyXrvqE6nUaFKc",
    photos: [
      {
        imageName: "8eb5b060-aca3-11ea-b1f6-655d279c50ce.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F8eb5b060-aca3-11ea-b1f6-655d279c50ce.jpg?alt=media&token=b4c0576c-a46a-44ea-a20d-11cf008e982a"
      }
    ],
    productNameEnglish: "LIMES lemon",
    productPrice: "1.50",
    productSupplier: "BCS SHOP",
    searchText: "লেবু  কাগুজী ",
    sortOrder: "a",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "250gm",
    updateDateTime: "Sat 08-08-20 11:44 am",
    count: 130
  },
  {
    category: "COSMETICS",
    isPopular: "YES",
    key: "-M9bBN6Cns4Ya5sBUZvD",
    photos: [
      {
        imageName: "f96bfd60-e8da-11ea-b634-e7e7c4cb042d.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Ff96bfd60-e8da-11ea-b634-e7e7c4cb042d.jpg?alt=media&token=89db75f0-26ba-4dd0-a1d1-8a1edafaa6fb"
      }
    ],
    productNameEnglish: "Dettol soap",
    productPrice: "4",
    productSupplier: "BCS SHOP",
    searchText: "detol sop sabun",
    sortOrder: "75g",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "pack of 4 pcs",
    updateDateTime: "Fri 28-08-20 11:03 am",
    count: 129
  },
  {
    author: "+6594562455",
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    isPopular: "YES",
    key: "-M9YW2R7LfkaxZEJ6Ev5",
    photos: [
      {
        imageName: "115db770-c81e-11ea-99a6-3f4f89ed7cd9.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F115db770-c81e-11ea-99a6-3f4f89ed7cd9.jpg?alt=media&token=4fa3df14-1c00-44e4-bd8e-31b4340d72e4"
      }
    ],
    productNameEnglish: "Onion ",
    productPrice: "2.00",
    productSupplier: "BCS SHOP",
    searchText: "onion piaz piaj পেঁয়াজ পেয়াজ",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1kg ",
    updateDateTime: "Fri 07-08-20 8:27 pm",
    count: 122
  },
  {
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    isPopular: "YES",
    key: "-M9Y-M8Psr7VBfwBi9uI",
    photos: [
      {
        imageName: "b7c3abb0-abd1-11ea-b76c-0b360dd92c32.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fb7c3abb0-abd1-11ea-b76c-0b360dd92c32.jpg?alt=media&token=3243ad4c-9c84-4933-affc-1397c26316c9"
      }
    ],
    productNameEnglish: "Cauliflower ",
    productPrice: "5",
    productSupplier: "BCS SHOP",
    searchText: "ফুলকপি ",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1kg ",
    updateDateTime: "08/07/2020 06:07:38",
    count: 122
  },
  {
    availability: "AVAILABLE",
    category: "SNACKS DRY FOOD",
    isPopular: "YES",
    key: "-MA-jxAY58AOBdeov11V",
    photos: [
      {
        imageName: "49158100-b05b-11ea-8357-d5a4954c59fc.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F49158100-b05b-11ea-8357-d5a4954c59fc.jpg?alt=media&token=e3a9b308-dd01-4615-88c2-df10f1c61547"
      }
    ],
    productNameEnglish: "PRAN Hot Chanachur ",
    productPrice: "0.90",
    productSupplier: "BCS SHOP",
    searchText: "চানাচুর ",
    sortOrder: "a",
    sourceSupplier: "KHAN PRODUCTS PTE LTD.",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "150G",
    updateDateTime: "03/08/2020 04:42:40",
    count: 118
  },
  {
    availability: "AVAILABLE",
    category: "রান্না করা খাবার",
    key: "-MCQxdBRu9m2vsPCNd7-",
    photos: [
      {
        imageName: "f99a1bb0-d6e6-11ea-8976-95d75731af67.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ff99a1bb0-d6e6-11ea-8976-95d75731af67.jpg?alt=media&token=2b4864ff-386d-4517-b542-dc96ab9531ef"
      }
    ],
    productNameEnglish:
      "খাসির বিরানী স্পেশাল Mutton Briyani - Delivery by taxi, pay as meter-fare. ",
    productPrice: "7",
    productSupplier: "BCS SHOP",
    sortOrder: "a",
    supplierContactName: "Ahmed Fayyaz",
    supplierContactPhone: "97861239",
    unit: "1 serving ",
    updateDateTime: "Tue 11-08-20 6:43 pm",
    count: 117
  },
  {
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    isPopular: "YES",
    key: "-MBEKS4n6InBM-7Pyuqh",
    photos: [
      {
        imageName: "1192dc50-bc59-11ea-b7df-33e703b87300.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F1192dc50-bc59-11ea-b7df-33e703b87300.jpg?alt=media&token=3559c821-d04d-4d69-b4a0-7887d7e74fe6"
      }
    ],
    productNameEnglish: "Green Grapes ",
    productPrice: "4.50",
    productSupplier: "BCS SHOP",
    searchText: "আঙ্গুর আঙুর ",
    sortOrder: "a",
    supplierContactName: "Ahmed Fayyaz",
    supplierContactPhone: "97861239",
    unit: "500gm",
    updateDateTime: "Mon 21-09-20 3:37 pm",
    count: 116
  },
  {
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    isPopular: "YES",
    key: "-M9YGnHxxGqnARPsRDxa",
    photos: [
      {
        imageName: "b8ea5860-f733-11ea-885a-2b4d96b2f26b.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Fb8ea5860-f733-11ea-885a-2b4d96b2f26b.jpg?alt=media&token=4a9b442e-13e4-426c-8f7d-b075c2d45a3e"
      }
    ],
    productNameEnglish: "bitter melon ",
    productPrice: "5",
    productSupplier: "BCS SHOP",
    searchText: "করল্লা ",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1kg",
    updateDateTime: "Fri 18-09-20 6:22 pm",
    count: 105
  },
  {
    availability: "AVAILABLE",
    category: "SNACKS DRY FOOD",
    isPopular: "YES",
    key: "-M9aVAEroX6hfNMnZlj6",
    photos: [
      {
        imageName: "f60ff850-ac59-11ea-bbe4-619ccaa778ae.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ff60ff850-ac59-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=6c8fb7e5-3e4f-4055-a03f-840ad423c18b"
      }
    ],
    productNameEnglish: "RAISINS ",
    productPrice: "2 ",
    productSupplier: "BCS SHOP",
    searchText: "maiwa কিচমিচ ",
    sortOrder: "a",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "150gms",
    updateDateTime: "23/07/2020 12:45:56",
    count: 104
  },
  {
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    isPopular: "YES",
    key: "-M9YEMBOnzZygQ5XCB9U",
    photos: [
      {
        imageName: "a7a8cfe0-abda-11ea-8036-6322e2b6fd90.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fa7a8cfe0-abda-11ea-8036-6322e2b6fd90.jpg?alt=media&token=ea2fe2d9-04bd-45fd-99b1-9933f95d19de"
      }
    ],
    productNameEnglish: "calabash ",
    productPrice: "2",
    productSupplier: "BCS SHOP",
    searchText: "লাউ ",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1kg",
    updateDateTime: "17/07/2020 08:32:47",
    count: 100
  },
  {
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    isPopular: "YES",
    key: "-MA4MUO3ordS6KdiUfku",
    photos: [
      {
        imageName: "47866d60-bf81-11ea-85e3-735b22b1a0db.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F47866d60-bf81-11ea-85e3-735b22b1a0db.jpg?alt=media&token=bf2dc684-71aa-4ea2-8d3f-af91965453b6"
      }
    ],
    productNameEnglish: "Shim Bean",
    productPrice: "6.50",
    productSupplier: "BCS SHOP",
    searchText: "শিম ছিম  sim shim seem ",
    sortOrder: "a",
    sourceSupplier: "Amman trading ",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1KG",
    updateDateTime: "03/08/2020 04:26:35",
    count: 100
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    isPopular: "YES",
    key: "-M9aS4IY6quwHYKAvjXX",
    photos: [
      {
        imageName: "03b4edf0-ac58-11ea-bbe4-619ccaa778ae.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F03b4edf0-ac58-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=0859059e-6ed2-4914-b8ea-9d5354cb1a40"
      }
    ],
    productNameEnglish: "GARAM MASALA",
    productPrice: "3.70",
    productSupplier: "BCS SHOP",
    searchText: "গরম মসলা ",
    sortOrder: "a",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1pkt",
    updateDateTime: "17/07/2020 07:51:43",
    count: 99
  },
  {
    availability: "AVAILABLE",
    category: "রান্না করা খাবার",
    key: "-MCXB9pCvM1-zyyx3mEz",
    photos: [
      {
        imageName: "9fb805e0-c8fd-11ea-91d6-d9d33e68425f.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F9fb805e0-c8fd-11ea-91d6-d9d33e68425f.jpg?alt=media&token=d934f38a-071b-4e1e-b3c2-49a8a227fa38"
      }
    ],
    productNameEnglish:
      "ভাত white rice - Delivery by taxi, pay as meter-fare. ",
    productPrice: "1",
    productSupplier: "BCS SHOP",
    sortOrder: "a",
    supplierContactName: "Kabir",
    supplierContactPhone: "94562455",
    unit: "1 Serving",
    updateDateTime: "Tue 11-08-20 6:44 pm",
    count: 98
  },
  {
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    key: "-M9b0j9_hMaT1Csp0yn-",
    photos: [
      {
        imageName: "097e8f90-f89b-11ea-aaa8-a9cfb87a7f3a.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F097e8f90-f89b-11ea-aaa8-a9cfb87a7f3a.jpg?alt=media&token=376cd4db-cf71-4542-b4d0-5bcd941bce01"
      }
    ],
    productNameEnglish: "ROYAL APPLE",
    productPrice: "3 ",
    productSupplier: "BCS SHOP",
    searchText: "আপেল ",
    sortOrder: "d",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "5pcs",
    updateDateTime: "Thu 17-09-20 12:05 pm",
    count: 97
  },
  {
    availability: "AVAILABLE",
    category: "DRINKS DESSERT",
    isPopular: "YES",
    key: "-M9acdO504KEU3NWLjzn",
    photos: [
      {
        imageName: "098170d0-ac5f-11ea-bbe4-619ccaa778ae.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F098170d0-ac5f-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=898f30fa-1c3b-4c88-9319-cc14e2c84f7d"
      }
    ],
    productNameEnglish: "SUGAR",
    productPrice: "1.50",
    productSupplier: "BCS SHOP",
    searchText: "চিনি  ",
    sortOrder: "a",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1Kg Packet",
    updateDateTime: "17/07/2020 07:32:49",
    count: 96
  },
  {
    availability: "AVAILABLE",
    category: "COSMETICS",
    isPopular: "YES",
    key: "-M9bU3WAyP6vNO30iLZ4",
    photos: [
      {
        imageName: "636ef970-ac80-11ea-9b70-29a530f3e931.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F636ef970-ac80-11ea-9b70-29a530f3e931.jpg?alt=media&token=c6cc4818-e3dd-490b-b005-01bff27b3f65"
      }
    ],
    productNameEnglish: "Gilette blade",
    productPrice: "1.20",
    productSupplier: "BCS SHOP",
    searchText: "ব্লেড",
    sortOrder: "x",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1 Pkt",
    updateDateTime: "17/07/2020 03:08:41",
    count: 93
  },
  {
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    isPopular: "YES",
    key: "-M9Y-cMWFKAa3SBkMufK",
    photos: [
      {
        imageName: "cce05570-abd1-11ea-b76c-0b360dd92c32.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fcce05570-abd1-11ea-b76c-0b360dd92c32.jpg?alt=media&token=cde2016d-51b6-4050-bff9-067a501c3d7e"
      }
    ],
    productNameEnglish: "Cabbage ",
    productPrice: "3.5",
    productSupplier: "BCS SHOP",
    searchText: "বাধাকপি পাতাকপি ",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1kg",
    updateDateTime: "08/07/2020 06:08:21",
    count: 93
  },
  {
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    isPopular: "YES",
    key: "-M9YSL-0prcztEj2MH5X",
    photos: [
      {
        imageName: "ff7c0d60-abe2-11ea-99a0-ada8a2be9f1b.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fff7c0d60-abe2-11ea-99a0-ada8a2be9f1b.jpg?alt=media&token=a59b7fe6-4135-4487-b3b1-a1ad75bf4d6d"
      }
    ],
    productNameEnglish: "Broccoli ",
    productPrice: "5.5",
    productSupplier: "BCS SHOP",
    searchText: "ব্রকোলি ",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1kg",
    updateDateTime: "Wed 02-12-20 10:21 am",
    count: 91
  },
  {
    author: "+6594562455",
    availability: "AVAILABLE",
    category: "MEAT FISH",
    isPopular: "YES",
    key: "-M9YYZThoI3vTcDmU6d5",
    photos: [
      {
        imageName: "efae5970-abe6-11ea-99a0-ada8a2be9f1b.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fefae5970-abe6-11ea-99a0-ada8a2be9f1b.jpg?alt=media&token=e19b59dd-8ca4-4349-9716-82d1369e98c7"
      },
      {
        imageName: "68b0df30-d3fd-11ea-a0e0-7d366b7a98ae.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F68b0df30-d3fd-11ea-a0e0-7d366b7a98ae.jpg?alt=media&token=4e1c3011-50be-46f0-ab15-5d380e0cb817"
      }
    ],
    productNameEnglish: "Chicken",
    productPrice: "6",
    productSupplier: "BCS SHOP",
    searchText: "মুরগি মুরগী ",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1.5kg ",
    updateDateTime: "01/08/2020 09:48:25",
    count: 91
  },
  {
    availability: "AVAILABLE",
    category: "রান্না করা খাবার",
    key: "-MCQxtNNMYXBX8xmTm7x",
    photos: [
      {
        imageName: "8346f870-d6e6-11ea-8976-95d75731af67.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F8346f870-d6e6-11ea-8976-95d75731af67.jpg?alt=media&token=157e0fa3-00d5-4548-af23-9575bbac25a6"
      }
    ],
    productNameEnglish:
      "খাসির খিচুরি স্পেশাল  mutton khichuri - Delivery by taxi, pay as meter-fare. ",
    productPrice: "7",
    productSupplier: "BCS SHOP",
    sortOrder: "a",
    supplierContactName: "Ahmed Fayyaz",
    supplierContactPhone: "97861239",
    unit: "1 serving ",
    updateDateTime: "Tue 11-08-20 6:42 pm",
    count: 90
  },
  {
    availability: "AVAILABLE",
    category: "TOILETRIES",
    photos: [
      {
        imageName: "1df0eb10-e67d-11ea-9786-7f7137f3f585.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F1df0eb10-e67d-11ea-9786-7f7137f3f585.jpg?alt=media&token=16b83173-3df0-4d56-a3b8-9911c72dd3e8"
      }
    ],
    productNameEnglish: "Mama detergent powder",
    productPrice: "2.50",
    productSupplier: "BCS SHOP",
    searchText: "Detergrnt powder",
    sortOrder: "a",
    supplierContactName: "Ismita",
    supplierContactPhone: "userMobile",
    unit: "1kg",
    updateDateTime: "Tue 25-08-20 10:46 am",
    key: "-MFYVeAeF1eu5WHENFbn",
    count: 89
  },
  {
    availability: "AVAILABLE",
    category: "রান্না করা খাবার",
    key: "-MCR0bUOwveXN1jXgscq",
    photos: [
      {
        imageName: "a4472470-c80c-11ea-99a6-3f4f89ed7cd9.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fa4472470-c80c-11ea-99a6-3f4f89ed7cd9.jpg?alt=media&token=75f78750-428d-49c2-8bd8-1c13989818a1"
      }
    ],
    productNameEnglish: "শাক spinach - Delivery by taxi, pay as meter-fare. ",
    productPrice: "1",
    productSupplier: "BCS SHOP",
    searchText: "",
    sortOrder: "a",
    supplierContactName: "Ahmed Fayyaz",
    supplierContactPhone: "97861239",
    unit: "1 serving ",
    updateDateTime: "Tue 11-08-20 6:48 pm",
    count: 88
  },
  {
    availability: "AVAILABLE",
    category: "RICE DAAL NOODLES",
    isPopular: "YES",
    key: "-M9_z0n6fZMwZEkO3MGg",
    photos: [
      {
        imageName: "aedfe0d0-ac45-11ea-ba1a-4bcfa8bf5006.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Faedfe0d0-ac45-11ea-ba1a-4bcfa8bf5006.jpg?alt=media&token=06c9af4c-2dc9-4c0f-a22f-eff214fdf9aa"
      }
    ],
    productNameEnglish: "Rice Kali jera  ",
    productPrice: "5",
    productSupplier: "BCS SHOP",
    searchText: "Kalojeera Rice zira কালো জিরা চাউল ",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1kg",
    updateDateTime: "23/07/2020 12:58:15",
    count: 88
  },
  {
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    isPopular: "YES",
    key: "-MA4Nz1M4RpvVw3tSrQR",
    photos: [
      {
        imageName: "61b7ff00-bdb5-11ea-8ba8-ddb60ef370d4.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F61b7ff00-bdb5-11ea-8ba8-ddb60ef370d4.jpg?alt=media&token=a5464231-fb92-483c-b9f6-c46abc99578d"
      }
    ],
    productNameEnglish: "Pointed Gourd",
    productPrice: "6",
    productSupplier: "BCS SHOP",
    searchText: "potol ",
    sortOrder: "a",
    sourceSupplier: "Amman trading ",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1kg",
    updateDateTime: "03/08/2020 04:25:09",
    count: 87
  },
  {
    availability: "AVAILABLE",
    category: "রান্না করা খাবার",
    key: "-MCQrmhygF7gQa3IavNv",
    photos: [
      {
        imageName: "c7335310-c806-11ea-99a6-3f4f89ed7cd9.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fc7335310-c806-11ea-99a6-3f4f89ed7cd9.jpg?alt=media&token=74f1c1e7-50d6-404a-b62f-f781706b6a25"
      }
    ],
    productNameEnglish:
      "গরুর মাংস  Beef Curry - Delivery by taxi, pay as meter-fare. ",
    productPrice: "5",
    productSupplier: "BCS SHOP",
    sortOrder: "a",
    supplierContactName: "Ahmed Fayyaz",
    supplierContactPhone: "97861239",
    unit: "1 serving ",
    updateDateTime: "Tue 11-08-20 6:48 pm",
    count: 86
  },
  {
    availability: "AVAILABLE",
    category: "রান্না করা খাবার",
    key: "-MCWkR6NjvZA27TfckdU",
    photos: [
      {
        imageName: "a9bc04d0-c8ec-11ea-91d6-d9d33e68425f.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fa9bc04d0-c8ec-11ea-91d6-d9d33e68425f.jpg?alt=media&token=29e2b7b3-d972-4465-add1-89c066ce3cd9"
      }
    ],
    productNameEnglish:
      "ইলিশ মাছ ilish fish curry - Delivery by taxi, pay as meter-fare. ",
    productPrice: "5",
    productSupplier: "BCS SHOP",
    sortOrder: "a",
    supplierContactName: "Kabir",
    supplierContactPhone: "94562455",
    unit: "1 serving ",
    updateDateTime: "Tue 11-08-20 6:45 pm",
    count: 86
  },
  {
    availability: "AVAILABLE",
    category: "DRINKS DESSERT",
    isPopular: "YES",
    key: "-M9adMyGbl5sEoSO32-G",
    photos: [
      {
        imageName: "fa049c20-c826-11ea-99a6-3f4f89ed7cd9.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ffa049c20-c826-11ea-99a6-3f4f89ed7cd9.jpg?alt=media&token=422a5305-33a0-4c49-b19b-91e1e0c87417"
      }
    ],
    productNameEnglish: "SHEMAI",
    productPrice: "1",
    productSupplier: "BCS SHOP",
    searchText: "সেমাই ",
    sortOrder: "a",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1 pkt",
    updateDateTime: "17/07/2020 08:13:56",
    count: 86
  },
  {
    availability: "AVAILABLE",
    category: "SNACKS DRY FOOD",
    key: "-MEfelSS4pQkEVJ_ds8w",
    photos: [
      {
        imageName: "e38b6c40-ddf6-11ea-a50a-71ea37251d72.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Fe38b6c40-ddf6-11ea-a50a-71ea37251d72.jpg?alt=media&token=f8ddf301-b918-4469-adbb-c692e52ea8ac"
      }
    ],
    productNameEnglish: "sweet toast pran",
    productPrice: "2.00",
    productSupplier: "BCS SHOP",
    searchText: "toast ",
    sortOrder: "a",
    supplierContactName: "Ismita",
    supplierContactPhone: "userMobile",
    unit: "1 pkt 350g",
    updateDateTime: "Fri 14-08-20 4:15 pm",
    count: 86
  },
  {
    availability: "AVAILABLE",
    category: "OTHERS",
    photos: [
      {
        imageName: "7171a1a0-0200-11eb-a8a9-31b609c2f968.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F7171a1a0-0200-11eb-a8a9-31b609c2f968.jpg?alt=media&token=ca50bf2e-b0f7-4dca-a51a-54b63e0437c8"
      }
    ],
    productNameEnglish: "Socks",
    productPrice: "2",
    productSupplier: "BCS SHOP",
    searchText: "মুজা",
    sortOrder: "a",
    supplierContactName: "Ismita",
    supplierContactPhone: "userMobile",
    unit: "3 pcs",
    updateDateTime: "Tue 29-09-20 11:04 am",
    key: "-MIMoLyFOfruboBr4c6b",
    count: 84
  },
  {
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    isPopular: "YES",
    key: "-MA4MzYjKNqu56ROR_7d",
    photos: [
      {
        imageName: "962ee5f0-bdce-11ea-8ba8-ddb60ef370d4.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F962ee5f0-bdce-11ea-8ba8-ddb60ef370d4.jpg?alt=media&token=718ad6e5-d580-4ee0-9965-7aaee126ac23"
      }
    ],
    productNameEnglish: "Taro Root ",
    productPrice: "6",
    productSupplier: "BCS SHOP",
    searchText: "kochu kacha kacho কচু কচুর ছরা ",
    sortOrder: "a",
    sourceSupplier: "Veg mart ",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1kg",
    updateDateTime: "03/08/2020 04:25:58",
    count: 83
  },
  {
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    isPopular: "YES",
    key: "-M9Y1KPJE0XuOLGxP41o",
    photos: [
      {
        imageName: "ea6810e0-c104-11ea-8470-83fbeadd4a74.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fea6810e0-c104-11ea-8470-83fbeadd4a74.jpg?alt=media&token=393c1c30-82f6-40e0-a6d2-e52d0ca425ad"
      }
    ],
    productNameEnglish: "Ladyfinger  ",
    productPrice: "5",
    productSupplier: "BCS SHOP",
    searchText: "ঢেঁড়শ ঢেঁড়স ",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1kg",
    updateDateTime: "08/07/2020 06:22:27",
    count: 82
  },
  {
    availability: "AVAILABLE",
    category: "TUPPERWARE CONTAINER",
    isPopular: "YES",
    key: "-M9YWPKH6wupC6XKrA8-",
    photos: [
      {
        imageName: "97fbbf20-abe5-11ea-99a0-ada8a2be9f1b.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F97fbbf20-abe5-11ea-99a0-ada8a2be9f1b.jpg?alt=media&token=26ed90f0-9141-4123-ba6c-745d89b1bf9b"
      }
    ],
    productNameEnglish: "Makan paper ",
    productPrice: "3.90",
    productSupplier: "BCS SHOP",
    searchText: "মাকান পেপার ভাতের প্যাকেট ",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1 packet ",
    updateDateTime: "17/07/2020 08:42:43",
    count: 81
  },
  {
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    isPopular: "YES",
    key: "-MA0HZHWnF1HIYhUqzL8",
    photos: [
      {
        imageName: "4b63d840-bc58-11ea-b7df-33e703b87300.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F4b63d840-bc58-11ea-b7df-33e703b87300.jpg?alt=media&token=a8a0acab-0394-4137-b528-fcb07dfc9e02"
      }
    ],
    productNameEnglish: "Red Grapes",
    productPrice: "4.50",
    productSupplier: "BCS SHOP",
    searchText: "লাল আঙ্গুর ",
    sortOrder: "a",
    sourceSupplier: "Sheng siong ",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "500gm",
    updateDateTime: "Mon 21-09-20 3:38 pm",
    count: 80
  },
  {
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    isPopular: "YES",
    key: "-M9XzO90h7UOuD09Pl9g",
    photos: [
      {
        imageName: "e2db46b0-abd0-11ea-b76c-0b360dd92c32.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fe2db46b0-abd0-11ea-b76c-0b360dd92c32.jpg?alt=media&token=45d6c7fe-894e-4782-ad44-5339cac68c34"
      }
    ],
    productNameEnglish: "Potato ",
    productPrice: "2",
    productSupplier: "BCS SHOP",
    searchText: "আলু ",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1kg",
    updateDateTime: "08/07/2020 06:05:20",
    count: 79
  },
  {
    availability: "AVAILABLE",
    category: "PICKLES",
    isPopular: "YES",
    key: "-M9aWOR41HDGXQM1UaW-",
    photos: [
      {
        imageName: "ea186f50-ac81-11ea-b4b2-63d9e39acaf7.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fea186f50-ac81-11ea-b4b2-63d9e39acaf7.jpg?alt=media&token=a589dc38-cee4-4faf-9603-1d54438c10b9"
      }
    ],
    productNameEnglish: "PRAN MANGO PICKLE",
    productPrice: " 3.2",
    productSupplier: "BCS SHOP",
    searchText: "আমের আচার",
    sortOrder: "a",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1 btl",
    updateDateTime: "17/07/2020 07:38:49",
    count: 77
  },
  {
    category: "DRINKS DESSERT",
    key: "-M9g56tFxoB1fRkZZD9F",
    photos: [
      {
        imageName: "8f622520-ad34-11ea-9a01-db9ea96fa329.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F8f622520-ad34-11ea-9a01-db9ea96fa329.jpg?alt=media&token=1fc71b99-2a2c-426f-bdb0-2b359fdcbf25"
      }
    ],
    productNameEnglish: "NESCAFE ORIGINAL 3 IN 1 INSTANT COFFEE",
    productPrice: "7.50",
    productSupplier: "BCS SHOP",
    sortOrder: "d",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "35 per pack",
    updateDateTime: "04/07/2020 11:24:20",
    count: 77
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    isPopular: "YES",
    key: "-M9aRdZyiIAso0X611a2",
    photos: [
      {
        imageName: "b8db3f50-ac57-11ea-bbe4-619ccaa778ae.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fb8db3f50-ac57-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=f869a70e-0bf3-4b27-80d6-cf9145ff45c1"
      }
    ],
    productNameEnglish: "CINNAMON ",
    productPrice: "2",
    productSupplier: "BCS SHOP",
    searchText: "দারুচিনি",
    sortOrder: "q",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1 pkt",
    updateDateTime: "23/07/2020 12:52:38",
    count: 73
  },
  {
    author: "+6589050302",
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    isPopular: "YES",
    key: "-MA4VexMK1sATknlT1Hj",
    photos: [
      {
        imageName: "736eba60-bc55-11ea-b7df-33e703b87300.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F736eba60-bc55-11ea-b7df-33e703b87300.jpg?alt=media&token=c5088de9-6c92-4b31-bc7c-9191b79f2bac"
      }
    ],
    productNameEnglish: "Red Spinach",
    productPrice: "3.20",
    productSupplier: "BCS SHOP",
    searchText: "lal shak sak লাল শাক সবজি সব্জি ",
    sortOrder: "a",
    sourceSupplier: "Veg mart ",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1kg",
    updateDateTime: "Tue 18-08-20 10:52 am",
    count: 73
  },
  {
    availability: "AVAILABLE",
    category: "PICKLES",
    isPopular: "YES",
    key: "-M9aW7edgmjmeVJGuQDg",
    photos: [
      {
        imageName: "906b0bb0-ac5a-11ea-bbe4-619ccaa778ae.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F906b0bb0-ac5a-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=0d5ccf96-888e-4839-9527-6ee38c6b6752"
      }
    ],
    productNameEnglish: "PRAN OLIVE PICKLE",
    productPrice: "3.20",
    productSupplier: "BCS SHOP",
    searchText: "জলপাইর আচার",
    sortOrder: "a",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1 btl",
    updateDateTime: "17/07/2020 07:38:26",
    count: 73
  },
  {
    availability: "AVAILABLE",
    category: "DRINKS DESSERT",
    isPopular: "YES",
    key: "-M9abIGxJKlE1oLFhixj",
    photos: [
      {
        imageName: "4e108430-ac5e-11ea-bbe4-619ccaa778ae.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F4e108430-ac5e-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=5153f384-472c-4c7e-8d5d-65c8f3afa2ca"
      }
    ],
    productNameEnglish: "ISABGOL",
    productPrice: "2.80 ",
    productSupplier: "BCS SHOP",
    searchText: "ইছবগুল",
    sortOrder: "d",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1 pkt small",
    updateDateTime: "17/07/2020 08:49:03",
    count: 71
  },
  {
    author: "+6589050302",
    category: "DRINKS DESSERT",
    isPopular: "YES",
    key: "-M9gIBXZJGdkFxuAn3mh",
    photos: [
      {
        imageName: "886561d0-ad3c-11ea-9a01-db9ea96fa329.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F886561d0-ad3c-11ea-9a01-db9ea96fa329.jpg?alt=media&token=3ab8b277-a7bf-41c9-960f-4cb0f1cb7394"
      }
    ],
    productNameEnglish: "SPRITE",
    productPrice: "2.50",
    productSupplier: "BCS SHOP",
    sortOrder: "a",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1.5L",
    updateDateTime: "11/07/2020 07:19:01",
    count: 69
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    isPopular: "YES",
    key: "-M9acBvzo_FyEcT4Sy6f",
    photos: [
      {
        imageName: "ca7b4140-ac5e-11ea-bbe4-619ccaa778ae.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fca7b4140-ac5e-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=4e0e8eed-939d-434c-8934-3e09de7f84a0"
      }
    ],
    productNameEnglish: "GHEE",
    productPrice: "3.80 ",
    productSupplier: "BCS SHOP",
    searchText: "ঘি ",
    sortOrder: "a",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "100gms",
    updateDateTime: "17/07/2020 07:11:57",
    count: 69
  },
  {
    availability: "AVAILABLE",
    category: "রান্না করা খাবার",
    key: "-MCyaRbCwGD5sQknunF3",
    photos: [
      {
        imageName: "6cd1f460-cd53-11ea-9688-f37030ef31de.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F6cd1f460-cd53-11ea-9688-f37030ef31de.jpg?alt=media&token=b0631769-f9ff-4fef-989f-41b57c970c2f"
      }
    ],
    productNameEnglish: "করলা ভাজী - Delivery by taxi, pay as meter-fare. ",
    productPrice: "1",
    productSupplier: "BCS SHOP",
    sortOrder: "g",
    supplierContactName: "Ahmed Fayyaz",
    supplierContactPhone: "97861239",
    unit: "1 serving",
    updateDateTime: "Tue 11-08-20 6:44 pm",
    count: 68
  },
  {
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    key: "-M9azGy9V0WyqpXj0Fnx",
    photos: [
      {
        imageName: "598c4b40-f89a-11ea-aaa8-a9cfb87a7f3a.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F598c4b40-f89a-11ea-aaa8-a9cfb87a7f3a.jpg?alt=media&token=24f5c465-1f6c-436a-8cb0-abe73572625b"
      }
    ],
    productNameEnglish: "PINEAPPLE ",
    productPrice: "2",
    productSupplier: "BCS SHOP",
    searchText: "আনারস ",
    sortOrder: "d",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1 pc",
    updateDateTime: "Thu 17-09-20 12:00 pm",
    count: 68
  },
  {
    availability: "AVAILABLE",
    category: "MEAT FISH",
    isPopular: "YES",
    key: "-M9zxNO5xPdfu9fs1xXG",
    photos: [
      {
        imageName: "28148060-b03c-11ea-9737-25db4b55bc7b.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F28148060-b03c-11ea-9737-25db4b55bc7b.jpg?alt=media&token=b78474e7-b834-42be-8761-59103a522186"
      }
    ],
    productNameEnglish: "Rohu Fish",
    productPrice: "5.50",
    productSupplier: "BCS SHOP",
    searchText: "রুই মাছ ",
    sortOrder: "a",
    sourceSupplier: "AYSHA SUPERMARKET PTE LTD",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1KG",
    updateDateTime: "03/08/2020 05:19:02",
    count: 68
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    isPopular: "YES",
    key: "-M9aQxDONOGmx6jfGsIZ",
    photos: [
      {
        imageName: "62e5aa00-f7d3-11ea-9ca4-275d4c37dc1b.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F62e5aa00-f7d3-11ea-9ca4-275d4c37dc1b.jpg?alt=media&token=f59c35ed-827b-4519-8f99-9a89a34bbb90"
      }
    ],
    productNameEnglish: "DRY CHILLI ",
    productPrice: "1.50",
    productSupplier: "BCS SHOP",
    searchText: "শুকনা মরিচ লাল মরিচ ",
    sortOrder: "a",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1 pkt",
    updateDateTime: "Wed 16-09-20 12:16 pm",
    count: 68
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    isPopular: "YES",
    key: "-M9aPVOkQxrHnTECKuuC",
    photos: [
      {
        imageName: "da671460-de06-11ea-a50a-71ea37251d72.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Fda671460-de06-11ea-a50a-71ea37251d72.jpg?alt=media&token=f5a3c8c0-fcc1-4da3-a7ee-be044efff30e"
      }
    ],
    productNameEnglish: "DC CUMIN POWDER ",
    productPrice: "3.80",
    productSupplier: "BCS SHOP",
    searchText: "জিরার গুঁড়া পাউডার ",
    sortOrder: "a",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1 btl 200g",
    updateDateTime: "Fri 14-08-20 4:20 pm",
    count: 66
  },
  {
    availability: "AVAILABLE",
    category: "MEAT FISH",
    isPopular: "YES",
    key: "-M9aa9kk1vImV8YpWvXX",
    photos: [
      {
        imageName: "575f2290-ac5d-11ea-a00d-954b17f61eb9.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F575f2290-ac5d-11ea-a00d-954b17f61eb9.jpg?alt=media&token=48cef136-ff9c-468a-945c-3a86b315c180"
      }
    ],
    productNameEnglish: "Olive bard ",
    productPrice: "5.5",
    productSupplier: "BCS SHOP",
    searchText: "মাছ ",
    sortOrder: "d",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1kg",
    updateDateTime: "17/07/2020 07:36:39",
    count: 66
  },
  {
    availability: "AVAILABLE",
    category: "SNACKS DRY FOOD",
    isPopular: "YES",
    key: "-MA-kPUXlw_fuYi26H_Z",
    photos: [
      {
        imageName: "7ae9a1b0-bb79-11ea-9bec-f98d55a4d196.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F7ae9a1b0-bb79-11ea-9bec-f98d55a4d196.jpg?alt=media&token=07e55a5f-06fe-4b12-8cf2-52100c798bac"
      }
    ],
    productNameEnglish: "PRAN Hot Chanachur - Bombay Mix",
    productPrice: "2",
    productSupplier: "BCS SHOP",
    searchText: "চানাচুর ",
    sortOrder: "a",
    sourceSupplier: "RAJDHANI ENTERPRISE PTE LTD",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "300gm",
    updateDateTime: "03/08/2020 04:40:42",
    count: 65
  },
  {
    availability: "AVAILABLE",
    category: "EGGS DAIRY",
    isPopular: "YES",
    key: "-M9YV1R47lPAdYHNFpMi",
    photos: [
      {
        imageName: "ceed5840-f898-11ea-aaa8-a9cfb87a7f3a.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Fceed5840-f898-11ea-aaa8-a9cfb87a7f3a.jpg?alt=media&token=e54b879e-b9c1-451e-9290-c805bc6c07a5"
      }
    ],
    productNameEnglish: "Egg ",
    productPrice: "2.80",
    productSupplier: "BCS SHOP",
    searchText: "ডিম ",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "10pcs",
    updateDateTime: "Thu 17-09-20 11:49 am",
    count: 64
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    isPopular: "YES",
    key: "-M9aRBklNAIDF9JOcKsC",
    photos: [
      {
        imageName: "55b9f160-f738-11ea-885a-2b4d96b2f26b.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F55b9f160-f738-11ea-885a-2b4d96b2f26b.jpg?alt=media&token=16644f6d-4e4a-4cca-a4a7-9502e87dca56"
      }
    ],
    productNameEnglish: "BAY LEAF",
    productPrice: "1.40",
    productSupplier: "BCS SHOP",
    searchText: "তেজ পাতা",
    sortOrder: "a",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1 pkt",
    updateDateTime: "Tue 15-09-20 5:47 pm",
    count: 64
  },
  {
    availability: "AVAILABLE",
    category: "রান্না করা খাবার",
    key: "-MCQu3407vHD39i2hP0P",
    photos: [
      {
        imageName: "2debe7b0-c808-11ea-99a6-3f4f89ed7cd9.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F2debe7b0-c808-11ea-99a6-3f4f89ed7cd9.jpg?alt=media&token=94f03c54-1eaa-4189-b193-07e206a6ef52"
      }
    ],
    productNameEnglish:
      "খাসির মাংস Mutton curry - Delivery by taxi, pay as meter-fare. ",
    productPrice: "5",
    productSupplier: "BCS SHOP",
    sortOrder: "a",
    supplierContactName: "Ahmed Fayyaz",
    supplierContactPhone: "97861239",
    unit: "1 serving",
    updateDateTime: "Tue 11-08-20 6:43 pm",
    count: 63
  },
  {
    author: "+6589050302",
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    isPopular: "YES",
    key: "-M9bFJPUfqMNttFWJLgM",
    photos: [
      {
        imageName: "63ca27e0-ac77-11ea-8ded-437354ec7423.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F63ca27e0-ac77-11ea-8ded-437354ec7423.jpg?alt=media&token=f6e057d7-8089-4ce0-9410-6a43081ccbe4"
      }
    ],
    productNameEnglish: "Vegetable oil",
    productPrice: "9.50",
    productSupplier: "BCS SHOP",
    searchText: "তেল তৈল ",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "5L Bottle",
    updateDateTime: "29/07/2020 02:40:39",
    count: 62
  },
  {
    availability: "AVAILABLE",
    category: "RICE DAAL NOODLES",
    isPopular: "YES",
    key: "-M9bEiKuAy12yg2CASFh",
    photos: [
      {
        imageName: "fe2216d0-b231-11ea-b6a3-23fbd917d0cb.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ffe2216d0-b231-11ea-b6a3-23fbd917d0cb.jpg?alt=media&token=6f51e17b-1284-472c-90f3-49df7ecd0d3f"
      }
    ],
    productNameEnglish: "Moong dhal lentils ",
    productPrice: "2.5",
    productSupplier: "BCS SHOP",
    searchText: "mug dal mog mong mag dhal ডাল",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "409gm",
    updateDateTime: "17/07/2020 08:55:42",
    count: 62
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    isPopular: "YES",
    key: "-M9bJ5RXMyXyUlmbf8WR",
    photos: [
      {
        imageName: "bdc954d0-ac79-11ea-90b2-195942e61adb.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fbdc954d0-ac79-11ea-90b2-195942e61adb.jpg?alt=media&token=02b0bb15-a44b-4c94-816e-2f64d4f63033"
      }
    ],
    productNameEnglish: "Vegetable oil",
    productPrice: "2.8",
    productSupplier: "BCS SHOP",
    searchText: "তেল তৈল",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1L Bottle",
    updateDateTime: "17/07/2020 03:13:04",
    count: 62
  },
  {
    category: "MEAT FISH",
    key: "-M9b6XWMW4dWuzwjBQDW",
    photos: [
      {
        imageName: "0e1f8f60-ac72-11ea-8ded-437354ec7423.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F0e1f8f60-ac72-11ea-8ded-437354ec7423.jpg?alt=media&token=9d5f7d1b-3bcc-467b-b82a-76ad2703a339"
      }
    ],
    productNameEnglish: "Chicken",
    productPrice: "3.5",
    productSupplier: "BCS SHOP",
    sortOrder: "d",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1pc 800gm",
    updateDateTime: "04/07/2020 11:32:06",
    count: 61
  },
  {
    category: "MEAT FISH",
    isPopular: "YES",
    key: "-M9zxx8mwFMeson_IRkz",
    photos: [
      {
        imageName: "d1e6c670-b03c-11ea-9737-25db4b55bc7b.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fd1e6c670-b03c-11ea-9737-25db4b55bc7b.jpg?alt=media&token=9c8f5020-1867-4b38-8fa7-597e616207f2"
      }
    ],
    productNameEnglish: "Catla Fish",
    productPrice: "5.50",
    productSupplier: "BCS SHOP",
    sortOrder: "a",
    sourceSupplier: "AYSHA SUPERMARKET PTE LTD",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1KG",
    updateDateTime: "03/08/2020 05:23:26",
    count: 60
  },
  {
    availability: "AVAILABLE",
    category: "রান্না করা খাবার",
    key: "-MCR7zvnQzc1AeZpRsk0",
    photos: [
      {
        imageName: "3a79ee10-c811-11ea-99a6-3f4f89ed7cd9.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F3a79ee10-c811-11ea-99a6-3f4f89ed7cd9.jpg?alt=media&token=a26699e9-de8d-4e6a-86bf-04274fbcd3d8"
      }
    ],
    productNameEnglish:
      "মিক্স সব্জি mixed vege - Delivery by taxi, pay as meter-fare. ",
    productPrice: "1",
    productSupplier: "BCS SHOP",
    sortOrder: "a",
    supplierContactName: "Ahmed Fayyaz",
    supplierContactPhone: "97861239",
    unit: "1 serving ",
    updateDateTime: "Tue 11-08-20 6:47 pm",
    count: 59
  },
  {
    availability: "AVAILABLE",
    category: "EGGS DAIRY",
    isPopular: "YES",
    key: "-MABkOB9PgFDrB6Dv8D_",
    photos: [
      {
        imageName: "de9c87a0-bc4f-11ea-b7df-33e703b87300.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fde9c87a0-bc4f-11ea-b7df-33e703b87300.jpg?alt=media&token=8606e8f7-8b04-43b7-b055-09d58a6c0147"
      }
    ],
    productNameEnglish: "Nestle Everyday Intant Milk Powder",
    productPrice: "11",
    productSupplier: "BCS SHOP",
    searchText: "milk dudh dod ধুদ ",
    sortOrder: "c",
    supplierContactName: "Ahmed Fayyaz",
    supplierContactPhone: "97861239",
    unit: "600gm",
    updateDateTime: "Tue 18-08-20 9:35 am",
    count: 58
  },
  {
    availability: "AVAILABLE",
    category: "SNACKS DRY FOOD",
    isPopular: "YES",
    key: "-MA-oxGQ_WnEFDAPleoG",
    photos: [
      {
        imageName: "5e3f1ac0-b216-11ea-921f-9db4b33fb426.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F5e3f1ac0-b216-11ea-921f-9db4b33fb426.jpg?alt=media&token=c75ffd76-551e-448c-b3bd-a8bab4d76e16"
      }
    ],
    productNameEnglish: "PRAN Special Toast Biscuit ",
    productPrice: "2",
    productSupplier: "BCS SHOP",
    sortOrder: "a",
    sourceSupplier: "TERRY TRADING CO PTE LTD",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "350g",
    updateDateTime: "03/08/2020 04:38:34",
    count: 56
  },
  {
    availability: "AVAILABLE",
    category: "OTHERS",
    isPopular: "YES",
    key: "-MAuUm3Qs70W-bsoD_Ci",
    photos: [
      {
        imageName: "8ae9f9d0-01ff-11eb-b3c7-236ec5a8a539.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F8ae9f9d0-01ff-11eb-b3c7-236ec5a8a539.jpg?alt=media&token=d22c1735-ae5c-424a-a3b6-ba84cb76dcb4"
      }
    ],
    productNameEnglish: "Lungi - Bangladeshi & large size",
    productPrice: "10",
    productSupplier: "BCS SHOP",
    searchText: "longi loongi lunge লুঙ্গি লুঙ্গী ",
    sortOrder: "m",
    sourceSupplier: "TANMOY ENTERPRISE PTE LTD",
    supplierContactName: "Ahmed Fayyaz",
    supplierContactPhone: "97861239",
    unit: "1 pc",
    updateDateTime: "Tue 29-09-20 10:57 am",
    count: 55
  },
  {
    category: "COSMETICS",
    isPopular: "YES",
    key: "-MA-sRL3qefgUMb_UOtv",
    photos: [
      {
        imageName: "1a2d7c20-b214-11ea-921f-9db4b33fb426.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F1a2d7c20-b214-11ea-921f-9db4b33fb426.jpg?alt=media&token=4e348ad6-5cfa-47ed-82bb-f1c7a4ef338c"
      }
    ],
    productNameEnglish: "Fair and Handsome Advanced Whitening Cream",
    productPrice: "4.20",
    productSupplier: "BCS SHOP",
    searchText: "fair & handsome ফেইস ক্রিম",
    sortOrder: "x",
    sourceSupplier: "MUSTAFA CENTRE",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "50G",
    updateDateTime: "17/07/2020 06:32:49",
    count: 55
  },
  {
    author: "+6589050302",
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    isPopular: "YES",
    key: "-MA4XcGeK3fGezqp242G",
    photos: [
      {
        imageName: "9635a610-bdb5-11ea-8ba8-ddb60ef370d4.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F9635a610-bdb5-11ea-8ba8-ddb60ef370d4.jpg?alt=media&token=f349ff7f-4bf3-4fff-bd73-0269501e0056"
      }
    ],
    productNameEnglish: "Green Papaya",
    productPrice: "3.50",
    productSupplier: "BCS SHOP",
    searchText: "kacha pepe কাচা পেঁপে পেপে ",
    sortOrder: "a",
    sourceSupplier: "Veg mart ",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1kg",
    updateDateTime: "Fri 21-08-20 4:31 pm",
    count: 54
  },
  {
    availability: "AVAILABLE",
    category: "RICE DAAL NOODLES",
    isPopular: "YES",
    key: "-M9faHN_6liw96XMkKvd",
    photos: [
      {
        imageName: "1f949a60-ad21-11ea-9a01-db9ea96fa329.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F1f949a60-ad21-11ea-9a01-db9ea96fa329.jpg?alt=media&token=cc2aeda7-af86-483b-a3e1-2cd897649ea3"
      }
    ],
    productNameEnglish: "MAGGI 2-MIN CURRY NOODLES",
    productPrice: "2.90",
    productSupplier: "BCS SHOP",
    searchText: "mi goreng",
    sortOrder: "a",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "5x79g Packets",
    updateDateTime: "17/07/2020 06:54:18",
    count: 53
  },
  {
    availability: "AVAILABLE",
    category: "RICE DAAL NOODLES",
    isPopular: "YES",
    key: "-M9aVSMCT5Ptf6z4V_RH",
    photos: [
      {
        imageName: "39359b30-ac5a-11ea-abb9-bdb7271566ee.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F39359b30-ac5a-11ea-abb9-bdb7271566ee.jpg?alt=media&token=bc3b3ed4-680c-4e06-89a9-78472234b2f4"
      }
    ],
    productNameEnglish: "Rice ",
    productPrice: "14.9",
    productSupplier: "BCS SHOP",
    searchText: "চাউল ",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "10kg",
    updateDateTime: "23/07/2020 12:45:01",
    count: 53
  },
  {
    availability: "AVAILABLE",
    category: "POPULAR",
    isPopular: "YES",
    key: "-M9fIeLqNa6uImfqltyH",
    photos: [
      {
        imageName: "9354b8a0-f97e-11ea-8999-bfa3df93f633.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F9354b8a0-f97e-11ea-8999-bfa3df93f633.jpg?alt=media&token=3718d897-6ec4-4b58-992b-e029e262f565"
      }
    ],
    productNameEnglish: "Carrot 1kg ",
    productPrice: "3.5",
    productSupplier: "BCS SHOP",
    searchText: "শাক সবজি সব্জি গাঁজর গাজর ",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1kg",
    updateDateTime: "Fri 18-09-20 3:14 pm",
    count: 53
  },
  {
    category: "RICE DAAL NOODLES",
    isPopular: "YES",
    key: "-MA-qjY8tZLSruvj_oBv",
    photos: [
      {
        imageName: "6201d390-b05f-11ea-8357-d5a4954c59fc.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F6201d390-b05f-11ea-8357-d5a4954c59fc.jpg?alt=media&token=75707566-396b-4928-bd91-e700686d6a6f"
      }
    ],
    productNameEnglish: "PRAN Chinigura Aromatic Rice",
    productPrice: "4.50",
    productSupplier: "BCS SHOP",
    searchText: "পুলাওর চাউল ",
    sortOrder: "a",
    sourceSupplier: "AYSHA SUPERMARKET PTE LTD",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1Kg",
    updateDateTime: "03/08/2020 04:35:31",
    count: 52
  },
  {
    category: "FRUITS VEGETABLES ",
    isPopular: "YES",
    key: "-M9YUfCHK8nxBXdjiJRN",
    photos: [
      {
        imageName: "630beac0-abe4-11ea-99a0-ada8a2be9f1b.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F630beac0-abe4-11ea-99a0-ada8a2be9f1b.jpg?alt=media&token=983ece57-623a-4c70-9ba4-de656b02edde"
      }
    ],
    productNameEnglish: "Sponge ",
    productPrice: "1.5",
    productSupplier: "BCS SHOP",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1kg",
    updateDateTime: "04/07/2020 09:21:27",
    count: 52
  },
  {
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    isPopular: "YES",
    key: "-M9cLdWJVsksCUdGRgRj",
    photos: [
      {
        imageName: "644cdde0-aca2-11ea-b1f6-655d279c50ce.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F644cdde0-aca2-11ea-b1f6-655d279c50ce.jpg?alt=media&token=8d7f8193-7f41-41f3-a64e-429368edbbdd"
      }
    ],
    productNameEnglish: "BRINJAL ",
    productPrice: "5",
    productSupplier: "BCS SHOP",
    searchText: "বেগুন বেগূন",
    sortOrder: "a",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1kg",
    updateDateTime: "17/07/2020 02:52:35",
    count: 52
  },
  {
    availability: "AVAILABLE",
    category: "EGGS DAIRY",
    isPopular: "YES",
    key: "-MABjiEtSQvbCSB-t1ux",
    photos: [
      {
        imageName: "ae547e80-bc50-11ea-b7df-33e703b87300.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fae547e80-bc50-11ea-b7df-33e703b87300.jpg?alt=media&token=e5e3a84e-1a4e-44e5-bea6-9e551bb27f0c"
      }
    ],
    productNameEnglish: "Nestle Everyday Intant Milk Powder",
    productPrice: "6",
    productSupplier: "BCS SHOP",
    searchText: "milk dudh dod powder ধুদ ",
    sortOrder: "c",
    supplierContactName: "Ahmed Fayyaz",
    supplierContactPhone: "97861239",
    unit: "300gm",
    updateDateTime: "03/08/2020 04:11:05",
    count: 51
  },
  {
    category: "FRUITS VEGETABLES ",
    isPopular: "YES",
    key: "-MA0JocbXImUuWFjH6Ch",
    photos: [
      {
        imageName: "b27d3680-b211-11ea-921f-9db4b33fb426.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fb27d3680-b211-11ea-921f-9db4b33fb426.jpg?alt=media&token=13981dc9-eabd-4cd2-a395-3bb289017930"
      }
    ],
    productNameEnglish: "Bottle Gourd",
    productPrice: "3",
    productSupplier: "BCS SHOP",
    sortOrder: "a",
    sourceSupplier: "S.K.K minimart ",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1Kg",
    updateDateTime: "03/08/2020 04:29:22",
    count: 51
  },
  {
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    isPopular: "YES",
    key: "-M9YXM8PU-56kPNuswb1",
    photos: [
      {
        imageName: "2d402df0-abe6-11ea-99a0-ada8a2be9f1b.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F2d402df0-abe6-11ea-99a0-ada8a2be9f1b.jpg?alt=media&token=cf7ca708-43d5-43a4-8d59-f2d6ccc47bfe"
      }
    ],
    productNameEnglish: "Spiny gourd ",
    productPrice: " 5.5",
    productSupplier: "BCS SHOP",
    searchText: "কারকল ",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1kg",
    updateDateTime: "17/07/2020 07:23:30",
    count: 50
  },
  {
    availability: "AVAILABLE",
    category: "DRINKS DESSERT",
    key: "-MEfRF_oewwv035TCXPk",
    photos: [
      {
        imageName: "9201ae00-ddee-11ea-a50a-71ea37251d72.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F9201ae00-ddee-11ea-a50a-71ea37251d72.jpg?alt=media&token=483d8be6-e128-48ee-aa65-270258f8b6f8"
      }
    ],
    productNameEnglish: "basil seeds tukma Pran",
    productPrice: "1.8",
    productSupplier: "BCS SHOP",
    searchText: "tukma dana ",
    sortOrder: "a",
    supplierContactName: "Ismita",
    supplierContactPhone: "userMobile",
    unit: "1 pkt 100g",
    updateDateTime: "Fri 14-08-20 4:13 pm",
    count: 50
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    key: "-MEfybskqSgPAmRbKKRe",
    photos: [
      {
        imageName: "55e9df40-de03-11ea-a50a-71ea37251d72.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F55e9df40-de03-11ea-a50a-71ea37251d72.jpg?alt=media&token=afed655d-6893-410d-8ca2-55fe79475e68"
      }
    ],
    productNameEnglish: "turmeric powder pran",
    productPrice: "3.80",
    productSupplier: "BCS SHOP",
    searchText: "holud",
    sortOrder: "a",
    supplierContactName: "Ismita",
    supplierContactPhone: "userMobile",
    unit: "1 jar 250g",
    updateDateTime: "Fri 14-08-20 4:17 pm",
    count: 47
  },
  {
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    key: "-M9Y4AEtGCuFmPazEOcn",
    photos: [
      {
        imageName: "428601a0-f734-11ea-885a-2b4d96b2f26b.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F428601a0-f734-11ea-885a-2b4d96b2f26b.jpg?alt=media&token=3437c6f2-a9e1-4f33-b7e9-482a9694df90"
      }
    ],
    productNameEnglish: "Eggplant ",
    productPrice: "5",
    productSupplier: "BCS SHOP",
    searchText: "গোল বেগুন ",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1KG",
    updateDateTime: "Tue 15-09-20 5:17 pm",
    count: 47
  },
  {
    availability: "AVAILABLE",
    category: "RICE DAAL NOODLES",
    isPopular: "",
    key: "-ME2kI4Y8ht02vbEv9uV",
    photos: [
      {
        imageName: "c2f04820-d7de-11ea-942d-b9f1e760c600.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fc2f04820-d7de-11ea-942d-b9f1e760c600.jpg?alt=media&token=3c4cd649-eeea-4e59-ba14-27e37a6cd9e9"
      }
    ],
    productNameEnglish: "Rice - house brand 25kg",
    productPrice: "34",
    productSupplier: "BCS SHOP",
    searchText: "rice",
    sortOrder: "a",
    supplierContactName: "Ahmed Fayyaz",
    supplierContactPhone: "97861239",
    unit: "25kg",
    updateDateTime: "Wed 02-12-20 10:20 am",
    count: 47
  },
  {
    availability: "AVAILABLE",
    category: "SNACKS DRY FOOD",
    isPopular: "YES",
    key: "-M9aUta2ZW3uTbaB-UsJ",
    photos: [
      {
        imageName: "d7e77b00-ac59-11ea-bbe4-619ccaa778ae.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fd7e77b00-ac59-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=e82f3068-a359-4d59-ad04-7a1317b3da4c"
      }
    ],
    productNameEnglish: "ALMOND ",
    productPrice: "2",
    productSupplier: "BCS SHOP",
    sortOrder: "a",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1 pkt",
    updateDateTime: "23/07/2020 12:46:52",
    count: 45
  },
  {
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    key: "-M9cYGhK2EUcpGwMdTBz",
    photos: [
      {
        imageName: "1a317c90-acaa-11ea-ab51-0f18e1d42bbd.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F1a317c90-acaa-11ea-ab51-0f18e1d42bbd.jpg?alt=media&token=63c6c4c7-00e2-4f0d-bfde-00a4e9080c96"
      }
    ],
    productNameEnglish: "PUMPKIN (1kg)",
    productPrice: "4",
    productSupplier: "BCS SHOP",
    searchText: "মিষ্টি কুমড়া মিস্টি ",
    sortOrder: "g",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1kg",
    updateDateTime: "17/07/2020 02:43:00",
    count: 45
  },
  {
    availability: "AVAILABLE",
    category: "EGGS DAIRY",
    isPopular: "YES",
    key: "-M9ayXnPTIZLPeIsVKIy",
    photos: [
      {
        imageName: "859f9950-bf8b-11ea-85e3-735b22b1a0db.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F859f9950-bf8b-11ea-85e3-735b22b1a0db.jpg?alt=media&token=feeb6233-fae4-4319-b830-d02a86d405de"
      }
    ],
    productNameEnglish: "Meiji milk ",
    productPrice: "6",
    productSupplier: "BCS SHOP",
    searchText: "fresh milk দুধ গরুর দুধ",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "2L",
    updateDateTime: "06/07/2020 09:24:42",
    count: 45
  },
  {
    availability: "AVAILABLE",
    category: "রান্না করা খাবার",
    key: "-MCRA-WbZ8wZGd0NCVYC",
    photos: [
      {
        imageName: "6d422780-c812-11ea-99a6-3f4f89ed7cd9.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F6d422780-c812-11ea-99a6-3f4f89ed7cd9.jpg?alt=media&token=245e524c-7edc-46d9-b689-500b37ea48ea"
      }
    ],
    productNameEnglish:
      "আলুর ভর্তা spicy mashed potato - Delivery by taxi, pay as meter-fare. ",
    productPrice: "1",
    productSupplier: "BCS SHOP",
    sortOrder: "a",
    supplierContactName: "Ahmed Fayyaz",
    supplierContactPhone: "97861239",
    unit: "1 serving ",
    updateDateTime: "Tue 11-08-20 6:46 pm",
    count: 44
  },
  {
    availability: "AVAILABLE",
    category: "PICKLES",
    isPopular: "YES",
    key: "-M9aVn49Kj6Vx8QpDqtJ",
    photos: [
      {
        imageName: "566ba230-ac5a-11ea-bbe4-619ccaa778ae.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F566ba230-ac5a-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=ac9d7b01-1703-49c2-b16a-523110e1c10c"
      }
    ],
    productNameEnglish: "PRAN CHILLI PICKLE",
    productPrice: "3.2",
    productSupplier: "BCS SHOP",
    searchText: "মরিচের আচার ",
    sortOrder: "a",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1 btl",
    updateDateTime: "17/07/2020 07:38:21",
    count: 44
  },
  {
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    key: "-MGajFuMfZ35eVylCMyq",
    photos: [
      {
        imageName: "40f06ea0-f0bf-11ea-ba7d-67bd2d78e913.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F40f06ea0-f0bf-11ea-ba7d-67bd2d78e913.jpg?alt=media&token=82428541-1ba2-4944-87ee-192f3a6c0338"
      }
    ],
    productNameEnglish: "Garlic 1 bag",
    productPrice: "9",
    productSupplier: "BCS SHOP",
    searchText: "Garlic",
    sortOrder: "a",
    supplierContactName: "Ismita",
    supplierContactPhone: "userMobile",
    unit: "1 bag",
    updateDateTime: "Mon 07-09-20 12:45 pm",
    count: 44
  },
  {
    availability: "AVAILABLE",
    category: "MEAT FISH",
    isPopular: "YES",
    key: "-M9a01C0di5V5yqY-TI8",
    photos: [
      {
        imageName: "f7b6c520-ac46-11ea-ba1a-4bcfa8bf5006.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ff7b6c520-ac46-11ea-ba1a-4bcfa8bf5006.jpg?alt=media&token=979f21dc-bcfe-45bb-9a80-9574a3b8c01d"
      }
    ],
    productNameEnglish: "Beef liver ",
    productPrice: "5.5",
    productSupplier: "BCS SHOP",
    searchText: "গরুর কলিজা ",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1kg",
    updateDateTime: "23/07/2020 12:57:35",
    count: 43
  },
  {
    category: "RICE DAAL NOODLES",
    key: "-M9bEIvlWNBonUmZ9tjK",
    photos: [
      {
        imageName: "d8406a40-ac76-11ea-8ded-437354ec7423.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fd8406a40-ac76-11ea-8ded-437354ec7423.jpg?alt=media&token=e36c2ce6-7cbb-4953-a788-e97be6dd7d76"
      }
    ],
    productNameEnglish: "House yellow gran",
    productPrice: "2.5",
    productSupplier: "BCS SHOP",
    sortOrder: "d",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "500g",
    updateDateTime: "04/07/2020 08:37:06",
    count: 43
  },
  {
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    key: "-M9f5MRLGTyvg4nAONHR",
    photos: [
      {
        imageName: "ac00d520-f896-11ea-aaa8-a9cfb87a7f3a.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Fac00d520-f896-11ea-aaa8-a9cfb87a7f3a.jpg?alt=media&token=fc3dcaf3-9569-432a-90d7-4eb1f19a07bc"
      }
    ],
    productNameEnglish: "Lychee",
    productPrice: "3.5",
    productSupplier: "BCS SHOP",
    searchText: "লিচু লীচু ফল ",
    sortOrder: "g",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "500gm",
    updateDateTime: "Thu 17-09-20 11:34 am",
    count: 43
  },
  {
    author: "+6584124637",
    isPopular: "YES",
    key: "-M94SdSeP41Szh-wrWfT",
    photos: [
      {
        imageName: "6412cc70-a74f-11ea-a14e-4374971e8751.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F6412cc70-a74f-11ea-a14e-4374971e8751.jpg?alt=media&token=a0cc3232-a09a-4453-bf63-1dcaeea80e83"
      },
      {
        imageName: "7af12360-a74f-11ea-a14e-4374971e8751.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F7af12360-a74f-11ea-a14e-4374971e8751.jpg?alt=media&token=f25c18cd-576f-4418-b0b8-b1fa02598ee9"
      }
    ],
    productDescription:
      "Free prayer mats for migrant brothers who does not have prayer mat. ",
    productNameEnglish: "Prayer mats ",
    productPrice: "Free ",
    productSupplier: "FREE PRAYER MAT",
    supplierContactName: "Kabir",
    supplierContactPhone: "94562455",
    updateDateTime: "17/06/2020 10:35:38",
    count: 41
  },
  {
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    isPopular: "YES",
    key: "-MABXAIcpABQfGW7lI7F",
    photos: [
      {
        imageName: "b64648c0-bf80-11ea-85e3-735b22b1a0db.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fb64648c0-bf80-11ea-85e3-735b22b1a0db.jpg?alt=media&token=f787ebe8-3b5d-45b6-b77a-338e1b461c99"
      }
    ],
    productNameEnglish: "Orange (Malta)",
    productPrice: "6",
    productSupplier: "BCS SHOP",
    searchText: "komola malta কমলা মালটা ",
    sortOrder: "a",
    supplierContactName: "Ahmed Fayyaz",
    supplierContactPhone: "97861239",
    unit: "5 pcs",
    updateDateTime: "03/08/2020 03:56:14",
    count: 41
  },
  {
    availability: "AVAILABLE",
    category: "DRINKS DESSERT",
    isPopular: "YES",
    key: "-M9afcR3fAF6iuy36Ovu",
    photos: [
      {
        imageName: "0d7136b0-ac61-11ea-bbe4-ef7bbce60778.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F0d7136b0-ac61-11ea-bbe4-ef7bbce60778.jpg?alt=media&token=a377c659-95bc-41e7-86eb-c1a85c6d4774"
      }
    ],
    productNameEnglish: "Coffee ye ye ",
    productPrice: "13.50",
    productSupplier: "BCS SHOP",
    searchText: "কফি ",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "100pcs",
    updateDateTime: "17/07/2020 08:12:24",
    count: 40
  },
  {
    availability: "AVAILABLE",
    category: "MEAT FISH",
    isPopular: "YES",
    key: "-M9a_0-2n-GYPYpy2QX6",
    photos: [
      {
        imageName: "e04f6610-ac5c-11ea-a00d-954b17f61eb9.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fe04f6610-ac5c-11ea-a00d-954b17f61eb9.jpg?alt=media&token=d08dcef5-139c-492a-92aa-18b9655b6dc6"
      }
    ],
    productNameEnglish: "prawns $16 to $30/1kg",
    productPrice: "18",
    productSupplier: "BCS SHOP",
    searchText: "চিংড়ি মাছ ",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1 kg",
    updateDateTime: "23/07/2020 12:43:05",
    count: 40
  },
  {
    availability: "AVAILABLE",
    category: "SNACKS DRY FOOD",
    key: "-MEfmmg-H4wL9EEg2t16",
    photos: [
      {
        imageName: "68c74100-ddfb-11ea-a50a-71ea37251d72.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F68c74100-ddfb-11ea-a50a-71ea37251d72.jpg?alt=media&token=1da3667b-b911-4aba-a5a9-be787b749aa7"
      }
    ],
    productNameEnglish: "chanachur hot 150g pran",
    productPrice: "0.90",
    productSupplier: "BCS SHOP",
    searchText: "chanachur ",
    sortOrder: "a",
    supplierContactName: "Ismita",
    supplierContactPhone: "userMobile",
    unit: "1 pkt 150g",
    updateDateTime: "Fri 14-08-20 4:16 pm",
    count: 40
  },
  {
    availability: "AVAILABLE",
    category: "রান্না করা খাবার",
    key: "-MCR8w6gC2C8s2l4M1hd",
    photos: [
      {
        imageName: "c551e7e0-c811-11ea-99a6-3f4f89ed7cd9.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fc551e7e0-c811-11ea-99a6-3f4f89ed7cd9.jpg?alt=media&token=aa22d044-dabd-49c5-bbe6-35ac8325053f"
      }
    ],
    productNameEnglish:
      "ছুট মাছ  small fish curry - Delivery by taxi, pay as meter-fare. ",
    productPrice: "4",
    productSupplier: "BCS SHOP",
    sortOrder: "a",
    supplierContactName: "Ahmed Fayyaz",
    supplierContactPhone: "97861239",
    unit: "1 serving ",
    updateDateTime: "Tue 11-08-20 6:46 pm",
    count: 39
  },
  {
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    key: "-MFLZTbxvM6MFf8kb2ym",
    photos: [
      {
        imageName: "ac2a8d60-e483-11ea-8a88-a93d6c394935.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Fac2a8d60-e483-11ea-8a88-a93d6c394935.jpg?alt=media&token=6a9d6725-42f2-4ccc-bc4f-d6db00e37be1"
      }
    ],
    productNameEnglish: "Red chilli ",
    productPrice: "1.5",
    productSupplier: "BCS SHOP",
    searchText: "লাল কাঁচা মরিচ",
    sortOrder: "a",
    supplierContactName: "Kabir",
    supplierContactPhone: "94562455",
    unit: "200g",
    updateDateTime: "Wed 02-12-20 10:21 am",
    count: 39
  },
  {
    availability: "AVAILABLE",
    category: "SNACKS DRY FOOD",
    isPopular: "NO",
    key: "-M9aaC7nHYMy5XdSKVR6",
    photos: [
      {
        imageName: "bcdbf850-ac5d-11ea-bbe4-619ccaa778ae.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fbcdbf850-ac5d-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=af322bc6-c4d3-4053-a024-e9a32cee307d"
      }
    ],
    productNameEnglish: "TOAST ",
    productPrice: "2",
    productSupplier: "BCS SHOP",
    sortOrder: "d",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1 pkt",
    updateDateTime: "23/07/2020 12:32:33",
    count: 38
  },
  {
    availability: "AVAILABLE",
    category: "DRINKS DESSERT",
    key: "-MCFqELs7pn6hJ5HC77t",
    photos: [
      {
        imageName: "07c78780-c658-11ea-8937-41f6a00ee84d.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F07c78780-c658-11ea-8937-41f6a00ee84d.jpg?alt=media&token=2640edda-a253-4dc8-92b4-00b85773333a"
      }
    ],
    productNameEnglish: "Red Bull Energy Drink",
    productPrice: "6.70",
    productSupplier: "BCS SHOP",
    searchText: "রেডবুল ",
    sortOrder: "g",
    supplierContactName: "Ahmed Fayyaz",
    supplierContactPhone: "97861239",
    unit: "6 pcs x 250ml",
    updateDateTime: "03/08/2020 03:26:32",
    count: 38
  },
  {
    availability: "OUT OF STOCK, TOPPING UP IN PROGRESS",
    category: "COOKING OIL INGREDIENTS",
    isPopular: "YES",
    key: "-MDxtMUlxU5qBOzL7Irf",
    photos: [
      {
        imageName: "e47946b0-d6fb-11ea-82eb-219eb13e1aa0.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fe47946b0-d6fb-11ea-82eb-219eb13e1aa0.jpg?alt=media&token=c332da8e-6d70-4b27-8bc2-3906dab13ee0"
      }
    ],
    productNameEnglish: "Sunflower oil ",
    productPrice: "13.50",
    productSupplier: "BCS SHOP",
    searchText: "G",
    sortOrder: "G",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "5L",
    updateDateTime: "Wed 16-09-20 11:35 am",
    count: 37
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    key: "-MEg0nusCP-6UF_64iQi",
    photos: [
      {
        imageName: "32a793a0-de04-11ea-a50a-71ea37251d72.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F32a793a0-de04-11ea-a50a-71ea37251d72.jpg?alt=media&token=bab13879-c2b9-44db-81c6-f210583f03d9"
      }
    ],
    productNameEnglish: "coriander powder pran",
    productPrice: "2.5",
    productSupplier: "BCS SHOP",
    searchText: "coriander",
    sortOrder: "a",
    supplierContactName: "Ismita",
    supplierContactPhone: "userMobile",
    unit: "1 jar 200g",
    updateDateTime: "Fri 14-08-20 4:43 pm",
    count: 37
  },
  {
    availability: "AVAILABLE",
    category: "রান্না করা খাবার",
    key: "-MCRBqPtysKzn9y35Vp3",
    photos: [
      {
        imageName: "2c161540-c813-11ea-99a6-3f4f89ed7cd9.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F2c161540-c813-11ea-99a6-3f4f89ed7cd9.jpg?alt=media&token=c9861ad2-9fd6-4d4d-b17c-a0ca1d52012d"
      }
    ],
    productNameEnglish:
      "কাতলা মাছ catla fish curry - Delivery by taxi, pay as meter-fare. ",
    productPrice: "4",
    productSupplier: "BCS SHOP",
    sortOrder: "a",
    supplierContactName: "Ahmed Fayyaz",
    supplierContactPhone: "97861239",
    unit: "1 serving ",
    updateDateTime: "Tue 11-08-20 6:45 pm",
    count: 36
  },
  {
    availability: "AVAILABLE",
    category: "SNACKS DRY FOOD",
    isPopular: "YES",
    key: "-MAB9V1JLwAGA1zCB0hy",
    photos: [
      {
        imageName: "af7cc410-b5bc-11ea-8808-e1e7c83edfc8.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Faf7cc410-b5bc-11ea-8808-e1e7c83edfc8.jpg?alt=media&token=1fe738cc-b954-4daf-bd5c-018587483d3a"
      }
    ],
    productNameEnglish: "PRAN Chanachur - Hot 1kg Pack ",
    productPrice: "6",
    productSupplier: "BCS SHOP",
    searchText: "channachur chanacor ",
    sortOrder: "a",
    sourceSupplier: "GLOBAL PIONEEER PTE LTD",
    supplierContactName: "Kabir",
    supplierContactPhone: "94562455",
    unit: "1kg",
    updateDateTime: "03/08/2020 03:58:41",
    count: 36
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    isPopular: "YES",
    key: "-M9bJC6AZeWff8sR21LX",
    photos: [
      {
        imageName: "514a0f10-ac84-11ea-905e-b59fb9963ca1.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F514a0f10-ac84-11ea-905e-b59fb9963ca1.jpg?alt=media&token=186d6c18-e5e4-424b-a294-eab6f8e85802"
      }
    ],
    productNameEnglish: "Vegetable oil",
    productPrice: "5.80",
    productSupplier: "BCS SHOP",
    searchText: "তেল তৈল ",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "2L Bottle",
    updateDateTime: "Fri 28-08-20 11:57 am",
    count: 36
  },
  {
    availability: "AVAILABLE",
    category: "রান্না করা খাবার",
    key: "-MHVDYR3ye_hNAYgtCWm",
    photos: [
      {
        imageName: "f24ea0e0-f984-11ea-98b2-bdfbde6255e9.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Ff24ea0e0-f984-11ea-98b2-bdfbde6255e9.jpg?alt=media&token=bbba37df-1b44-485f-8597-953919ce52ba"
      }
    ],
    productNameEnglish: "কালো  জিরা ভর্তা ।",
    productPrice: "1",
    productSupplier: "BCS SHOP",
    searchText: "kalo jera vorta.",
    sortOrder: "a",
    supplierContactName: "Ismita",
    supplierContactPhone: "userMobile",
    unit: "1 serving.",
    updateDateTime: "Fri 18-09-20 4:21 pm",
    count: 36
  },
  {
    availability: "AVAILABLE",
    category: "রান্না করা খাবার",
    key: "-MCR9GdJufTtT8m56H-1",
    photos: [
      {
        imageName: "f3b228c0-c811-11ea-99a6-3f4f89ed7cd9.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ff3b228c0-c811-11ea-99a6-3f4f89ed7cd9.jpg?alt=media&token=1389e0eb-e748-4908-8f6a-76710cdba94f"
      }
    ],
    productNameEnglish:
      "ডাল ভর্তা  Mashed lentil - Delivery by taxi, pay as meter-fare.  ",
    productPrice: "1",
    productSupplier: "BCS SHOP",
    sortOrder: "a",
    supplierContactName: "Ahmed Fayyaz",
    supplierContactPhone: "97861239",
    unit: "1 serving ",
    updateDateTime: "Tue 11-08-20 6:46 pm",
    count: 34
  },
  {
    category: "EGGS DAIRY",
    isPopular: "YES",
    key: "-M9Y0ixv1jxpZF_BdfTy",
    photos: [
      {
        imageName: "1cf52090-abd2-11ea-b76c-0b360dd92c32.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F1cf52090-abd2-11ea-b76c-0b360dd92c32.jpg?alt=media&token=3177d850-f72d-4b52-add8-1c73565f5f68"
      }
    ],
    productNameEnglish: "Honey  ",
    productPrice: "6.5",
    productSupplier: "BCS SHOP",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "500ml",
    updateDateTime: "04/07/2020 09:14:33",
    count: 34
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    key: "-M9fHMrVBEGYkGPsl98Q",
    photos: [
      {
        imageName: "f954d920-ad14-11ea-8bc0-03f48af12a9c.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ff954d920-ad14-11ea-8bc0-03f48af12a9c.jpg?alt=media&token=50a9ce25-4ef7-4149-97b4-413063b91f9f"
      }
    ],
    productNameEnglish: "PAGODA FINE SALT",
    productPrice: "0.90",
    productSupplier: "BCS SHOP",
    searchText: "লবণ লবন ",
    sortOrder: "d",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "500g",
    updateDateTime: "17/07/2020 08:50:31",
    count: 34
  },
  {
    availability: "AVAILABLE",
    category: "DRINKS DESSERT",
    isPopular: "YES",
    key: "-MBZKEFOmp9p-uw3Bn5n",
    photos: [
      {
        imageName: "30743ec0-bf8d-11ea-85e3-735b22b1a0db.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F30743ec0-bf8d-11ea-85e3-735b22b1a0db.jpg?alt=media&token=e2b19a51-7dc8-4665-982a-e0c6fba31e4f"
      }
    ],
    productNameEnglish: "SIS Refined White Sugar",
    productPrice: "1.90",
    productSupplier: "BCS SHOP",
    searchText: "চিনি ",
    sortOrder: "a",
    sourceSupplier: "Sheng siong ",
    supplierContactName: "Ahmed Fayyaz",
    supplierContactPhone: "97861239",
    unit: "1kg",
    updateDateTime: "17/07/2020 07:32:58",
    count: 33
  },
  {
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    isPopular: "YES",
    key: "-M9Y9D065-hddXvOvSpc",
    photos: [
      {
        imageName: "168de720-f734-11ea-885a-2b4d96b2f26b.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F168de720-f734-11ea-885a-2b4d96b2f26b.jpg?alt=media&token=2e5d791c-cfe6-4d98-828e-a8d9ec8210a9"
      }
    ],
    productNameEnglish: "Radish ",
    productPrice: "4",
    productSupplier: "BCS SHOP",
    searchText: "মুলা ",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1kg",
    updateDateTime: "Tue 15-09-20 5:16 pm",
    count: 33
  },
  {
    availability: "AVAILABLE",
    category: "DRINKS DESSERT",
    key: "-MA4cGShaIl7o-YkQkFm",
    photos: [
      {
        imageName: "659d4fd0-bc52-11ea-b7df-33e703b87300.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F659d4fd0-bc52-11ea-b7df-33e703b87300.jpg?alt=media&token=53698db7-deb9-4657-9712-87bcbe08649d"
      }
    ],
    productNameEnglish: "Young Coconut",
    productPrice: "2.50",
    productSupplier: "BCS SHOP",
    searchText: "ডাবের পানি নারিকেল পানি ",
    sortOrder: "a",
    sourceSupplier: "B&S minimart ",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1PC",
    updateDateTime: "17/07/2020 02:12:13",
    count: 33
  },
  {
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    isPopular: "NO",
    key: "-M9YZA49hWE54KVe0tCV",
    photos: [
      {
        imageName: "6bdc1a00-bdad-11ea-8ba8-ddb60ef370d4.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F6bdc1a00-bdad-11ea-8ba8-ddb60ef370d4.jpg?alt=media&token=d2412a77-2d03-45c8-9cc1-1610484cc04b"
      }
    ],
    productNameEnglish: "Baby Cucumber ",
    productPrice: "2",
    productSupplier: "BCS SHOP",
    searchText: "shosha  ছোট  শশা শসা ",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "500gm",
    updateDateTime: "28/07/2020 06:04:42",
    count: 33
  },
  {
    availability: "AVAILABLE",
    category: "SNACKS DRY FOOD",
    key: "-MEfnE2YRECG5CSHrUtD",
    photos: [
      {
        imageName: "f611cc00-ddfc-11ea-a50a-71ea37251d72.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Ff611cc00-ddfc-11ea-a50a-71ea37251d72.jpg?alt=media&token=f83a126e-c360-4e31-9b8f-53537c243e7c"
      }
    ],
    productNameEnglish: "chanachur hot 300g",
    productPrice: "1.80",
    productSupplier: "BCS SHOP",
    searchText: "chanachur",
    sortOrder: "a",
    supplierContactName: "Ismita",
    supplierContactPhone: "userMobile",
    unit: "1 pkt 300g",
    updateDateTime: "Fri 14-08-20 4:16 pm",
    count: 33
  },
  {
    availability: "AVAILABLE",
    category: "RICE DAAL NOODLES",
    isPopular: "YES",
    key: "-M9glXjaEe-mKWvEMYkB",
    photos: [
      {
        imageName: "047157e0-ad4f-11ea-9947-39ad013963aa.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F047157e0-ad4f-11ea-9947-39ad013963aa.jpg?alt=media&token=41b67f4a-8e77-4c84-b40c-e0d7a10cd76d"
      }
    ],
    productNameEnglish: "Uncle Cook's Ponni Rice",
    productPrice: "7.8",
    productSupplier: "BCS SHOP",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "5Kg",
    updateDateTime: "03/08/2020 06:59:38",
    count: 32
  },
  {
    category: "DRINKS DESSERT",
    key: "-M9bCf_WwXB4rAW5mkgT",
    photos: [
      {
        imageName: "d1ef1840-ac75-11ea-8ded-437354ec7423.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fd1ef1840-ac75-11ea-8ded-437354ec7423.jpg?alt=media&token=f5efc351-df92-4c74-944a-afc119a630ff"
      }
    ],
    productNameEnglish: "Coca cola",
    productPrice: "2.5",
    productSupplier: "BCS SHOP",
    sortOrder: "f",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1L Bottle",
    updateDateTime: "04/07/2020 08:43:06",
    count: 32
  },
  {
    availability: "AVAILABLE",
    category: "PICKLES",
    photos: [
      {
        imageName: "78e64740-de0d-11ea-9698-4d47c48636b6.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F78e64740-de0d-11ea-9698-4d47c48636b6.jpg?alt=media&token=748ec572-b5c5-4569-91b4-b56dffd8c98e"
      }
    ],
    productNameEnglish: "pran garlic pickle",
    productPrice: "3.20",
    productSupplier: "BCS SHOP",
    searchText: "rosun acher",
    sortOrder: "a",
    supplierContactName: "Ismita",
    supplierContactPhone: "userMobile",
    unit: "1 jar",
    updateDateTime: "Fri 14-08-20 5:07 pm",
    key: "-MEgDFKInKeMU-2jR-B9",
    count: 31
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    isPopular: "YES",
    key: "-M9aEGTP2736X6CBBnXa",
    photos: [
      {
        imageName: "87a98890-ac4f-11ea-95e2-e74f5187871b.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F87a98890-ac4f-11ea-95e2-e74f5187871b.jpg?alt=media&token=49f5c0fe-472b-4833-bd94-5e60cc5c65fd"
      }
    ],
    productNameEnglish: "CORIANDER POWDER",
    productPrice: "2.50",
    productSupplier: "BCS SHOP",
    searchText: "ধনিয়ার গুঁড়া ",
    sortOrder: "a",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1 pkt",
    updateDateTime: "17/07/2020 08:01:23",
    count: 31
  },
  {
    category: "EGGS DAIRY",
    isPopular: "YES",
    key: "-M9gCSog7V0Vdy8tUqRW",
    photos: [
      {
        imageName: "09d1d8b0-ad39-11ea-9a01-db9ea96fa329.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F09d1d8b0-ad39-11ea-9a01-db9ea96fa329.jpg?alt=media&token=0e6309ca-1e09-4b48-9349-d330afa8a9eb"
      }
    ],
    productNameEnglish: "MILKMAID FULL CREAM SWEETENED CONDENSED MILK",
    productPrice: "1.80",
    productSupplier: "BCS SHOP",
    sortOrder: "a",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "392g",
    updateDateTime: "04/07/2020 11:07:20",
    count: 31
  },
  {
    availability: "AVAILABLE",
    category: "রান্না করা খাবার",
    key: "-MHVG19Kcy11GUx62ZHn",
    photos: [
      {
        imageName: "83a71300-f986-11ea-98b2-bdfbde6255e9.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F83a71300-f986-11ea-98b2-bdfbde6255e9.jpg?alt=media&token=da735328-9af7-411e-ab71-4e72c5633557"
      }
    ],
    productNameEnglish: "শরিষা  ভর্তা  ।",
    productPrice: "1",
    productSupplier: "BCS SHOP",
    sortOrder: "a",
    supplierContactName: "Ismita",
    supplierContactPhone: "userMobile",
    unit: "1 serving",
    updateDateTime: "Fri 18-09-20 4:21 pm",
    count: 31
  },
  {
    category: "RICE DAAL NOODLES",
    key: "-M9b8JWwYFz517RGfvJ_",
    photos: [
      {
        imageName: "1759f790-ac73-11ea-8ded-437354ec7423.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F1759f790-ac73-11ea-8ded-437354ec7423.jpg?alt=media&token=87c9c6c7-6838-45e5-a421-679aa0408600"
      },
      {
        imageName: "21c9c7f0-ac73-11ea-8ded-437354ec7423.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F21c9c7f0-ac73-11ea-8ded-437354ec7423.jpg?alt=media&token=033a0dad-aa01-4f30-9273-cba66ffad7db"
      }
    ],
    productNameEnglish: "Big curry noodels",
    productPrice: "3.1",
    productSupplier: "BCS SHOP",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1 Pkt",
    updateDateTime: "04/07/2020 08:49:23",
    count: 31
  },
  {
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    key: "-M9b-7mBkiQTOHJc8uAO",
    photos: [
      {
        imageName: "a3e41fb0-f89a-11ea-aaa8-a9cfb87a7f3a.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Fa3e41fb0-f89a-11ea-aaa8-a9cfb87a7f3a.jpg?alt=media&token=87a4a44c-3b0a-42cf-b613-d3a7b86c04f8"
      }
    ],
    productNameEnglish: "MANGO ",
    productPrice: "8",
    productSupplier: "BCS SHOP",
    searchText: "আম ",
    sortOrder: "d",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1 kg",
    updateDateTime: "Mon 21-09-20 3:34 pm",
    count: 29
  },
  {
    category: "FRUITS VEGETABLES ",
    key: "-M9b-MLpqXrFjouqCo9g",
    photos: [
      {
        imageName: "e3403770-f89a-11ea-aaa8-a9cfb87a7f3a.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Fe3403770-f89a-11ea-aaa8-a9cfb87a7f3a.jpg?alt=media&token=b68ac054-e6a1-4338-a8cd-35365f3e48e5"
      }
    ],
    productNameEnglish: "POMEGRANATE ",
    productPrice: "3",
    productSupplier: "BCS SHOP",
    sortOrder: "d",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1 pc",
    updateDateTime: "Thu 17-09-20 12:04 pm",
    count: 29
  },
  {
    availability: "AVAILABLE",
    category: "SNACKS DRY FOOD",
    isPopular: "YES",
    key: "-M9aUTJYmnr3ay_dMfFU",
    photos: [
      {
        imageName: "88b87c00-ac59-11ea-bbe4-619ccaa778ae.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F88b87c00-ac59-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=806628c8-d92a-4854-998b-769cf8e22f6b"
      }
    ],
    productNameEnglish: "CASHEW ",
    productPrice: "2.50",
    productSupplier: "BCS SHOP",
    sortOrder: "a",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1 pkt",
    updateDateTime: "23/07/2020 12:47:08",
    count: 29
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    isPopular: "YES",
    key: "-M9aTBq-BrOibWA7X8Y-",
    photos: [
      {
        imageName: "ce7ab830-ac58-11ea-bbe4-619ccaa778ae.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fce7ab830-ac58-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=0348fe5e-a6e4-4e9a-9cef-f0f783d50486"
      }
    ],
    productNameEnglish: "FENUGREEK ",
    productPrice: "2.5",
    productSupplier: "BCS SHOP",
    searchText: "মেথি",
    sortOrder: "a",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1 pkt",
    updateDateTime: "23/07/2020 12:50:35",
    count: 28
  },
  {
    availability: "AVAILABLE",
    category: "COSMETICS",
    isPopular: "YES",
    key: "-M9hI30fYjFeEKpztA36",
    photos: [
      {
        imageName: "7e4b19c0-ad63-11ea-a545-3fca42f11c6b.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F7e4b19c0-ad63-11ea-a545-3fca42f11c6b.jpg?alt=media&token=f89a5dfc-e44a-4e86-a476-6a4592e4a004"
      }
    ],
    productNameEnglish: "Shaving Blade",
    productPrice: "1",
    productSupplier: "BCS SHOP",
    searchText: "shave shaving saving ব্লেড ",
    sortOrder: "x",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1 Pkt",
    updateDateTime: "03/08/2020 06:55:41",
    count: 28
  },
  {
    availability: "AVAILABLE",
    category: "রান্না করা খাবার",
    photos: [
      {
        imageName: "8d5bb440-f987-11ea-98b2-bdfbde6255e9.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F8d5bb440-f987-11ea-98b2-bdfbde6255e9.jpg?alt=media&token=f3dad4d2-92af-4b70-b443-2779ae1cb9ff"
      }
    ],
    productNameEnglish: "মাছের ডিম ভাজি।",
    productPrice: "2",
    productSupplier: "BCS SHOP",
    sortOrder: "a",
    supplierContactName: "Ismita",
    supplierContactPhone: "userMobile",
    unit: "1 serving",
    updateDateTime: "Fri 18-09-20 4:18 pm",
    key: "-MHVHnnh2iPjqWz6WrV5",
    count: 28
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    isPopular: "YES",
    key: "-M9aQc7YsWNmDmoolF11",
    photos: [
      {
        imageName: "0b0b8ce0-ac57-11ea-bbe4-619ccaa778ae.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F0b0b8ce0-ac57-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=2a3877ce-a6ee-49ba-b688-70de2d971d96"
      }
    ],
    productNameEnglish: "DC DRY CHILLI POWDER ",
    productPrice: "3.50",
    productSupplier: "BCS SHOP",
    searchText: "মরিচের গুঁড়া ",
    sortOrder: "a",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1 btl",
    updateDateTime: "17/07/2020 07:57:15",
    count: 28
  },
  {
    availability: "AVAILABLE",
    category: "EGGS DAIRY",
    key: "-M9b5gixFFWFZu_8K2gD",
    photos: [
      {
        imageName: "78b34d40-ac71-11ea-8ded-437354ec7423.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F78b34d40-ac71-11ea-8ded-437354ec7423.jpg?alt=media&token=5313c355-f51e-4170-8e2b-3fd689895acf"
      }
    ],
    productNameEnglish: "Bread",
    productPrice: "2.9",
    productSupplier: "BCS SHOP",
    searchText: "পাউরুটি পাওরোটি",
    sortOrder: "d",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1 Pkt",
    updateDateTime: "06/07/2020 09:40:20",
    count: 28
  },
  {
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    isPopular: "YES",
    key: "-M9YBFF3IOwSaJ5jdXxt",
    photos: [
      {
        imageName: "86af5890-f897-11ea-aaa8-a9cfb87a7f3a.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F86af5890-f897-11ea-aaa8-a9cfb87a7f3a.jpg?alt=media&token=e3172c68-6f4a-4e1e-b1d5-def8c76d97e3"
      }
    ],
    productNameEnglish: " wax gourd ",
    productPrice: "3.5",
    productSupplier: "BCS SHOP",
    searchText: "চালকোমড়া",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1kg",
    updateDateTime: "Thu 17-09-20 11:40 am",
    count: 28
  },
  {
    availability: "AVAILABLE",
    category: "LAUNDRY CLEANING",
    key: "-M9bBs4PdfnxhlDzHxTx",
    photos: [
      {
        imageName: "28eaf7a0-ac75-11ea-8ded-437354ec7423.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F28eaf7a0-ac75-11ea-8ded-437354ec7423.jpg?alt=media&token=dded438e-c6a6-42e7-83a1-a1e3e8232eee"
      }
    ],
    productNameEnglish: "Fab perfect washing powder ",
    productPrice: "6.8",
    productSupplier: "BCS SHOP",
    searchText: "ওয়াশিং পাউডার ",
    sortOrder: "f",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "2.1Kg",
    updateDateTime: "17/07/2020 07:56:39",
    count: 27
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    isPopular: "YES",
    key: "-M9aQ4t5M-cz1xzBmOfI",
    photos: [
      {
        imageName: "dcc3dd10-ac56-11ea-bbe4-619ccaa778ae.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fdcc3dd10-ac56-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=91619b71-70f4-4a45-96b4-043c11dd2dfe"
      }
    ],
    productNameEnglish: "DC TURMERIC POWDER ",
    productPrice: "3.70",
    productSupplier: "BCS SHOP",
    searchText: "হলুদের গুঁড়া হলুদ ",
    sortOrder: "a",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1 btl",
    updateDateTime: "23/07/2020 12:54:39",
    count: 27
  },
  {
    author: "+6589050302",
    category: "COSMETICS",
    isPopular: "NO",
    key: "-M9qx3DztDO4jxgP57j_",
    photos: [
      {
        imageName: "a7b53410-aedc-11ea-9b4b-4bd8d539c6a6.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fa7b53410-aedc-11ea-9b4b-4bd8d539c6a6.jpg?alt=media&token=8e4acb94-2c64-4ae6-9551-d48f8f537fa9"
      }
    ],
    productNameEnglish: "Parachute Coconut Hair Oil",
    productPrice: "3.50",
    productSupplier: "BCS SHOP",
    sortOrder: "k",
    sourceSupplier: "MUSTAFA CENTRE",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "200ML",
    updateDateTime: "Tue 25-08-20 10:01 am",
    count: 27
  },
  {
    availability: "AVAILABLE",
    category: "RICE DAAL NOODLES",
    key: "-M9hjms-69uHkY6aPAh0",
    photos: [
      {
        imageName: "00b8a060-ad75-11ea-8617-6988f4fcb266.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F00b8a060-ad75-11ea-8617-6988f4fcb266.jpg?alt=media&token=c61cbe55-8a1b-4bd0-8d7d-49a4346f852b"
      }
    ],
    productNameEnglish: "Housebrand Ponni Rice",
    productPrice: "8.5",
    productSupplier: "BCS SHOP",
    searchText: "চাউল rice",
    sortOrder: "b",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "5Kg",
    updateDateTime: "03/08/2020 06:51:41",
    count: 27
  },
  {
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    isPopular: "YES",
    key: "-MA4XjnSy0_iJBg1YE3w",
    photos: [
      {
        imageName: "e95f8440-bc53-11ea-b7df-33e703b87300.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fe95f8440-bc53-11ea-b7df-33e703b87300.jpg?alt=media&token=b2d5737c-b2c2-4a88-9a39-a80f2ffd9ad8"
      }
    ],
    productNameEnglish: " Malabar Spinach",
    productPrice: "5",
    productSupplier: "BCS SHOP",
    searchText: "poishak puishak shak পুঁইশাক পুইশাক ",
    sortOrder: "a",
    sourceSupplier: "B&S minimart ",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1kg",
    updateDateTime: "03/08/2020 04:19:53",
    count: 27
  },
  {
    availability: "AVAILABLE",
    category: "রান্না করা খাবার",
    key: "-MCR8Fw96_IPSx7ezDb2",
    photos: [
      {
        imageName: "5cde4050-c811-11ea-99a6-3f4f89ed7cd9.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F5cde4050-c811-11ea-99a6-3f4f89ed7cd9.jpg?alt=media&token=9fbae84a-126c-4869-97cd-e5655b73ad45"
      }
    ],
    productNameEnglish:
      "মিষ্টি কুমড়া pumkin vege - Delivery by taxi, pay as meter-fare. ",
    productPrice: "1",
    productSupplier: "BCS SHOP",
    sortOrder: "a",
    supplierContactName: "Ahmed Fayyaz",
    supplierContactPhone: "97861239",
    unit: "1 serving ",
    updateDateTime: "Tue 11-08-20 6:47 pm",
    count: 26
  },
  {
    availability: "OUT OF STOCK, TOPPING UP IN PROGRESS",
    category: "OTHERS",
    isPopular: "YES",
    key: "-MAuV2lPINSwTniomMlp",
    photos: [
      {
        imageName: "3e521340-b92b-11ea-bcad-f16312f4aa54.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F3e521340-b92b-11ea-bcad-f16312f4aa54.jpg?alt=media&token=6bc2029c-be52-4eec-8cfa-5cd4e63354ae"
      }
    ],
    productNameEnglish: "Gamsa - Bangladeshi Gamsa",
    productPrice: "5",
    productSupplier: "BCS SHOP",
    searchText: "gamsa gamca gamcha গামছা ",
    sortOrder: "m",
    sourceSupplier: "TANMOY ENTERPRISE PTE LTD",
    supplierContactName: "Ahmed Fayyaz",
    supplierContactPhone: "97861239",
    unit: "1 pc",
    updateDateTime: "Tue 25-08-20 11:45 am",
    count: 25
  },
  {
    availability: "AVAILABLE",
    category: "রান্না করা খাবার",
    key: "-MCR9THHUwxHT0yCpCK6",
    photos: [
      {
        imageName: "23c71e80-c812-11ea-99a6-3f4f89ed7cd9.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F23c71e80-c812-11ea-99a6-3f4f89ed7cd9.jpg?alt=media&token=7a711649-1626-455d-8215-e3a9860aa7f1"
      }
    ],
    productNameEnglish:
      "বাধাঁকপি cabbage - Delivery by taxi, pay as meter-fare. ",
    productPrice: "1",
    productSupplier: "BCS SHOP",
    sortOrder: "a",
    supplierContactName: "Ahmed Fayyaz",
    supplierContactPhone: "97861239",
    unit: "1 serving ",
    updateDateTime: "Tue 11-08-20 6:46 pm",
    count: 24
  },
  {
    category: "FROZEN",
    isPopular: "YES",
    key: "-M9a4CZ78AOClgPOpNxT",
    photos: [
      {
        imageName: "6bbed500-ac49-11ea-ba1a-4bcfa8bf5006.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F6bbed500-ac49-11ea-ba1a-4bcfa8bf5006.jpg?alt=media&token=d5cff067-856b-447e-9a85-edd0d3a73555"
      }
    ],
    productNameEnglish: "chicken drumstick   ",
    productPrice: "4",
    productSupplier: "BCS SHOP",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1kg",
    updateDateTime: "04/07/2020 09:30:07",
    count: 24
  },
  {
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    photos: [
      {
        imageName: "4fbdfc10-e122-11ea-8469-c1686cba6d19.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F4fbdfc10-e122-11ea-8469-c1686cba6d19.jpg?alt=media&token=e50af00e-c1d9-4625-b94a-9f7832addccf"
      }
    ],
    productNameEnglish: "Arum lobe",
    productPrice: "6.00",
    productSupplier: "BCS SHOP",
    searchText: "Kachur lati",
    sortOrder: "a",
    supplierContactName: "Ismita",
    supplierContactPhone: "userMobile",
    unit: "1 kg",
    updateDateTime: "Tue 18-08-20 3:22 pm",
    key: "-MF-RiWAtk49xfQvcQ0k",
    count: 24
  },
  {
    availability: "AVAILABLE",
    category: "রান্না করা খাবার",
    key: "-MHVHKvftDDCPt3j1R-8",
    photos: [
      {
        imageName: "3ae48f20-f987-11ea-98b2-bdfbde6255e9.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F3ae48f20-f987-11ea-98b2-bdfbde6255e9.jpg?alt=media&token=9c03f659-6de2-4ae8-a483-39de6b2cae1b"
      }
    ],
    productNameEnglish: "হাঁস এর মাংস রান্না।",
    productPrice: "6",
    productSupplier: "BCS SHOP",
    sortOrder: "a",
    supplierContactName: "Ismita",
    supplierContactPhone: "userMobile",
    unit: "1 serving .",
    updateDateTime: "Fri 18-09-20 4:18 pm",
    count: 24
  },
  {
    availability: "AVAILABLE",
    category: "রান্না করা খাবার",
    key: "-MDKs4BC155HT4MpXh_N",
    photos: [
      {
        imageName: "96689730-d0e0-11ea-aade-65854897e2af.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F96689730-d0e0-11ea-aade-65854897e2af.jpg?alt=media&token=afeec514-ce2b-4005-8752-fde751847904"
      }
    ],
    productNameEnglish:
      "চিকেন বিরানি  Chicken Briyani (not everyday available) - Delivery by taxi, pay as meter-fare. ",
    productPrice: "6",
    productSupplier: "BCS SHOP",
    searchText: "চিকেন বিরানি ",
    sortOrder: "a",
    supplierContactName: "Ahmed Fayyaz",
    supplierContactPhone: "97861239",
    unit: "1 serving ",
    updateDateTime: "Tue 11-08-20 6:44 pm",
    count: 24
  },
  {
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    isPopular: "YES",
    key: "-MA4Da4f67pdMPLcn-m-",
    photos: [
      {
        imageName: "b373dcf0-bf82-11ea-85e3-735b22b1a0db.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fb373dcf0-bf82-11ea-85e3-735b22b1a0db.jpg?alt=media&token=63926f40-da9c-467b-b58b-0a8bffae0475"
      }
    ],
    productNameEnglish: "Drumstick",
    productPrice: "6.50",
    productSupplier: "BCS SHOP",
    searchText: "সইজনা সাজনা ",
    sortOrder: "a",
    sourceSupplier: "MADURAI MEENAKSHI MINIMART",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1kg",
    updateDateTime: "03/08/2020 04:26:43",
    count: 24
  },
  {
    availability: "AVAILABLE",
    category: "রান্না করা খাবার",
    key: "-MCRAQqB_mm1I7ffCCQg",
    photos: [
      {
        imageName: "9b0f9e40-c812-11ea-99a6-3f4f89ed7cd9.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F9b0f9e40-c812-11ea-99a6-3f4f89ed7cd9.jpg?alt=media&token=b8d00adb-4a78-4692-a08b-d9742444d78c"
      }
    ],
    productNameEnglish:
      "মাছের মাথা fish head curry Small - Delivery by taxi, pay as meter-fare. ",
    productPrice: "4",
    productSupplier: "BCS SHOP",
    sortOrder: "a",
    supplierContactName: "Ahmed Fayyaz",
    supplierContactPhone: "97861239",
    unit: "1 serving ",
    updateDateTime: "Tue 11-08-20 6:46 pm",
    count: 23
  },
  {
    availability: "AVAILABLE",
    category: "EGGS DAIRY",
    isPopular: "YES",
    key: "-MBZLVLQXyTSh5pehqLR",
    photos: [
      {
        imageName: "0b0d3e60-bf8e-11ea-85e3-735b22b1a0db.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F0b0d3e60-bf8e-11ea-85e3-735b22b1a0db.jpg?alt=media&token=98d5462b-d434-4893-a76e-e90c91f9bca5"
      }
    ],
    productNameEnglish: "Gardenia Super Soft Wholemeal Bread",
    productPrice: "3.5",
    productSupplier: "BCS SHOP",
    searchText: "পাউরুটি পাওরোটি ",
    sortOrder: "g",
    supplierContactName: "Ahmed Fayyaz",
    supplierContactPhone: "97861239",
    unit: "600gm pkt",
    updateDateTime: "03/08/2020 03:40:48",
    count: 23
  },
  {
    availability: "AVAILABLE",
    category: "DRINKS DESSERT",
    photos: [
      {
        imageName: "b936ee50-f7ce-11ea-9ca4-275d4c37dc1b.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Fb936ee50-f7ce-11ea-9ca4-275d4c37dc1b.jpg?alt=media&token=c1f3cd55-0ebd-423e-9f7b-26c46189b56f"
      }
    ],
    productNameEnglish: "Pran lachcha shemi",
    productPrice: "1.70",
    productSupplier: "BCS SHOP",
    searchText: " lachcha shemi",
    sortOrder: "a",
    supplierContactName: "Ismita",
    supplierContactPhone: "userMobile",
    unit: "200g",
    updateDateTime: "Wed 16-09-20 11:43 am",
    key: "-MHK-YgxQtovzCL12aCX",
    count: 23
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    isPopular: "YES",
    key: "-M9aDmJfZ26UqwhujLhA",
    photos: [
      {
        imageName: "2903cc10-ac4f-11ea-95e2-e74f5187871b.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F2903cc10-ac4f-11ea-95e2-e74f5187871b.jpg?alt=media&token=5157bf34-ad86-474d-bf50-f6401dca9beb"
      }
    ],
    productNameEnglish: "CUMIN POWDER",
    productPrice: "3.50",
    productSupplier: "BCS SHOP",
    searchText: "জিরার গুঁড়া ",
    sortOrder: "a",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1 packet",
    updateDateTime: "17/07/2020 07:58:13",
    count: 23
  },
  {
    availability: "AVAILABLE",
    category: "EGGS DAIRY",
    isPopular: "YES",
    key: "-MABjJi6SUbQ8eTcAd04",
    photos: [
      {
        imageName: "197d5b00-bc51-11ea-b7df-33e703b87300.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F197d5b00-bc51-11ea-b7df-33e703b87300.jpg?alt=media&token=062360d1-e98d-411a-af84-081a86567545"
      }
    ],
    productNameEnglish: "Enricos Instant Milk Powder",
    productPrice: "10",
    productSupplier: "BCS SHOP",
    searchText: "milk dud dood powder ধুদ ",
    sortOrder: "c",
    supplierContactName: "Ahmed Fayyaz",
    supplierContactPhone: "97861239",
    unit: "635gm",
    updateDateTime: "03/08/2020 03:55:05",
    count: 22
  },
  {
    author: "+6589050302",
    category: "COOKING OIL INGREDIENTS",
    isPopular: "YES",
    key: "-M9bFo5eMFcy5tHOyT4I",
    photos: [
      {
        imageName: "bab43780-ac77-11ea-8ded-437354ec7423.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fbab43780-ac77-11ea-8ded-437354ec7423.jpg?alt=media&token=963e0410-83b1-42fc-8b27-114977dd6974"
      }
    ],
    productNameEnglish: "Vegetable oil",
    productPrice: "6.20",
    productSupplier: "BCS SHOP",
    searchText: "তেল তৈল",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "3L Bottle",
    updateDateTime: "29/07/2020 02:40:52",
    count: 22
  },
  {
    availability: "AVAILABLE",
    category: "MEAT FISH",
    isPopular: "YES",
    key: "-M9YVFGS1aZS8hhaFMb-",
    photos: [
      {
        imageName: "e35086a0-abe4-11ea-99a0-ada8a2be9f1b.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fe35086a0-abe4-11ea-99a0-ada8a2be9f1b.jpg?alt=media&token=e2323664-15e7-4ee9-920c-b765fbb86483"
      }
    ],
    productNameEnglish: "Fish baby fish",
    productPrice: "4",
    productSupplier: "BCS SHOP",
    searchText: "ছোট মাছ",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: " 1 packet",
    updateDateTime: "Sun 20-12-20 11:28 pm",
    count: 22
  },
  {
    availability: "AVAILABLE",
    category: "OTHERS",
    key: "-MFYfAtBRvgQShD8sJic",
    photos: [
      {
        imageName: "9d69ead0-e683-11ea-9786-7f7137f3f585.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F9d69ead0-e683-11ea-9786-7f7137f3f585.jpg?alt=media&token=e81bf61a-6b93-4c43-849e-9bc8ac156da7"
      }
    ],
    productNameEnglish: "BD Lungi",
    productPrice: "8",
    productSupplier: "BCS SHOP",
    searchText: "Lungi",
    sortOrder: "a",
    supplierContactName: "Ismita",
    supplierContactPhone: "userMobile",
    unit: "1 pc",
    updateDateTime: "Tue 29-09-20 10:26 am",
    count: 21
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    isPopular: "YES",
    key: "-M9aTVD1cwIwhtaqReNX",
    photos: [
      {
        imageName: "f04821a0-ac58-11ea-bbe4-619ccaa778ae.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ff04821a0-ac58-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=b3c70bc6-b839-4717-8275-0a13fd2d023e"
      }
    ],
    productNameEnglish: "NIGELLA SEEDS ",
    productPrice: "2.50",
    productSupplier: "BCS SHOP",
    searchText: "কালোজিরা",
    sortOrder: "a",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1 pkt ",
    updateDateTime: "23/07/2020 12:50:01",
    count: 21
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    photos: [
      {
        imageName: "08d9b330-f7ce-11ea-9ca4-275d4c37dc1b.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F08d9b330-f7ce-11ea-9ca4-275d4c37dc1b.jpg?alt=media&token=0ab0d7ab-a6f5-4784-988c-7fb85cbd6ea5"
      }
    ],
    productNameEnglish: "Saffy sunflower",
    productPrice: "14",
    productSupplier: "BCS SHOP",
    sortOrder: "a",
    supplierContactName: "Ismita",
    supplierContactPhone: "userMobile",
    unit: "5 L",
    updateDateTime: "Wed 16-09-20 11:38 am",
    key: "-MHJzQbjEXxFWdlUEMSV",
    count: 20
  },
  {
    availability: "AVAILABLE",
    category: "TUPPERWARE CONTAINER",
    isPopular: "YES",
    key: "-M9a2COGsCqlkCzrn6zP",
    photos: [
      {
        imageName: "5c267b30-ac48-11ea-ba1a-4bcfa8bf5006.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F5c267b30-ac48-11ea-ba1a-4bcfa8bf5006.jpg?alt=media&token=b7299a94-a39a-4d4b-afba-fff28c83d61a"
      }
    ],
    productNameEnglish: "Plastic bag ",
    productPrice: "0.70",
    productSupplier: "BCS SHOP",
    searchText: "প্লাষ্টিক প্যাকেট ",
    sortOrder: "x",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1 packet",
    updateDateTime: "23/07/2020 12:55:53",
    count: 20
  },
  {
    availability: "OUT OF STOCK, TOPPING UP IN PROGRESS",
    category: "DRINKS DESSERT",
    isPopular: "YES",
    key: "-MA-oFKOeZeM-mQuLaZ3",
    photos: [
      {
        imageName: "518409f0-c100-11ea-8470-83fbeadd4a74.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F518409f0-c100-11ea-8470-83fbeadd4a74.jpg?alt=media&token=fd0b2094-6d22-4412-b912-9bbf77e8da93"
      }
    ],
    productNameEnglish: "Lachcha Shemai",
    productPrice: "1.50",
    productSupplier: "BCS SHOP",
    searchText: "লাচ্ছা সেমাই ",
    sortOrder: "a",
    sourceSupplier: "TRISHA EXPORT & IMPORT PTE LTD MINIMART",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "125g Packet",
    updateDateTime: "Wed 16-09-20 11:38 am",
    count: 19
  },
  {
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    isPopular: "YES",
    key: "-M9YANJFg1D08vwrvhm1",
    photos: [
      {
        imageName: "24b72040-f898-11ea-aaa8-a9cfb87a7f3a.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F24b72040-f898-11ea-aaa8-a9cfb87a7f3a.jpg?alt=media&token=7a26b0b8-9da8-4697-a324-15de9739248f"
      }
    ],
    productNameEnglish: "Green Plantains banana ",
    productPrice: "6.00",
    productSupplier: "BCS SHOP",
    searchText: "কাঁচা কলা ",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1kg",
    updateDateTime: "Thu 17-09-20 11:44 am",
    count: 19
  },
  {
    availability: "AVAILABLE",
    category: "OTHERS",
    photos: [
      {
        imageName: "13a4cb20-e684-11ea-9786-7f7137f3f585.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F13a4cb20-e684-11ea-9786-7f7137f3f585.jpg?alt=media&token=c8135dfc-00cc-4bb0-a557-ddfd23c852c9"
      }
    ],
    productNameEnglish: "BD Gamsa",
    productPrice: "4.5",
    productSupplier: "BCS SHOP",
    searchText: "Gamsa",
    sortOrder: "a",
    supplierContactName: "Ismita",
    supplierContactPhone: "userMobile",
    unit: "1 pc",
    updateDateTime: "Tue 25-08-20 11:36 am",
    key: "-MFYfxsA5OQoH8IP5nlX",
    count: 19
  },
  {
    availability: "AVAILABLE",
    category: "SNACKS DRY FOOD",
    isPopular: "",
    key: "-MHFul2QZyxooWaFH1y6",
    photos: [
      {
        imageName: "2d8bc640-f72f-11ea-885a-2b4d96b2f26b.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F2d8bc640-f72f-11ea-885a-2b4d96b2f26b.jpg?alt=media&token=f4f0d783-4812-45c4-b3e5-20b781d6caaf"
      }
    ],
    productNameEnglish: "Muri moa 1 jar",
    productPrice: "3",
    productSupplier: "BCS SHOP",
    searchText: "Moa",
    sortOrder: "a",
    supplierContactName: "Ismita",
    supplierContactPhone: "userMobile",
    unit: "400g",
    updateDateTime: "Tue 15-09-20 4:50 pm",
    count: 19
  },
  {
    category: "TOILETRIES",
    key: "-M9fcF5ZkBOD12P39W6C",
    photos: [
      {
        imageName: "2742e450-ad22-11ea-bbe8-977967140bbe.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F2742e450-ad22-11ea-bbe8-977967140bbe.jpg?alt=media&token=20a426d3-5a61-41c0-bf5d-cac18dc2f593"
      }
    ],
    productNameEnglish: "Toothpost colgate advanced white valuepack",
    productPrice: "6.5",
    productSupplier: "BCS SHOP",
    sortOrder: "x",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "160gm×2pc",
    updateDateTime: "04/07/2020 11:21:01",
    count: 19
  },
  {
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    isPopular: "YES",
    key: "-M9cMHEZQIK86s60YiGI",
    photos: [
      {
        imageName: "178554e0-bdac-11ea-8ba8-ddb60ef370d4.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F178554e0-bdac-11ea-8ba8-ddb60ef370d4.jpg?alt=media&token=1430bbd5-0925-4ce0-850c-99f5ed839fce"
      }
    ],
    productNameEnglish: "PAPAYA (1kg)",
    productPrice: "5",
    productSupplier: "BCS SHOP",
    searchText: "paka pepe পাকা পেঁপে ",
    sortOrder: "a",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1kg",
    updateDateTime: "23/07/2020 11:38:24",
    count: 18
  },
  {
    availability: "AVAILABLE",
    category: "DRINKS DESSERT",
    isPopular: "YES",
    key: "-M9aRmMLeT1fzaHZUOLK",
    photos: [
      {
        imageName: "eb144d90-ac57-11ea-985e-71484f367323.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Feb144d90-ac57-11ea-985e-71484f367323.jpg?alt=media&token=3d7a2556-c483-41e1-9b7f-2cb2304f1474"
      }
    ],
    productNameEnglish: "Horlicks refill ",
    productPrice: "7.90",
    productSupplier: "BCS SHOP",
    searchText: "হরলিক্স ",
    sortOrder: "g",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "400g",
    updateDateTime: "17/07/2020 07:41:20",
    count: 18
  },
  {
    category: "MEAT FISH",
    isPopular: "YES",
    key: "-M9zp2dHatratHCAkQ7R",
    photos: [
      {
        imageName: "6448bd80-b037-11ea-9e6b-fd3fc5d44f8f.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F6448bd80-b037-11ea-9e6b-fd3fc5d44f8f.jpg?alt=media&token=5c22ec8a-4c8c-4e1f-be8f-b627ac0b6929"
      }
    ],
    productDescription: "1pic 600G to 900G.",
    productNameEnglish: "Ilish Fish - Medium",
    productPrice: "25",
    productSupplier: "BCS SHOP",
    searchText: "ilish elis elish hisla ইলিশ ",
    sortOrder: "a",
    sourceSupplier: "TERRY TRADING CO PTE LTD",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1kg",
    updateDateTime: "03/08/2020 05:24:13",
    count: 18
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    isPopular: "YES",
    key: "-M9b3EfDyq60NlPy0uO8",
    photos: [
      {
        imageName: "d6304170-e8db-11ea-b634-e7e7c4cb042d.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Fd6304170-e8db-11ea-b634-e7e7c4cb042d.jpg?alt=media&token=a556f9c9-2e21-463f-8d57-9cb517b61bd6"
      }
    ],
    productNameEnglish: "ATTA Flour",
    productPrice: "1.80",
    productSupplier: "BCS SHOP",
    searchText: "atta",
    sortOrder: "a",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1Kg Packet",
    updateDateTime: "Fri 28-08-20 11:09 am",
    count: 18
  },
  {
    availability: "AVAILABLE",
    category: "রান্না করা খাবার",
    key: "-MCQyJtJM1kmln_OE3uJ",
    photos: [
      {
        imageName: "9f409760-c80a-11ea-99a6-3f4f89ed7cd9.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F9f409760-c80a-11ea-99a6-3f4f89ed7cd9.jpg?alt=media&token=4f4eccb4-d964-40bf-a792-e19c40a1c92a"
      }
    ],
    productNameEnglish:
      "পেঁপে ভর্তা  mashed papaya - Delivery by taxi, pay as meter-fare. ",
    productPrice: "1",
    productSupplier: "BCS SHOP",
    searchText: "",
    sortOrder: "a",
    supplierContactName: "Ahmed Fayyaz",
    supplierContactPhone: "97861239",
    unit: "1 serving ",
    updateDateTime: "Tue 11-08-20 6:48 pm",
    count: 17
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    key: "-M9fKkWFv5n6-RqH2DpL",
    photos: [
      {
        imageName: "07832630-ad17-11ea-8bc0-03f48af12a9c.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F07832630-ad17-11ea-8bc0-03f48af12a9c.jpg?alt=media&token=13bbb1f5-cd46-42c8-82d7-ff23b01d0a55"
      }
    ],
    productNameEnglish: "PAGODA SEA SALT",
    productPrice: "0.90",
    productSupplier: "BCS SHOP",
    searchText: "লবণ লবন",
    sortOrder: "d",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "500g",
    updateDateTime: "17/07/2020 08:50:15",
    count: 17
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    isPopular: "YES",
    key: "-MHJwuApldBM-FqskEBo",
    photos: [
      {
        imageName: "a10a7e70-f7cc-11ea-9ca4-275d4c37dc1b.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Fa10a7e70-f7cc-11ea-9ca4-275d4c37dc1b.jpg?alt=media&token=2f1cd8b1-8072-43f0-bb05-11c203012f00"
      }
    ],
    productNameEnglish: "pran chilli powder",
    productPrice: "3.50",
    productSupplier: "BCS SHOP",
    searchText: "chilli powder",
    sortOrder: "a",
    supplierContactName: "Ismita",
    supplierContactPhone: "userMobile",
    unit: "250g",
    updateDateTime: "Wed 16-09-20 5:33 pm",
    count: 17
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    isPopular: "YES",
    key: "-MA-stIMYdnOFUC6-HLs",
    photos: [
      {
        imageName: "aa6a0610-c0ff-11ea-8470-83fbeadd4a74.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Faa6a0610-c0ff-11ea-8470-83fbeadd4a74.jpg?alt=media&token=034120b7-cba3-4703-a626-c8c8c4ec2234"
      }
    ],
    productNameEnglish: "RADHUNI GARAM MASALA POWDER ",
    productPrice: "2.20",
    productSupplier: "BCS SHOP",
    searchText: "গরম মশলা ",
    sortOrder: "a",
    sourceSupplier: "RAJDHANI ENTERPRISE PTE LTD",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "80g",
    updateDateTime: "Tue 18-08-20 8:37 am",
    count: 16
  },
  {
    availability: "AVAILABLE",
    category: "DRINKS DESSERT",
    isPopular: "YES",
    key: "-M9pvV6nBjpjHiV6X0CV",
    photos: [
      {
        imageName: "94c360c0-aeb4-11ea-a578-077a102352bb.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F94c360c0-aeb4-11ea-a578-077a102352bb.jpg?alt=media&token=72ca56df-f33d-4162-b57c-e093b5130775"
      }
    ],
    productNameEnglish: "Jaggery / Gour / Gur",
    productPrice: "3.5",
    productSupplier: "BCS SHOP",
    searchText: "gur sugare cane মিঠাই ",
    sortOrder: "a",
    sourceSupplier: "TERRY TRADING CO PTE LTD",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: " 500gm",
    updateDateTime: "03/08/2020 06:21:02",
    count: 16
  },
  {
    availability: "AVAILABLE",
    category: "DRINKS DESSERT",
    isPopular: "YES",
    key: "-MB8X5eB7StmB_sv4Fli",
    photos: [
      {
        imageName: "437a1230-bb76-11ea-9bec-f98d55a4d196.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F437a1230-bb76-11ea-9bec-f98d55a4d196.jpg?alt=media&token=b6760277-0838-48c4-a15c-87a32db02106"
      }
    ],
    productNameEnglish: "PRAN Orange Powder ",
    productPrice: "4.50",
    productSupplier: "BCS SHOP",
    searchText: "orange juice powder অরেঞ্জ জুস",
    sortOrder: "g",
    sourceSupplier: "GLOBAL PIONEEER PTE LTD",
    supplierContactName: "Ahmed Fayyaz",
    supplierContactPhone: "97861239",
    unit: "500ml",
    updateDateTime: "03/08/2020 03:44:33",
    count: 16
  },
  {
    availability: "AVAILABLE",
    category: "COSMETICS",
    key: "-M9qZ5EiIDdsa9Zg3LpE",
    photos: [
      {
        imageName: "5bcb99e0-aecd-11ea-b774-7962c3b67908.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F5bcb99e0-aecd-11ea-b774-7962c3b67908.jpg?alt=media&token=851cd3dd-5f35-4a51-a06d-e274dd956981"
      }
    ],
    productNameEnglish: "Garnier Light Foam Facial Wash",
    productPrice: "6.8",
    productSupplier: "BCS SHOP",
    searchText: "ফেইস ওয়াশ ",
    sortOrder: "d",
    sourceSupplier: "MUSTAFA CENTRE",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1pc of 100ML",
    updateDateTime: "03/08/2020 06:01:46",
    count: 16
  },
  {
    category: "MEAT FISH",
    isPopular: "YES",
    key: "-MA-081YlnomuMShqhCU",
    photos: [
      {
        imageName: "b2e7ad50-b03e-11ea-9737-25db4b55bc7b.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fb2e7ad50-b03e-11ea-9737-25db4b55bc7b.jpg?alt=media&token=a3257c88-e921-4c8d-8c84-7b8ba4eb1f30"
      }
    ],
    productNameEnglish: "Tilapia ",
    productPrice: "6",
    productSupplier: "BCS SHOP",
    sortOrder: "a",
    sourceSupplier: "AYSHA SUPERMARKET PTE LTD",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1KG",
    updateDateTime: "03/08/2020 05:00:12",
    count: 16
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    isPopular: "YES",
    key: "-MA-s21eYOIHIgZgZ47u",
    photos: [
      {
        imageName: "01912890-f7d0-11ea-9ca4-275d4c37dc1b.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F01912890-f7d0-11ea-9ca4-275d4c37dc1b.jpg?alt=media&token=f0c6568d-56df-442a-b030-aca55b7ae8e9"
      }
    ],
    productNameEnglish: "PRAN Garam Masala",
    productPrice: "3.50",
    productSupplier: "BCS SHOP",
    searchText: "গরম মসলা ",
    sortOrder: "a",
    sourceSupplier: "KHAN PRODUCTS PTE LTD.",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "130g",
    updateDateTime: "Wed 16-09-20 11:54 am",
    count: 16
  },
  {
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    key: "-M9az5-Me-d8aZxa8GQ6",
    photos: [
      {
        imageName: "ef2c6410-f899-11ea-aaa8-a9cfb87a7f3a.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Fef2c6410-f899-11ea-aaa8-a9cfb87a7f3a.jpg?alt=media&token=cf50a739-762a-4e82-a0c5-c51e14099503"
      }
    ],
    productNameEnglish: "SWEET POTATOES ",
    productPrice: "5",
    productSupplier: "BCS SHOP",
    searchText: "মিষ্টি আলু ",
    sortOrder: "d",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1Kg",
    updateDateTime: "Fri 02-10-20 11:09 am",
    count: 16
  },
  {
    category: "RICE DAAL NOODLES",
    key: "-M9maT0lAzHbQKcGlLMR",
    photos: [
      {
        imageName: "a14a4b60-ae32-11ea-8070-f3cc7bbcb5d1.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fa14a4b60-ae32-11ea-8070-f3cc7bbcb5d1.jpg?alt=media&token=7b230263-aba4-444d-a265-51b6a6df402a"
      }
    ],
    productNameEnglish: "Ooty Pooni Rice - By Sri Ambikas",
    productPrice: "9",
    productSupplier: "BCS SHOP",
    sortOrder: "b",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "5Kg",
    updateDateTime: "03/08/2020 06:48:19",
    count: 16
  },
  {
    availability: "AVAILABLE",
    category: "DRINKS DESSERT",
    isPopular: "NO",
    key: "-M9aUEBtt43r8qUiG-Jk",
    photos: [
      {
        imageName: "74a5c830-ac59-11ea-abb9-bdb7271566ee.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F74a5c830-ac59-11ea-abb9-bdb7271566ee.jpg?alt=media&token=b1d26395-81c3-4f04-859f-5e1a62451811"
      }
    ],
    productNameEnglish: "Super coffee",
    productPrice: "6",
    productSupplier: "BCS SHOP",
    searchText: "কফি ",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: " 40 pkts",
    updateDateTime: "23/07/2020 12:47:40",
    count: 15
  },
  {
    availability: "AVAILABLE",
    category: "EGGS DAIRY",
    key: "-M9b6-8mJq4PnN0R5X6L",
    photos: [
      {
        imageName: "bba5f940-ac71-11ea-8ded-437354ec7423.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fbba5f940-ac71-11ea-8ded-437354ec7423.jpg?alt=media&token=cb0a2a4e-70fb-468c-9348-6340c159e0f6"
      }
    ],
    productNameEnglish: "Bread",
    productPrice: "3.8",
    productSupplier: "BCS SHOP",
    searchText: "পাউরুটি পাওরোটি",
    sortOrder: "d",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1 Pkt",
    updateDateTime: "06/07/2020 09:40:11",
    count: 14
  },
  {
    availability: "AVAILABLE",
    category: "রান্না করা খাবার",
    photos: [
      {
        imageName: "dd057e00-f986-11ea-98b2-bdfbde6255e9.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Fdd057e00-f986-11ea-98b2-bdfbde6255e9.jpg?alt=media&token=3a7a79ed-35e7-4cfa-bd33-2f2c88eb7355"
      }
    ],
    productNameEnglish: "ভুড়ি রান্না।",
    productPrice: "5",
    productSupplier: "BCS SHOP",
    searchText: "vure ranna.",
    sortOrder: "1",
    supplierContactName: "Ismita",
    supplierContactPhone: "userMobile",
    unit: "1 serving",
    updateDateTime: "Fri 18-09-20 4:13 pm",
    key: "-MHVGfdf1MsX6RnFMzmV",
    count: 14
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    isPopular: "YES",
    key: "-M9bGBYZ5VvgyNm1gak2",
    photos: [
      {
        imageName: "e0b871f0-c804-11ea-9d1d-d9f4bc315562.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fe0b871f0-c804-11ea-9d1d-d9f4bc315562.jpg?alt=media&token=32776a49-4223-4e2c-9b57-805ce21daad6"
      }
    ],
    productNameEnglish: "Duck oil 2L",
    productPrice: "6",
    productSupplier: "BCS SHOP",
    searchText: "তেল তৈল ",
    sortOrder: "d",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "2L",
    updateDateTime: "17/07/2020 04:09:55",
    count: 14
  },
  {
    availability: "AVAILABLE",
    category: "SNACKS DRY FOOD",
    key: "-MMUcA_ECvMzzCGqXyd6",
    photos: [
      {
        imageName: "8068ba40-2a41-11eb-bc77-4b3aa6852856.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F8068ba40-2a41-11eb-bc77-4b3aa6852856.jpg?alt=media&token=e0c10147-5cad-43d6-a818-0fe5a78abc05"
      }
    ],
    productDescription: "Peanut Biscuit",
    productNameEnglish: "Pran Cookies Peanut Biscuit",
    productPrice: "3.5",
    productSupplier: "BCS SHOP",
    searchText: "cookies peanut biscuit",
    sortOrder: "G",
    supplierContactName: "Kabir",
    supplierContactPhone: "94562455",
    unit: "Bottle",
    updateDateTime: "Fri 27-11-20 11:30 am",
    count: 14
  },
  {
    category: "FRUITS VEGETABLES ",
    isPopular: "YES",
    key: "-MA0Gzo9OmETYuiqg36L",
    photos: [
      {
        imageName: "c0663890-bc58-11ea-b7df-33e703b87300.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fc0663890-bc58-11ea-b7df-33e703b87300.jpg?alt=media&token=39849a01-d994-4832-ac04-15fca8882d58"
      }
    ],
    productNameEnglish: "Strawberries",
    productPrice: "4.50",
    productSupplier: "BCS SHOP",
    sortOrder: "a",
    sourceSupplier: "Sheng siong ",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "250g",
    updateDateTime: "Mon 21-09-20 3:39 pm",
    count: 13
  },
  {
    availability: "AVAILABLE",
    category: "DRINKS DESSERT",
    isPopular: "YES",
    key: "-MAZejYrhHO1ZLsEJ3AF",
    photos: [
      {
        imageName: "496b2ba0-bc4f-11ea-b7df-33e703b87300.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F496b2ba0-bc4f-11ea-b7df-33e703b87300.jpg?alt=media&token=684a42d8-1e00-4d42-9f9a-ad6f514604f9"
      }
    ],
    productNameEnglish: "Rock Sugar",
    productPrice: "2.20",
    productSupplier: "BCS SHOP",
    searchText: "mirchi মির্চি মির্ছি ",
    sortOrder: "g",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "350g",
    updateDateTime: "03/08/2020 03:46:25",
    count: 13
  },
  {
    author: "+6589050302",
    availability: "AVAILABLE",
    category: "LAUNDRY CLEANING",
    isPopular: "YES",
    key: "-MBZOXMuKXHpRPhG7DoH",
    photos: [
      {
        imageName: "e14e8730-bf8f-11ea-85e3-735b22b1a0db.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fe14e8730-bf8f-11ea-85e3-735b22b1a0db.jpg?alt=media&token=7394dbcb-27e6-4c79-a3d3-250cef082cd9"
      }
    ],
    productNameEnglish: "FAB Detergent Powder - Downy",
    productPrice: "11.50",
    productSupplier: "BCS SHOP",
    searchText: "ওয়াশিং পাউডার কাপড় ধুয়ার পাউডার",
    sortOrder: "g",
    supplierContactName: "Ahmed Fayyaz",
    supplierContactPhone: "97861239",
    unit: "4.7kg",
    updateDateTime: "Thu 06-08-20 12:46 pm",
    count: 13
  },
  {
    availability: "AVAILABLE",
    category: "SNACKS DRY FOOD",
    isPopular: "YES",
    key: "-M9aUeq2jeBQO3RmM6qP",
    photos: [
      {
        imageName: "b42e2010-ac59-11ea-bbe4-619ccaa778ae.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fb42e2010-ac59-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=1388583b-af31-4f72-9810-0a5c20199038"
      }
    ],
    productNameEnglish: "PEANUT ",
    productPrice: "0.80",
    productSupplier: "BCS SHOP",
    searchText: "বাদাম ",
    sortOrder: "a",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "100G",
    updateDateTime: "23/07/2020 12:46:44",
    count: 13
  },
  {
    category: "COOKING OIL INGREDIENTS",
    key: "-M9fWgVH0Saajjgwca01",
    photos: [
      {
        imageName: "4f592d90-ad1e-11ea-9a01-db9ea96fa329.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F4f592d90-ad1e-11ea-9a01-db9ea96fa329.jpg?alt=media&token=25af8b2c-bd2d-4313-bc12-165cd8b23390"
      }
    ],
    productNameEnglish: "OKI PREMIUM SUNFLOWER OIL",
    productPrice: "7.90",
    productSupplier: "BCS SHOP",
    sortOrder: "d",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "2L",
    updateDateTime: "Tue 18-08-20 9:07 am",
    count: 13
  },
  {
    category: "MEAT FISH",
    isPopular: "YES",
    key: "-M9zz8Y5c7-PpsTsEobK",
    photos: [
      {
        imageName: "0d5bd5e0-c5bb-11ea-8edb-cd6b1542138d.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F0d5bd5e0-c5bb-11ea-8edb-cd6b1542138d.jpg?alt=media&token=36469c2b-0749-41a0-ae7a-26f5fca51c98"
      }
    ],
    productNameEnglish: "Catfish",
    productPrice: "7",
    productSupplier: "BCS SHOP",
    sortOrder: "a",
    sourceSupplier: "AYSHA SUPERMARKET PTE LTD",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1KG",
    updateDateTime: "03/08/2020 05:19:27",
    count: 13
  },
  {
    availability: "AVAILABLE",
    category: "RICE DAAL NOODLES",
    isPopular: "YES",
    key: "-M9bESNPxTDsCiuOhYQe",
    photos: [
      {
        imageName: "222cc2f0-bd9f-11ea-9c87-8df410c3c074.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F222cc2f0-bd9f-11ea-9c87-8df410c3c074.jpg?alt=media&token=274dc654-a767-4c6c-906f-f62cc865739b"
      }
    ],
    productNameEnglish: "Channa dhal lentils 500gm",
    productPrice: "2.5",
    productSupplier: "BCS SHOP",
    searchText: "chana dal dhal ডাল",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "500gm",
    updateDateTime: "17/07/2020 08:55:55",
    count: 13
  },
  {
    category: "SNACKS DRY FOOD",
    isPopular: "YES",
    key: "-M9b9n5oKPtCjUoynwer",
    photos: [
      {
        imageName: "f00ecde0-ac73-11ea-8ded-437354ec7423.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ff00ecde0-ac73-11ea-8ded-437354ec7423.jpg?alt=media&token=54d0d0a4-6b52-442c-946e-541d50fa28b9"
      }
    ],
    productNameEnglish: "Biscuits",
    productPrice: "4",
    productSupplier: "BCS SHOP",
    searchText: "sweet biscuit buiskit",
    sortOrder: "d",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1 packet",
    updateDateTime: "04/07/2020 08:46:22",
    count: 12
  },
  {
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    isPopular: "YES",
    key: "-MA4Na2HCRG67mD6NL0z",
    photos: [
      {
        imageName: "80ddab90-bdb6-11ea-8ba8-ddb60ef370d4.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F80ddab90-bdb6-11ea-8ba8-ddb60ef370d4.jpg?alt=media&token=148e4f5f-0c4f-45f9-97a9-eb6a2c3a470d"
      }
    ],
    productNameEnglish: "Sponge Gourd",
    productPrice: "6",
    productSupplier: "BCS SHOP",
    sortOrder: "a",
    sourceSupplier: "Amman trading ",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1kg",
    updateDateTime: "03/08/2020 04:25:41",
    count: 12
  },
  {
    availability: "AVAILABLE",
    category: "রান্না করা খাবার",
    key: "-MCRDjCeuWwGy19C9iJN",
    photos: [
      {
        imageName: "71693af0-c81d-11ea-99a6-3f4f89ed7cd9.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F71693af0-c81d-11ea-99a6-3f4f89ed7cd9.jpg?alt=media&token=4b572523-e57a-4634-8474-893337f38f05"
      }
    ],
    productNameEnglish:
      "মুরগির মাংস  chicken curry - Delivery by taxi, pay as meter-fare. ",
    productPrice: "4 ",
    productSupplier: "BCS SHOP",
    sortOrder: "a",
    supplierContactName: "Ahmed Fayyaz",
    supplierContactPhone: "97861239",
    unit: "1 serving ",
    updateDateTime: "Tue 11-08-20 6:45 pm",
    count: 12
  },
  {
    availability: "AVAILABLE",
    category: "DRINKS DESSERT",
    photos: [
      {
        imageName: "9d552330-2a43-11eb-97e8-9befc076c3e3.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F9d552330-2a43-11eb-97e8-9befc076c3e3.jpg?alt=media&token=73082170-4d97-4773-b699-97a11f23f03c"
      }
    ],
    productDescription: "Milk Tea Sticks",
    productNameEnglish: "Milk Tea Sticks",
    productPrice: "4.95",
    productSupplier: "BCS SHOP",
    searchText: "milk tea",
    sortOrder: "G",
    supplierContactName: "Ahmed Fayyaz",
    supplierContactPhone: "97861239",
    unit: "Bag(25 Sticks)",
    updateDateTime: "Thu 19-11-20 7:46 pm",
    key: "-MMUfeXIb0tl1MtLtJGE",
    count: 12
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    isPopular: "YES",
    key: "-MA-EUUCDoHoerBWyGXD",
    photos: [
      {
        imageName: "575b0190-b047-11ea-9737-25db4b55bc7b.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F575b0190-b047-11ea-9737-25db4b55bc7b.jpg?alt=media&token=f5e170aa-ba5d-4d33-aa9a-70c6627dff4e"
      }
    ],
    productNameEnglish: "RADHUNI Beef Masala",
    productPrice: "3.50",
    productSupplier: "BCS SHOP",
    searchText: "গরুর মাংস মসলা",
    sortOrder: "a",
    sourceSupplier: "KHAN PRODUCTS PTE LTD.",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "68G",
    updateDateTime: "03/08/2020 04:54:49",
    count: 12
  },
  {
    availability: "AVAILABLE",
    category: "EGGS DAIRY",
    key: "-M9bHoKF-2K9TkktZI1L",
    photos: [
      {
        imageName: "eda24870-ac78-11ea-90b2-195942e61adb.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Feda24870-ac78-11ea-90b2-195942e61adb.jpg?alt=media&token=10aa5058-9dc1-4df5-9b5d-ba4eb5adab9c"
      }
    ],
    productNameEnglish: "Cake traditional 1packet",
    productPrice: "2.5",
    productSupplier: "BCS SHOP",
    searchText: "কেক ",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1 pkt",
    updateDateTime: "17/07/2020 03:16:29",
    count: 11
  },
  {
    availability: "AVAILABLE",
    category: "EGGS DAIRY",
    isPopular: "YES",
    key: "-M9ccYf_UiWa3q-Eyubz",
    photos: [
      {
        imageName: "5399f5e0-acad-11ea-ab51-0f18e1d42bbd.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F5399f5e0-acad-11ea-ab51-0f18e1d42bbd.jpg?alt=media&token=21615a34-8ecf-4244-8310-23c58e04ed51"
      }
    ],
    productNameEnglish: "FARMHOUSE FRESH UHT MILK",
    productPrice: "3.50",
    productSupplier: "BCS SHOP",
    searchText: "fresh milk ধুদ ",
    sortOrder: "a",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1L",
    updateDateTime: "23/07/2020 12:28:18",
    count: 11
  },
  {
    category: "EGGS DAIRY",
    isPopular: "YES",
    key: "-M9b4GhsoKiSOk7LB9RD",
    photos: [
      {
        imageName: "8231fc50-ac70-11ea-9366-875156fdc5b0.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F8231fc50-ac70-11ea-9366-875156fdc5b0.jpg?alt=media&token=63f79f59-7260-4728-aac4-89908bf5dab5"
      }
    ],
    productNameEnglish: "HL banana/strawberry milk",
    productPrice: "6",
    productSupplier: "BCS SHOP",
    searchText: "fresh milk",
    sortOrder: "d",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "2 x 1L",
    updateDateTime: "05/07/2020 12:10:24",
    count: 11
  },
  {
    availability: "AVAILABLE",
    category: "RICE DAAL NOODLES",
    isPopular: "YES",
    key: "-M9fZqq9ZQaum3QmTD2W",
    photos: [
      {
        imageName: "407ffdb0-ad20-11ea-9a01-db9ea96fa329.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F407ffdb0-ad20-11ea-9a01-db9ea96fa329.jpg?alt=media&token=234d5097-afd8-47b9-be11-31dbce5f6f5d"
      }
    ],
    productNameEnglish: "MYOJO CHICKEN ABALONE FLAVOURED INSTANT NOODLES ",
    productPrice: "2.5",
    productSupplier: "BCS SHOP",
    sortOrder: "a",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "5 pack 79gm",
    updateDateTime: "17/07/2020 06:53:25",
    count: 11
  },
  {
    category: "MEAT FISH",
    isPopular: "YES",
    key: "-M9zzmXCYPD7EUwz7pRI",
    photos: [
      {
        imageName: "8f6a0e30-c5bb-11ea-8edb-cd6b1542138d.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F8f6a0e30-c5bb-11ea-8edb-cd6b1542138d.jpg?alt=media&token=48e71bcf-2931-464f-b488-ba579dba1e9a"
      }
    ],
    productDescription: "Price not stable  $13~$23.",
    productNameEnglish: "Silver Pomfret",
    productPrice: "15",
    productSupplier: "BCS SHOP",
    sortOrder: "a",
    sourceSupplier: "RAJDHANI ENTERPRISE PTE LTD",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1KG",
    updateDateTime: "03/08/2020 05:19:59",
    count: 11
  },
  {
    author: "+6589050302",
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    key: "-M9aW8grXeHaS2bkydWz",
    photos: [
      {
        imageName: "a2db8130-ac5a-11ea-943a-e361d08112a3.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fa2db8130-ac5a-11ea-943a-e361d08112a3.jpg?alt=media&token=7b6e03c4-43f6-4548-aeb3-0d72cf3688cc"
      }
    ],
    productNameEnglish: "Gold oil 2kg",
    productPrice: "9.80",
    productSupplier: "BCS SHOP",
    searchText: "তেল ",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "2L",
    updateDateTime: "Mon 10-08-20 12:01 pm",
    count: 11
  },
  {
    category: "DRINKS DESSERT",
    key: "-M9b3lrh63IHxC_1Mssm",
    photos: [
      {
        imageName: "4db120f0-ac70-11ea-9366-875156fdc5b0.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F4db120f0-ac70-11ea-9366-875156fdc5b0.jpg?alt=media&token=89f1f325-5fca-465b-88ba-d8436e533a81"
      }
    ],
    productNameEnglish: "Orange juice drink",
    productPrice: "4.5",
    productSupplier: "BCS SHOP",
    sortOrder: "d",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "2L",
    updateDateTime: "05/07/2020 12:14:31",
    count: 11
  },
  {
    availability: "OUT OF STOCK, TOPPING UP IN PROGRESS",
    category: "COOKING OIL INGREDIENTS",
    isPopular: "YES",
    key: "-MAZdpGYWmipvq1nf4Ja",
    photos: [
      {
        imageName: "f27709e0-bc4e-11ea-b7df-33e703b87300.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ff27709e0-bc4e-11ea-b7df-33e703b87300.jpg?alt=media&token=249abff1-d69c-46c5-a563-12c2ce077a2f"
      }
    ],
    productNameEnglish: "Himalay Coriander Powder",
    productPrice: "2.50",
    productSupplier: "BCS SHOP",
    searchText: "ধনিয়ার গুঁড়া ",
    sortOrder: "g",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "125g",
    updateDateTime: "Fri 14-08-20 4:18 pm",
    count: 10
  },
  {
    availability: "AVAILABLE",
    category: "RICE DAAL NOODLES",
    isPopular: "YES",
    key: "-M9bG0Ew_O0J9zgK08Ft",
    photos: [
      {
        imageName: "bd161c50-ac77-11ea-891a-2516dcf49b13.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fbd161c50-ac77-11ea-891a-2516dcf49b13.jpg?alt=media&token=121ac522-9835-41e2-bc69-159b7b01944f"
      }
    ],
    productNameEnglish: "SELF RAISING FLOUR",
    productPrice: "2.80 ",
    productSupplier: "BCS SHOP",
    searchText: "maida mayda fine ata atta আটা ময়দা",
    sortOrder: "d",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1Kg Packet",
    updateDateTime: "17/07/2020 04:13:25",
    count: 10
  },
  {
    availability: "AVAILABLE",
    category: "TOILETRIES",
    key: "-M9b7HZfPuATJUBkTdCs",
    photos: [
      {
        imageName: "91e2cab0-ac72-11ea-83ef-037972cabc05.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F91e2cab0-ac72-11ea-83ef-037972cabc05.jpg?alt=media&token=755f870a-7fbe-4703-bc41-4a71cf5cfed5"
      }
    ],
    productNameEnglish: "DOVE BODY WASH",
    productPrice: "7.5",
    productSupplier: "BCS SHOP",
    sortOrder: "d",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "Btl ",
    updateDateTime: "Wed 02-12-20 10:22 am",
    count: 10
  },
  {
    category: "MEAT FISH",
    isPopular: "YES",
    key: "-M9znavrxvUDOHWhLi0C",
    photos: [
      {
        imageName: "80f4a260-b036-11ea-9e6b-fd3fc5d44f8f.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F80f4a260-b036-11ea-9e6b-fd3fc5d44f8f.jpg?alt=media&token=fe5cdec9-0d8a-47a6-851c-1a6933987683"
      }
    ],
    productDescription: "1pcs is 900gm to 1.5kg",
    productNameEnglish: "Ilish Fish - Large",
    productPrice: "30",
    productSupplier: "BCS SHOP",
    searchText: "elish ilis elis isish fish ইলিশ ",
    sortOrder: "a",
    sourceSupplier: "TERRY TRADING CO PTE LTD",
    supplierContactName: "arif",
    supplierContactPhone: "84124637",
    unit: "1KG ",
    updateDateTime: "03/08/2020 05:24:38",
    count: 10
  },
  {
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    key: "-M9azxw85yqueK8BLY-D",
    photos: [
      {
        imageName: "83655650-f89a-11ea-aaa8-a9cfb87a7f3a.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F83655650-f89a-11ea-aaa8-a9cfb87a7f3a.jpg?alt=media&token=003237b8-013d-48f9-a76a-a63fd9e36fd1"
      }
    ],
    productNameEnglish: "MANGO ",
    productPrice: "3.50",
    productSupplier: "BCS SHOP",
    searchText: "আম ",
    sortOrder: "d",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1 pc",
    updateDateTime: "Mon 21-09-20 3:34 pm",
    count: 10
  },
  {
    author: "+6589050302",
    availability: "AVAILABLE",
    category: "EGGS DAIRY",
    isPopular: "NO",
    key: "-M9Y03q7FRuMQjK5r4uT",
    photos: [
      {
        imageName: "2e329130-c103-11ea-8470-83fbeadd4a74.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F2e329130-c103-11ea-8470-83fbeadd4a74.jpg?alt=media&token=4beb50e2-d473-4791-b9ba-e679e035548d"
      }
    ],
    productNameEnglish: "Yogurt ",
    productPrice: "1.10",
    productSupplier: "BCS SHOP",
    searchText: "দই দধি ",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1pc",
    updateDateTime: "Wed 16-09-20 8:08 am",
    count: 10
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    photos: [
      {
        imageName: "2a89fc70-01fa-11eb-b3c7-236ec5a8a539.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F2a89fc70-01fa-11eb-b3c7-236ec5a8a539.jpg?alt=media&token=7c5f9ad7-c20f-4e07-bbda-15170cc0a6a7"
      }
    ],
    productNameEnglish: "Kasundi ",
    productPrice: "2",
    productSupplier: "BCS SHOP",
    searchText: "Kasundi ",
    sortOrder: "a",
    supplierContactName: "Ismita",
    supplierContactPhone: "userMobile",
    unit: "300g",
    updateDateTime: "Tue 29-09-20 10:19 am",
    key: "-MIMe1KwabBD0YmmG3qm",
    count: 10
  },
  {
    category: "COOKING OIL INGREDIENTS",
    key: "-M9fY8PRxRRgFSg4VoDC",
    photos: [
      {
        imageName: "355bc6e0-ad1f-11ea-9a01-db9ea96fa329.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F355bc6e0-ad1f-11ea-9a01-db9ea96fa329.jpg?alt=media&token=867996e2-0035-4b7e-b3f9-314b813338ec"
      }
    ],
    productNameEnglish: "GOLDEN CIRCLE SUNFLOWER OIL",
    productPrice: "15",
    productSupplier: "BCS SHOP",
    sortOrder: "d",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "5L",
    updateDateTime: "04/07/2020 11:50:50",
    count: 9
  },
  {
    availability: "AVAILABLE",
    category: "RICE DAAL NOODLES",
    isPopular: "YES",
    key: "-M9aVKAJjayljKS9Th5s",
    photos: [
      {
        imageName: "2b985630-f899-11ea-aaa8-a9cfb87a7f3a.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F2b985630-f899-11ea-aaa8-a9cfb87a7f3a.jpg?alt=media&token=1e4a7b65-b3c4-453c-a5c3-5d45e4d79ba4"
      }
    ],
    productNameEnglish: "Rice ",
    productPrice: "7.8",
    productSupplier: "BCS SHOP",
    searchText: "চাউল",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "5kg",
    updateDateTime: "Thu 17-09-20 11:52 am",
    count: 9
  },
  {
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    isPopular: "YES",
    key: "-MA4RT70EXT1R-MsMAVd",
    photos: [
      {
        imageName: "0046bbe0-bdb4-11ea-8ba8-ddb60ef370d4.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F0046bbe0-bdb4-11ea-8ba8-ddb60ef370d4.jpg?alt=media&token=3b0fb145-bf3f-429f-b4fe-bd7a7ca49ca7"
      }
    ],
    productNameEnglish: "Ridge Gourd",
    productPrice: "6.20",
    productSupplier: "BCS SHOP",
    searchText: "jinga zinga jingha ",
    sortOrder: "a",
    sourceSupplier: "Veg mart ",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1kg",
    updateDateTime: "03/08/2020 04:24:11",
    count: 9
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    isPopular: "YES",
    key: "-M9aSP39jNTjGW4ykAwz",
    photos: [
      {
        imageName: "4b14b810-ac58-11ea-bbe4-619ccaa778ae.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F4b14b810-ac58-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=6247c545-4ff3-4cc8-8671-6d198ed11612"
      }
    ],
    productNameEnglish: "BLACK PEPPER ",
    productPrice: "3.20",
    productSupplier: "BCS SHOP",
    searchText: "গোল মরিচ",
    sortOrder: "a",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1pkt",
    updateDateTime: "23/07/2020 12:51:48",
    count: 9
  },
  {
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    isPopular: "YES",
    key: "-M9YXC8HFxzWybtMNJwR",
    photos: [
      {
        imageName: "0bad0e60-abe6-11ea-99a0-ada8a2be9f1b.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F0bad0e60-abe6-11ea-99a0-ada8a2be9f1b.jpg?alt=media&token=31a8943b-38a7-4aac-9cc1-b10e7eddbba0"
      }
    ],
    productNameEnglish: "yardlong long bean",
    productPrice: "4.5",
    productSupplier: "BCS SHOP",
    searchText: "বরবটি ",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1kg",
    updateDateTime: "17/07/2020 08:33:48",
    count: 9
  },
  {
    availability: "AVAILABLE",
    category: "COSMETICS",
    isPopular: "YES",
    key: "-MA-vTilQKSysy5VlORf",
    photos: [
      {
        imageName: "905237c0-bc59-11ea-b7df-33e703b87300.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F905237c0-bc59-11ea-b7df-33e703b87300.jpg?alt=media&token=b5a6f868-7444-4f54-bd7e-e85fd004c443"
      }
    ],
    productNameEnglish: "Fair & Lovely Daily Whitening Cream",
    productPrice: "5.20",
    productSupplier: "BCS SHOP",
    searchText: "ফেইস ক্রিম",
    sortOrder: "x",
    sourceSupplier: "MUSTAFA CENTRE",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "25G",
    updateDateTime: "17/07/2020 06:31:59",
    count: 9
  },
  {
    availability: "OUT OF STOCK, TOPPING UP IN PROGRESS",
    category: "COOKING OIL INGREDIENTS",
    isPopular: "YES",
    key: "-MAZe6naCD3X8bi9CORd",
    photos: [
      {
        imageName: "26a8dae0-bc4f-11ea-b7df-33e703b87300.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F26a8dae0-bc4f-11ea-b7df-33e703b87300.jpg?alt=media&token=4ec20587-3bbf-4fe4-a841-948d61bb46d9"
      }
    ],
    productNameEnglish: "Himalay Cumin Powder",
    productPrice: "3.50",
    productSupplier: "BCS SHOP",
    searchText: "zira jeera jira জিরা ",
    sortOrder: "g",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "125g",
    updateDateTime: "Fri 14-08-20 4:18 pm",
    count: 8
  },
  {
    category: "KITCHEN DINING",
    isPopular: "YES",
    key: "-M9agD1h6myA-aTwEf9n",
    photos: [
      {
        imageName: "4e8585c0-ac61-11ea-bbe4-ef7bbce60778.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F4e8585c0-ac61-11ea-bbe4-ef7bbce60778.jpg?alt=media&token=1aac9faa-a6d2-4d17-8f9d-69f4b8cd7d6a"
      }
    ],
    productNameEnglish: "Dish plate washing sumu ",
    productPrice: "2.5",
    productSupplier: "BCS SHOP",
    sortOrder: "x",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1 container",
    updateDateTime: "05/07/2020 12:52:00",
    count: 8
  },
  {
    availability: "AVAILABLE",
    category: "রান্না করা খাবার",
    key: "-MCRAxQoO6xt9ez_xpWK",
    photos: [
      {
        imageName: "d4c358c0-c812-11ea-99a6-3f4f89ed7cd9.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fd4c358c0-c812-11ea-99a6-3f4f89ed7cd9.jpg?alt=media&token=b868a8b5-6897-4cd9-9b7f-ab3521db00fa"
      }
    ],
    productNameEnglish:
      "কৈ মাছ  Koi fish curry - Delivery by taxi, pay as meter-fare. ",
    productPrice: "4",
    productSupplier: "BCS SHOP",
    sortOrder: "a",
    supplierContactName: "Ahmed Fayyaz",
    supplierContactPhone: "97861239",
    unit: "1 serving ",
    updateDateTime: "Tue 11-08-20 6:45 pm",
    count: 8
  },
  {
    category: "COSMETICS",
    isPopular: "YES",
    key: "-MA-tazsHlmvFvZ0mjFU",
    photos: [
      {
        imageName: "4c030310-b213-11ea-921f-9db4b33fb426.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F4c030310-b213-11ea-921f-9db4b33fb426.jpg?alt=media&token=1558cce1-de64-4608-8ba1-14666e3d733c"
      }
    ],
    productNameEnglish: "Fair & Handsome Advanced Whitening Cream",
    productPrice: "5.20",
    productSupplier: "BCS SHOP",
    searchText: "fair & handsome ফেইস ক্রিম",
    sortOrder: "x",
    sourceSupplier: "MUSTAFA CENTRE",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "50G",
    updateDateTime: "03/08/2020 04:33:26",
    count: 8
  },
  {
    availability: "AVAILABLE",
    category: "MEAT FISH",
    isPopular: "YES",
    key: "-M9a2iFZWTS972ahdFLF",
    photos: [
      {
        imageName: "b046e380-ac48-11ea-ba1a-4bcfa8bf5006.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fb046e380-ac48-11ea-ba1a-4bcfa8bf5006.jpg?alt=media&token=22920773-af55-4253-b1d8-dc02ba62bde0"
      }
    ],
    productNameEnglish: "Fish small ",
    productPrice: "5.5",
    productSupplier: "BCS SHOP",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1 packet",
    updateDateTime: "06/07/2020 07:12:48",
    count: 8
  },
  {
    availability: "AVAILABLE",
    category: "EGGS DAIRY",
    isPopular: "YES",
    key: "-MBIm9l66dbWcOIQ7hNU",
    photos: [
      {
        imageName: "ddad7f90-bd06-11ea-83e5-cbed5ea0d8b3.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fddad7f90-bd06-11ea-83e5-cbed5ea0d8b3.jpg?alt=media&token=c286cf2e-8b36-4a7a-a45b-11bd6579576c"
      }
    ],
    productNameEnglish: "Nespray Everyday Instant Milk Powder",
    productPrice: "9.95",
    productSupplier: "BCS SHOP",
    searchText: "milk naspry nespry nestly powder ধুদ ",
    sortOrder: "g",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "550g",
    updateDateTime: "03/08/2020 03:41:59",
    count: 8
  },
  {
    category: "COOKING OIL INGREDIENTS",
    key: "-M9fWDRRy5rGN0ssRTbd",
    photos: [
      {
        imageName: "09735940-ad1e-11ea-9a01-db9ea96fa329.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F09735940-ad1e-11ea-9a01-db9ea96fa329.jpg?alt=media&token=28d27ee0-f020-4787-9258-5f72de09ff3b"
      }
    ],
    productNameEnglish: "MAGGI CHILLI SAUCE",
    productPrice: "2.70",
    productSupplier: "BCS SHOP",
    sortOrder: "d",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "500g",
    updateDateTime: "04/07/2020 11:56:56",
    count: 8
  },
  {
    availability: "AVAILABLE",
    category: "DRINKS DESSERT",
    isPopular: "YES",
    key: "-MB8XrLyYdlYzf0Rutzt",
    photos: [
      {
        imageName: "8e563c60-bb77-11ea-9bec-f98d55a4d196.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F8e563c60-bb77-11ea-9bec-f98d55a4d196.jpg?alt=media&token=bcb1f0ad-b14d-4db9-a63c-e615ef251469"
      }
    ],
    productNameEnglish: "PRAN Frooto Mango Juice",
    productPrice: "2.50",
    productSupplier: "BCS SHOP",
    searchText: "amer juice mango mengo আমের রস জুস ",
    sortOrder: "g",
    supplierContactName: "Ahmed Fayyaz",
    supplierContactPhone: "97861239",
    unit: "1000ml",
    updateDateTime: "03/08/2020 03:43:36",
    count: 8
  },
  {
    category: "COSMETICS",
    isPopular: "YES",
    key: "-MA-t186nywzez5LkCVy",
    photos: [
      {
        imageName: "a2ae5c00-b213-11ea-921f-9db4b33fb426.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fa2ae5c00-b213-11ea-921f-9db4b33fb426.jpg?alt=media&token=0f958146-9d0d-43e9-a07a-d5d2437402f6"
      }
    ],
    productNameEnglish:
      "Fair & Handsome Advanced Whitening Cream - Oil Control",
    productPrice: "4.20",
    productSupplier: "BCS SHOP",
    searchText: "ফেইস ক্রিম",
    sortOrder: "x",
    sourceSupplier: "MUSTAFA CENTRE",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "50G",
    updateDateTime: "03/08/2020 04:34:26",
    count: 8
  },
  {
    availability: "AVAILABLE",
    category: "RICE DAAL NOODLES",
    isPopular: "YES",
    key: "-MBZW8vSHpbvJHgwGif3",
    photos: [
      {
        imageName: "7807e5f0-bf94-11ea-85e3-735b22b1a0db.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F7807e5f0-bf94-11ea-85e3-735b22b1a0db.jpg?alt=media&token=f17c7097-80ff-4b86-857c-8b9b2c041e35"
      }
    ],
    productNameEnglish: "India Gate Premium Basmati Rice",
    productPrice: "20.50",
    productSupplier: "BCS SHOP",
    searchText: "বাসমতি চাউল ",
    sortOrder: "a",
    supplierContactName: "Ahmed Fayyaz",
    supplierContactPhone: "97861239",
    unit: "5kg",
    updateDateTime: "03/08/2020 03:28:48",
    count: 8
  },
  {
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    isPopular: "NO",
    key: "-MA4cWSW0HAda4zBywEU",
    photos: [
      {
        imageName: "ff26c0d0-b119-11ea-810a-c5e0250e7646.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fff26c0d0-b119-11ea-810a-c5e0250e7646.jpg?alt=media&token=c10f409e-fbee-4c33-99d1-8f1533db8b86"
      }
    ],
    productNameEnglish: "Coconut",
    productPrice: "2.50",
    productSupplier: "BCS SHOP",
    searchText: "নারিকেল ",
    sortOrder: "a",
    sourceSupplier: "Minaka trading ",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1PC",
    updateDateTime: "17/07/2020 02:11:44",
    count: 8
  },
  {
    availability: "AVAILABLE",
    category: "LAUNDRY CLEANING",
    key: "-M9bAZLU-a_Q-V-WlbbY",
    photos: [
      {
        imageName: "7884e2e0-ac74-11ea-8ded-437354ec7423.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F7884e2e0-ac74-11ea-8ded-437354ec7423.jpg?alt=media&token=640f2b31-ab60-48c9-bc9a-fac131af8e2a"
      }
    ],
    productNameEnglish: "Detergent powder home niks",
    productPrice: "8.5",
    productSupplier: "BCS SHOP",
    searchText: "ওয়াশিং পাউডার ",
    sortOrder: "f",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "5Kg",
    updateDateTime: "17/07/2020 07:56:35",
    count: 8
  },
  {
    category: "SNACKS DRY FOOD",
    key: "-MA-ozuXRBn4GTx3Mhpe",
    photos: [
      {
        imageName: "2dac4270-b216-11ea-921f-9db4b33fb426.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F2dac4270-b216-11ea-921f-9db4b33fb426.jpg?alt=media&token=e0e21e43-159a-49b0-a77b-9312df500800"
      }
    ],
    productNameEnglish: "Pringles Original Potato Chips",
    productPrice: "2.70",
    productSupplier: "BCS SHOP",
    sortOrder: "h",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "147G",
    updateDateTime: "03/08/2020 04:37:00",
    count: 8
  },
  {
    author: "+6589050302",
    category: "DRINKS DESSERT",
    key: "-M9fioFzWCqGG8o7tc88",
    photos: [
      {
        imageName: "55884d60-ad26-11ea-9a01-db9ea96fa329.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F55884d60-ad26-11ea-9a01-db9ea96fa329.jpg?alt=media&token=f9fdd525-8908-49e8-bc7a-0253dc6b4adb"
      }
    ],
    productNameEnglish: "OSK 100% JAPANESE GREEN TEA",
    productPrice: "7.95",
    productSupplier: "BCS SHOP",
    sortOrder: "d",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "50 per pack",
    updateDateTime: "17/07/2020 08:54:46",
    count: 8
  },
  {
    author: "+6589050302",
    availability: "AVAILABLE",
    category: "EGGS DAIRY",
    isPopular: "YES",
    key: "-MABkwxm7pStALGAF3ev",
    photos: [
      {
        imageName: "4ba4f990-bc50-11ea-b7df-33e703b87300.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F4ba4f990-bc50-11ea-b7df-33e703b87300.jpg?alt=media&token=f55e6d5a-4cc4-4653-8c6f-62ec45f5b57c"
      }
    ],
    productNameEnglish: "Nestle Everyday Instant Milk Powder ",
    productPrice: "20.90",
    productSupplier: "BCS SHOP",
    searchText: "milk ধুদ ",
    sortOrder: "c",
    supplierContactName: "Ahmed Fayyaz",
    supplierContactPhone: "97861239",
    unit: "1kg Packet",
    updateDateTime: "Thu 13-08-20 10:50 pm",
    count: 7
  },
  {
    category: "TUPPERWARE CONTAINER",
    key: "-M9q5QC6nrc4MfVdUoN0",
    photos: [
      {
        imageName: "5b02a9c0-aebb-11ea-9600-53e79e8cda87.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F5b02a9c0-aebb-11ea-9600-53e79e8cda87.jpg?alt=media&token=809b5b04-7592-4e2f-a094-2d248028db9a"
      }
    ],
    productDescription: " 5PCS OF 1 PACK",
    productNameEnglish: "Glad Soup & Salad Containers",
    productPrice: "5.90",
    productSupplier: "BCS SHOP",
    sortOrder: "x",
    sourceSupplier: "MUSTAFA CENTRE",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "5PCS",
    updateDateTime: "03/08/2020 06:14:27",
    count: 7
  },
  {
    category: "RICE DAAL NOODLES",
    key: "-M9b8iXcL7dhjtXM7st6",
    photos: [
      {
        imageName: "49a41cd0-ac73-11ea-8ded-437354ec7423.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F49a41cd0-ac73-11ea-8ded-437354ec7423.jpg?alt=media&token=27c4bcd5-378a-415e-8b95-5102e1e649a3"
      }
    ],
    productNameEnglish: "Noodles tom yam/asam laksa/kari letup",
    productPrice: "2.5",
    productSupplier: "BCS SHOP",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1 Pkt",
    updateDateTime: "04/07/2020 08:48:26",
    count: 7
  },
  {
    category: "RICE DAAL NOODLES",
    isPopular: "YES",
    key: "-M9bH7pWwS_Hs2PnjPxw",
    photos: [
      {
        imageName: "78b62f40-ac78-11ea-891a-2516dcf49b13.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F78b62f40-ac78-11ea-891a-2516dcf49b13.jpg?alt=media&token=288e7221-e028-41a5-bbb2-f548e74e5773"
      }
    ],
    productNameEnglish: "BASIL SEEDS",
    productPrice: "3 ",
    productSupplier: "BCS SHOP",
    searchText: "tokma tukma tukh malanga",
    sortOrder: "c",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "100g",
    updateDateTime: "04/07/2020 08:27:20",
    count: 7
  },
  {
    availability: "AVAILABLE",
    category: "SNACKS DRY FOOD",
    isPopular: "NO",
    key: "-M9a_DoeaS6RlzomcExY",
    photos: [
      {
        imageName: "23c3c530-ac5d-11ea-bbe4-619ccaa778ae.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F23c3c530-ac5d-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=e15f3569-efc2-473e-932f-af0cc080335f"
      }
    ],
    productNameEnglish: "TOAST ",
    productPrice: "2",
    productSupplier: "BCS SHOP",
    sortOrder: "a",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1 pkt",
    updateDateTime: "23/07/2020 12:33:50",
    count: 7
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    key: "-M9bG1j4cuWPwuqeWkuI",
    photos: [
      {
        imageName: "dfdb2c30-ac77-11ea-8ded-437354ec7423.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fdfdb2c30-ac77-11ea-8ded-437354ec7423.jpg?alt=media&token=8f88031d-2ff0-402b-8bdf-079d45a83130"
      }
    ],
    productNameEnglish: "Soya bean oil ",
    productPrice: "12.5",
    productSupplier: "BCS SHOP",
    searchText: "তেল তৈল ",
    sortOrder: "d",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "5L",
    updateDateTime: "17/07/2020 04:10:11",
    count: 7
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    key: "-M9fMr2qCr1ml6DTdCaT",
    photos: [
      {
        imageName: "52a9c6e0-ad18-11ea-8bc0-03f48af12a9c.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F52a9c6e0-ad18-11ea-8bc0-03f48af12a9c.jpg?alt=media&token=02bc8234-8baf-4684-87ec-49f11199e839"
      }
    ],
    productNameEnglish: "MAGGI TOMATO KETCHUP (HEALTHIER CHOICE)",
    productPrice: "2",
    productSupplier: "BCS SHOP",
    sortOrder: "d",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "475g",
    updateDateTime: "17/07/2020 08:30:55",
    count: 7
  },
  {
    availability: "AVAILABLE",
    category: "TOILETRIES",
    key: "-MBZVee48Q_dgFNvFRDp",
    photos: [
      {
        imageName: "41a8d4b0-bf94-11ea-85e3-735b22b1a0db.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F41a8d4b0-bf94-11ea-85e3-735b22b1a0db.jpg?alt=media&token=27ac8c4c-13f3-47cb-9533-c4477ac2050e"
      }
    ],
    productNameEnglish: "Ginvera Natural Bath Shower Gel  ",
    productPrice: "4.95",
    productSupplier: "BCS SHOP",
    searchText: "শাওয়ার ফোম ",
    sortOrder: "g",
    supplierContactName: "Ahmed Fayyaz",
    supplierContactPhone: "97861239",
    unit: "1L",
    updateDateTime: "03/08/2020 03:29:54",
    count: 7
  },
  {
    category: "DRINKS DESSERT",
    key: "-M9gAmjVmP2ozJ5t6z3s",
    photos: [
      {
        imageName: "044d73a0-ad38-11ea-9a01-db9ea96fa329.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F044d73a0-ad38-11ea-9a01-db9ea96fa329.jpg?alt=media&token=0b38f9fa-338f-46b9-8112-5212ecc38a16"
      }
    ],
    productNameEnglish: "POKKA ICE LEMON TEA (1.5l)",
    productPrice: "2.30",
    productSupplier: "BCS SHOP",
    sortOrder: "d",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    updateDateTime: "04/07/2020 11:23:01",
    count: 7
  },
  {
    availability: "AVAILABLE",
    category: "RICE DAAL NOODLES",
    key: "-M9bFbu8vwHane1xIr1u",
    photos: [
      {
        imageName: "567cf3a0-e8dc-11ea-b634-e7e7c4cb042d.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F567cf3a0-e8dc-11ea-b634-e7e7c4cb042d.jpg?alt=media&token=19a68641-bb80-493c-b780-710c4536c9b1"
      }
    ],
    productNameEnglish: "PLAIN FLOUR (1kg)",
    productPrice: "2 ",
    productSupplier: "BCS SHOP",
    searchText: "এটা ময়দা ",
    sortOrder: "a",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1kg",
    updateDateTime: "Fri 28-08-20 11:12 am",
    count: 7
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    isPopular: "YES",
    key: "-MA-4o4Bq8366luSWQfN",
    photos: [
      {
        imageName: "48ce3da0-b041-11ea-9737-25db4b55bc7b.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F48ce3da0-b041-11ea-9737-25db4b55bc7b.jpg?alt=media&token=c34dcb2b-a64d-44ee-b72f-471880e904e4"
      }
    ],
    productNameEnglish: "PRAN Meat Masala ",
    productPrice: "3.50",
    productSupplier: "BCS SHOP",
    searchText: "মাংস মসলা",
    sortOrder: "a",
    sourceSupplier: "MUSTAFA CENTRE",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "100g",
    updateDateTime: "03/08/2020 04:59:21",
    count: 7
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    isPopular: "YES",
    key: "-MDSxVCslP0DQpLhyEuA",
    photos: [
      {
        imageName: "546a95d0-d21c-11ea-aa6f-8f310b43ab36.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F546a95d0-d21c-11ea-aa6f-8f310b43ab36.jpg?alt=media&token=a10fac92-656a-41b2-8c4e-665864e878ed"
      }
    ],
    productNameEnglish: "S&W Organic Apple Cider Vinegar",
    productPrice: "7.90",
    productSupplier: "BCS SHOP",
    sortOrder: "a",
    supplierContactName: "Kabir",
    supplierContactPhone: "94562455",
    unit: "473ml ",
    updateDateTime: "03/08/2020 03:18:41",
    count: 6
  },
  {
    author: "+6589050302",
    availability: "AVAILABLE",
    category: "RICE DAAL NOODLES",
    isPopular: "YES",
    key: "-M98XebbkWBaYir3DchI",
    photos: [
      {
        imageName: "c72d6f00-a7ee-11ea-9efa-45bf0dbedfb0.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fc72d6f00-a7ee-11ea-9efa-45bf0dbedfb0.jpg?alt=media&token=fe2bf965-c7d3-44e6-bf61-c6080eedf639"
      }
    ],
    productDescription: "Best rice ",
    productNameEnglish: "Rice ponni ",
    productPrice: "$8",
    productSupplier: "TANMOY",
    searchText: "চাউল ",
    sortOrder: "a",
    supplierContactName: "Moni",
    supplierContactPhone: "96220740",
    unit: "5kg",
    updateDateTime: "Sun 30-08-20 8:46 am",
    count: 6
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    key: "-M9bY_Q2RTlndObGkIIm",
    photos: [
      {
        imageName: "333c3b20-ac83-11ea-add8-bd9e7e764e64.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F333c3b20-ac83-11ea-add8-bd9e7e764e64.jpg?alt=media&token=5d71581c-65e6-417f-b22c-ef6c3b2a70ff"
      }
    ],
    productNameEnglish: "Fennel flower 100gm",
    productPrice: "2.2",
    productSupplier: "BCS SHOP",
    searchText: " মৌরি",
    sortOrder: "c",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "100gm",
    updateDateTime: "17/07/2020 03:07:41",
    count: 6
  },
  {
    category: "EGGS DAIRY",
    key: "-M9gboJ-Kb2YSSVTcp0e",
    photos: [
      {
        imageName: "1fbadfe0-ad49-11ea-9a01-db9ea96fa329.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F1fbadfe0-ad49-11ea-9a01-db9ea96fa329.jpg?alt=media&token=09645012-9ea6-454b-8c2d-b5ef0279514a"
      }
    ],
    productNameEnglish: "Nespray Fortified Full Cream Instant Milk Powder",
    productPrice: "12.50",
    productSupplier: "BCS SHOP",
    sortOrder: "x",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "600g",
    updateDateTime: "03/08/2020 07:03:20",
    count: 6
  },
  {
    availability: "AVAILABLE",
    category: "COSMETICS",
    key: "-M9mc8ytLAQtxJEccOPX",
    photos: [
      {
        imageName: "8e20f0b0-ae33-11ea-8070-f3cc7bbcb5d1.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F8e20f0b0-ae33-11ea-8070-f3cc7bbcb5d1.jpg?alt=media&token=17739c96-f6a4-4311-bad4-36c5a380d5ca"
      }
    ],
    productNameEnglish: "Garnier Men Turbo Light Cooling Foam ",
    productPrice: "10.50",
    productSupplier: "BCS SHOP",
    searchText: "ফেইস ওয়াশ ",
    sortOrder: "x",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "100ml",
    updateDateTime: "03/08/2020 06:45:38",
    count: 6
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    isPopular: "YES",
    key: "-MA-Gj6E5dx9nQhb3Ce_",
    photos: [
      {
        imageName: "f56d3bb0-b217-11ea-921f-9db4b33fb426.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ff56d3bb0-b217-11ea-921f-9db4b33fb426.jpg?alt=media&token=29bc3bcc-2d37-4edd-8a7c-cc4c78f8e1d8"
      }
    ],
    productNameEnglish: "RADHUNI Kala Vuna Masala",
    productPrice: "3.50",
    productSupplier: "BCS SHOP",
    searchText: "কালা ভুনা মসলা ",
    sortOrder: "a",
    sourceSupplier: "RAJDHANI ENTERPRISE PTE LTD",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "80g",
    updateDateTime: "03/08/2020 04:52:05",
    count: 6
  },
  {
    category: "MEAT FISH",
    isPopular: "YES",
    key: "-MA--py-a2EMdns3ljY1",
    photos: [
      {
        imageName: "7ed87f80-b03e-11ea-9737-25db4b55bc7b.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F7ed87f80-b03e-11ea-9737-25db4b55bc7b.jpg?alt=media&token=9dbd3be0-3355-4d02-83eb-1b29764ce67b"
      }
    ],
    productNameEnglish: "Anabas Testudineus",
    productPrice: "12",
    productSupplier: "BCS SHOP",
    sortOrder: "a",
    sourceSupplier: "KHAN PRODUCTS PTE LTD.",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1KG",
    updateDateTime: "03/08/2020 05:20:31",
    count: 6
  },
  {
    availability: "AVAILABLE",
    category: "রান্না করা খাবার",
    key: "-MD4cxuovAy6ZGT2kouJ",
    photos: [
      {
        imageName: "db3035d0-ce65-11ea-ad6f-2324c1fe3ac0.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fdb3035d0-ce65-11ea-ad6f-2324c1fe3ac0.jpg?alt=media&token=53937bc0-3ecc-465e-a5be-8da7dcb7a4d3"
      }
    ],
    productNameEnglish:
      "Lao chingri curry - Delivery by taxi, pay as meter-fare. ",
    productPrice: "4",
    productSupplier: "BCS SHOP",
    sortOrder: "a",
    supplierContactName: "Kabir",
    supplierContactPhone: "94562455",
    unit: "1 serving ",
    updateDateTime: "Tue 11-08-20 6:44 pm",
    count: 6
  },
  {
    availability: "AVAILABLE",
    category: "RICE DAAL NOODLES",
    isPopular: "YES",
    key: "-M9a57Nre5UDcjazBxYD",
    photos: [
      {
        imageName: "18c5b8a0-e8e4-11ea-b634-e7e7c4cb042d.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F18c5b8a0-e8e4-11ea-b634-e7e7c4cb042d.jpg?alt=media&token=7058c195-98e7-4b91-a358-48ce46e0e590"
      }
    ],
    productNameEnglish: "Rice Cinigora ",
    productPrice: "5",
    productSupplier: "BCS SHOP",
    searchText: "চিনিগুঁড়া ",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1kg",
    updateDateTime: "Fri 28-08-20 12:08 pm",
    count: 6
  },
  {
    category: "MEAT FISH",
    isPopular: "YES",
    key: "-M9a2QTdetZeIHqGAUar",
    photos: [
      {
        imageName: "790847b0-ac48-11ea-ba1a-4bcfa8bf5006.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F790847b0-ac48-11ea-ba1a-4bcfa8bf5006.jpg?alt=media&token=049c102a-db22-4066-bbd6-5906774e76bb"
      }
    ],
    productNameEnglish: "Fish small fish ",
    productPrice: "5.5",
    productSupplier: "BCS SHOP",
    sortOrder: "x",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1 packet",
    updateDateTime: "04/07/2020 09:28:25",
    count: 6
  },
  {
    category: "COSMETICS",
    key: "-M9gOUNg5ksrhHVA8-P4",
    photos: [
      {
        imageName: "2e812830-ad40-11ea-b044-d71d8f034373.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F2e812830-ad40-11ea-b044-d71d8f034373.jpg?alt=media&token=ef88be7c-b3f5-46e6-a5d6-d1d3234c9bc9"
      }
    ],
    productNameEnglish: "Shaving razor kai fixed type",
    productPrice: "3.5",
    productSupplier: "BCS SHOP",
    sortOrder: "x",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "5pcs 1packet",
    updateDateTime: "04/07/2020 10:16:29",
    count: 6
  },
  {
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    isPopular: "YES",
    key: "-MA-nsPshOgTcNls80ZJ",
    photos: [
      {
        imageName: "825e7b50-bc5a-11ea-b7df-33e703b87300.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F825e7b50-bc5a-11ea-b7df-33e703b87300.jpg?alt=media&token=3fc67247-a966-491d-8450-8be463c7ca4b"
      }
    ],
    productNameEnglish: "Pears",
    productPrice: "3.95",
    productSupplier: "BCS SHOP",
    searchText: "ফল ",
    sortOrder: "a",
    sourceSupplier: "Sheng siong ",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "4pcs",
    updateDateTime: "03/08/2020 04:39:26",
    count: 6
  },
  {
    category: "SNACKS DRY FOOD",
    key: "-MA-rg5hNW3ZbRV3v9Jv",
    photos: [
      {
        imageName: "800199a0-b214-11ea-921f-9db4b33fb426.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F800199a0-b214-11ea-921f-9db4b33fb426.jpg?alt=media&token=45477024-02fe-4447-878c-a490d9940512"
      }
    ],
    productNameEnglish: "Calbee Prawn Crackers ",
    productPrice: "2.70",
    productSupplier: "BCS SHOP",
    sortOrder: "h",
    sourceSupplier: "Sheng siong ",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "150G",
    updateDateTime: "17/07/2020 06:33:45",
    count: 6
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    key: "-M9bGSR_j7gaxUZ9Kc0f",
    photos: [
      {
        imageName: "1232e600-ac78-11ea-8ded-437354ec7423.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F1232e600-ac78-11ea-8ded-437354ec7423.jpg?alt=media&token=f067dcfa-91c9-450a-bae5-db864f4e022e"
      }
    ],
    productNameEnglish: "Gold oil sunflower ",
    productPrice: "16.2",
    productSupplier: "BCS SHOP",
    searchText: "তেল তৈল ",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    updateDateTime: "17/07/2020 04:08:18",
    count: 6
  },
  {
    category: "COOKING OIL INGREDIENTS",
    key: "-M9b6D6itMcUK3KyLdFp",
    photos: [
      {
        imageName: "e9e45a40-ac71-11ea-83ef-037972cabc05.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fe9e45a40-ac71-11ea-83ef-037972cabc05.jpg?alt=media&token=3a8ce57a-ae06-43e5-93d6-8eafb97be97d"
      }
    ],
    productNameEnglish: "PLAIN PARATHA",
    productPrice: "7.70",
    productSupplier: "BCS SHOP",
    sortOrder: "d",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "2 Kg",
    updateDateTime: "04/07/2020 11:32:50",
    count: 6
  },
  {
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    isPopular: "YES",
    key: "-MA0MsR80E1n5sC5-OGS",
    photos: [
      {
        imageName: "23246470-bf83-11ea-85e3-735b22b1a0db.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F23246470-bf83-11ea-85e3-735b22b1a0db.jpg?alt=media&token=638f8e2e-413c-4906-82cb-2102fe5d5e3d"
      }
    ],
    productNameEnglish: "Lemon Grass",
    productPrice: "1",
    productSupplier: "BCS SHOP",
    sortOrder: "a",
    sourceSupplier: "Sheng siong ",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "100G",
    updateDateTime: "03/08/2020 04:28:01",
    count: 6
  },
  {
    availability: "AVAILABLE",
    category: "RICE DAAL NOODLES",
    key: "-M9m_CxjtnUINLfRzie8",
    photos: [
      {
        imageName: "d15c2950-ae31-11ea-8070-f3cc7bbcb5d1.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fd15c2950-ae31-11ea-8070-f3cc7bbcb5d1.jpg?alt=media&token=2869470d-d387-4b94-b012-8fe360fba59c"
      }
    ],
    productNameEnglish: "Golden Pineapple AAA Thai Premium Fragrant Rice",
    productPrice: "25",
    productSupplier: "BCS SHOP",
    searchText: "চাউল rice",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "10Kg",
    updateDateTime: "Fri 27-11-20 11:30 am",
    count: 6
  },
  {
    category: "TOILETRIES",
    key: "-M9bB5dnsCXDomgJ_OBA",
    photos: [
      {
        imageName: "563bf250-f89b-11ea-aaa8-a9cfb87a7f3a.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F563bf250-f89b-11ea-aaa8-a9cfb87a7f3a.jpg?alt=media&token=bc346ebc-e30f-4488-bded-668fc3aae7a8"
      }
    ],
    productNameEnglish: "Hand wash",
    productPrice: "3.2",
    productSupplier: "BCS SHOP",
    sortOrder: "d",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "200ml",
    updateDateTime: "Thu 17-09-20 12:07 pm",
    count: 5
  },
  {
    availability: "OUT OF STOCK, TOPPING UP IN PROGRESS",
    category: "OTHERS",
    isPopular: "YES",
    key: "-MAuWje35ZQxDS99_aGV",
    photos: [
      {
        imageName: "48809f70-b92c-11ea-bcad-f16312f4aa54.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F48809f70-b92c-11ea-bcad-f16312f4aa54.jpg?alt=media&token=815ade9d-1279-4404-9cc5-ad1762f68393"
      }
    ],
    productNameEnglish: "Lungi - Malaysian & Indonesian ",
    productPrice: "8",
    productSupplier: "BCS SHOP",
    searchText: "lungi loongi sarong লুঙ্গি লুঙ্গী ",
    sortOrder: "m",
    sourceSupplier: "TANMOY ENTERPRISE PTE LTD",
    supplierContactName: "Ahmed Fayyaz",
    supplierContactPhone: "97861239",
    unit: "1 pc",
    updateDateTime: "Tue 29-09-20 10:56 am",
    count: 5
  },
  {
    availability: "OUT OF STOCK, TOPPING UP IN PROGRESS",
    category: "COOKING INGREDIENTS",
    isPopular: "YES",
    key: "-MAZdA2vloIV39grJ-lO",
    photos: [
      {
        imageName: "bb849240-bc4e-11ea-b7df-33e703b87300.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fbb849240-bc4e-11ea-b7df-33e703b87300.jpg?alt=media&token=0864398c-055b-493e-a542-3af485529ec0"
      }
    ],
    productNameEnglish: "Himalay Turmeric Powder",
    productPrice: "2.50",
    productSupplier: "BCS SHOP",
    searchText: "holud holdi turmeric turmaric হলুদের গুঁড়া হলুদ ",
    sortOrder: "g",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1.25G",
    updateDateTime: "Fri 14-08-20 4:17 pm",
    count: 5
  },
  {
    availability: "AVAILABLE",
    category: "SNACKS DRY FOOD",
    isPopular: "NO",
    key: "-M9a_1bytLy0Nu3atm0R",
    photos: [
      {
        imageName: "f81b9f70-ac5c-11ea-bbe4-619ccaa778ae.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ff81b9f70-ac5c-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=141646ea-3a5b-4fe8-b0fd-9308269e54ec"
      }
    ],
    productNameEnglish: "TOAST",
    productPrice: "2",
    productSupplier: "BCS SHOP",
    sortOrder: "a",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1 pkt",
    updateDateTime: "23/07/2020 12:34:05",
    count: 5
  },
  {
    category: "SNACKS DRY FOOD",
    key: "-MA-qJBBcd7sXZTc9zt_",
    photos: [
      {
        imageName: "e9800500-b215-11ea-921f-9db4b33fb426.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fe9800500-b215-11ea-921f-9db4b33fb426.jpg?alt=media&token=36ba7acc-839f-40ff-b993-be707f5ea6fb"
      }
    ],
    productNameEnglish: "Pringles Sour Cream & Onion Potato Chips ",
    productPrice: "2.70",
    productSupplier: "BCS SHOP",
    sortOrder: "h",
    sourceSupplier: "Sheng siong ",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "147G",
    updateDateTime: "03/08/2020 04:36:37",
    count: 5
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    isPopular: "YES",
    key: "-MDS5ujR6BVHM84V5qY5",
    photos: [
      {
        imageName: "0e7cae30-d1fb-11ea-af02-8f9212f09cdc.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F0e7cae30-d1fb-11ea-af02-8f9212f09cdc.jpg?alt=media&token=4cf63167-8847-46fc-ac5e-a00d53c19f93"
      }
    ],
    productNameEnglish: "Bragg Organic Apple Cider Vinegar ",
    productPrice: "13",
    productSupplier: "BCS SHOP",
    sortOrder: "a",
    supplierContactName: "Kabir",
    supplierContactPhone: "94562455",
    unit: "946ml",
    updateDateTime: "03/08/2020 03:18:29",
    count: 5
  },
  {
    category: "FRUITS VEGETABLES ",
    isPopular: "YES",
    key: "-MA4WSi3YxwmKiQR-BNs",
    photos: [
      {
        imageName: "ecbaa0b0-bc54-11ea-b7df-33e703b87300.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fecbaa0b0-bc54-11ea-b7df-33e703b87300.jpg?alt=media&token=2f85db9e-f690-4bf9-9357-cccf6c5747b8"
      }
    ],
    productNameEnglish: "Chow Chow",
    productPrice: "0.60",
    productSupplier: "BCS SHOP",
    searchText: "শাক সবজি সব্জি ",
    sortOrder: "a",
    sourceSupplier: "Amman trading ",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "100Gm",
    updateDateTime: "03/08/2020 04:21:11",
    count: 5
  },
  {
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    isPopular: "YES",
    key: "-MA4Mhz5_iloZFQAnB3V",
    photos: [
      {
        imageName: "a123f670-bdcf-11ea-8ba8-ddb60ef370d4.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fa123f670-bdcf-11ea-8ba8-ddb60ef370d4.jpg?alt=media&token=3406769c-8a30-4422-a360-1d21150f6c17"
      }
    ],
    productNameEnglish: "Amla",
    productPrice: "6.70",
    productSupplier: "BCS SHOP",
    sortOrder: "a",
    sourceSupplier: "Veg mart ",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1kg",
    updateDateTime: "03/08/2020 04:26:08",
    count: 5
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    isPopular: "YES",
    key: "-MA-C1A-sCAahqoQPvZV",
    photos: [
      {
        imageName: "f1445240-b045-11ea-9737-25db4b55bc7b.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ff1445240-b045-11ea-9737-25db4b55bc7b.jpg?alt=media&token=b82d5e26-9d1e-4b5d-acdf-6892445078c1"
      }
    ],
    productNameEnglish: "RADHUNI Meat Masala",
    productPrice: "3.50",
    productSupplier: "BCS SHOP",
    searchText: "গরুর মাংস মসলা",
    sortOrder: "a",
    sourceSupplier: "KHAN PRODUCTS PTE LTD.",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "100G",
    updateDateTime: "03/08/2020 04:58:05",
    count: 5
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    isPopular: "YES",
    key: "-MA-HwsBZXu5J459CxaK",
    photos: [
      {
        imageName: "978bbc80-b049-11ea-9737-25db4b55bc7b.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F978bbc80-b049-11ea-9737-25db4b55bc7b.jpg?alt=media&token=c15d7f86-7648-49ac-a6f4-677cb741606f"
      }
    ],
    productNameEnglish: "PRAN Duck Masala",
    productPrice: "3.50",
    productSupplier: "BCS SHOP",
    searchText: "হাঁসের মসলা ",
    sortOrder: "a",
    sourceSupplier: "RAJDHANI ENTERPRISE PTE LTD",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "60gm",
    updateDateTime: "03/08/2020 04:50:39",
    count: 5
  },
  {
    category: "COOKING OIL INGREDIENTS",
    key: "-M9fUL-PSLdd30YrWxBO",
    photos: [
      {
        imageName: "e2c5e110-ad1c-11ea-9a01-db9ea96fa329.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fe2c5e110-ad1c-11ea-9a01-db9ea96fa329.jpg?alt=media&token=63201167-0871-45b0-9cff-b678fbc51ee9"
      }
    ],
    productNameEnglish: "OKI PREMIUM SOYA BEAN OIL",
    productPrice: "7.40",
    productSupplier: "BCS SHOP",
    sortOrder: "d",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "2L",
    updateDateTime: "04/07/2020 11:51:54",
    count: 5
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    isPopular: "YES",
    key: "-MA-FDxT3W7EN2Xf9xNn",
    photos: [
      {
        imageName: "dfc09bd0-b047-11ea-9737-25db4b55bc7b.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fdfc09bd0-b047-11ea-9737-25db4b55bc7b.jpg?alt=media&token=7d962d31-6b99-4c5b-8f25-b0b8edd83e2f"
      }
    ],
    productNameEnglish: "RADHUNI Fish Curry Masala",
    productPrice: "3.50",
    productSupplier: "BCS SHOP",
    searchText: "মাছের মসলা",
    sortOrder: "a",
    sourceSupplier: "FAHIM ENTERPRISE PTE LTD",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "100G",
    updateDateTime: "03/08/2020 04:53:41",
    count: 5
  },
  {
    availability: "AVAILABLE",
    category: "DRINKS DESSERT",
    key: "-MEfZDL2i8fOR8Yu5BpS",
    photos: [
      {
        imageName: "1be55ff0-ddf3-11ea-a50a-71ea37251d72.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F1be55ff0-ddf3-11ea-a50a-71ea37251d72.jpg?alt=media&token=c985fea1-dc8b-419a-92b6-e8f822a0a70d"
      }
    ],
    productNameEnglish: "sat isabgol pran",
    productPrice: "3.00",
    productSupplier: "BCS SHOP",
    searchText: "isabgol esobgul isopgol",
    sortOrder: "a",
    supplierContactName: "Ismita",
    supplierContactPhone: "userMobile",
    unit: "1 pkt 100g",
    updateDateTime: "Fri 14-08-20 4:16 pm",
    count: 5
  },
  {
    availability: "AVAILABLE",
    category: "TOILETRIES",
    key: "-MBZWpNvXzV571CAQ62z",
    photos: [
      {
        imageName: "f54164b0-bf94-11ea-85e3-735b22b1a0db.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ff54164b0-bf94-11ea-85e3-735b22b1a0db.jpg?alt=media&token=19ad6bd8-8ddd-4fdb-ad7f-08086827c923"
      }
    ],
    productNameEnglish:
      "Neutrogena Deep Clean Blackhead eliminating daily scrub",
    productPrice: "13.60",
    productSupplier: "BCS SHOP",
    searchText: "ফেইস ওয়াশ ",
    sortOrder: "g",
    supplierContactName: "Ahmed Fayyaz",
    supplierContactPhone: "97861239",
    unit: "100gm",
    updateDateTime: "03/08/2020 03:27:39",
    count: 5
  },
  {
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    key: "-M9cXeynbwtq5zd_TsHl",
    photos: [
      {
        imageName: "b6486630-aca9-11ea-ab51-0f18e1d42bbd.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fb6486630-aca9-11ea-ab51-0f18e1d42bbd.jpg?alt=media&token=d03056ac-cd88-4d96-b004-7ed1029391fd"
      }
    ],
    productNameEnglish: "YELLOW WATERMELON",
    productPrice: "2.2",
    productSupplier: "BCS SHOP",
    searchText: "ফল ",
    sortOrder: "d",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1 Kg",
    updateDateTime: "Mon 21-09-20 3:37 pm",
    count: 5
  },
  {
    category: "COOKING OIL INGREDIENTS",
    isPopular: "YES",
    key: "-MA-tUS7aOooCDdRb5ll",
    photos: [
      {
        imageName: "1c5525c0-b061-11ea-8357-d5a4954c59fc.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F1c5525c0-b061-11ea-8357-d5a4954c59fc.jpg?alt=media&token=dc0bb154-2c99-49b0-aff7-3c9cce03764c"
      }
    ],
    productNameEnglish: "PRAN Curry Powder",
    productPrice: "4.50",
    productSupplier: "BCS SHOP",
    searchText: "মসলা ",
    sortOrder: "a",
    sourceSupplier: "GAZIPUR TRADING PTE LTD ",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "200G",
    updateDateTime: "03/08/2020 04:33:47",
    count: 4
  },
  {
    availability: "AVAILABLE",
    category: "SNACKS DRY FOOD",
    isPopular: "NO",
    key: "-M9a_YqhjXIpKB7_yC_b",
    photos: [
      {
        imageName: "3a2c76f0-ac5d-11ea-bbe4-619ccaa778ae.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F3a2c76f0-ac5d-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=10e0d0a5-0aa5-48a0-b5c8-bf72ce4be9e0"
      }
    ],
    productNameEnglish: "TOAST ",
    productPrice: "2",
    productSupplier: "BCS SHOP",
    sortOrder: "a",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1 pkt",
    updateDateTime: "23/07/2020 12:33:28",
    count: 4
  },
  {
    category: "FRUITS VEGETABLES ",
    key: "-M9bE9qlAKL7zmPvEStf",
    photos: [
      {
        imageName: "c4aaaea0-ac76-11ea-8ded-437354ec7423.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fc4aaaea0-ac76-11ea-8ded-437354ec7423.jpg?alt=media&token=c974a64a-f7b5-4fa1-9db5-9b788a8aebd2"
      }
    ],
    productNameEnglish: "House green peas",
    productPrice: "2.5",
    productSupplier: "BCS SHOP",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "500gm",
    updateDateTime: "04/07/2020 08:41:26",
    count: 4
  },
  {
    availability: "AVAILABLE",
    category: "LAUNDRY CLEANING",
    isPopular: "NO",
    key: "-MBZQu1RsS-9QxxS5if2",
    photos: [
      {
        imageName: "4b99b870-bf91-11ea-85e3-735b22b1a0db.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F4b99b870-bf91-11ea-85e3-735b22b1a0db.jpg?alt=media&token=6ce26509-6fce-4a04-b439-571b4e5c5b06"
      }
    ],
    productNameEnglish: "Comfort Fabric Conditioner ",
    productPrice: "8.50",
    productSupplier: "BCS SHOP",
    searchText: "কাপড়ের কন্ডিশনার ",
    sortOrder: "G",
    supplierContactName: "Ahmed Fayyaz",
    supplierContactPhone: "97861239",
    unit: "5L",
    updateDateTime: "03/08/2020 03:34:23",
    count: 4
  },
  {
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    isPopular: "YES",
    key: "-MA4p5aqO6oRSOzE2akk",
    photos: [
      {
        imageName: "b8777d30-bdaa-11ea-8ba8-ddb60ef370d4.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fb8777d30-bdaa-11ea-8ba8-ddb60ef370d4.jpg?alt=media&token=7a2ebcdb-2a16-4e7d-a5b5-a51bb6d7a2b2"
      }
    ],
    productNameEnglish: "Asparagus",
    productPrice: "1.30",
    productSupplier: "BCS SHOP",
    searchText: "শতমূলী ",
    sortOrder: "a",
    sourceSupplier: "Sheng siong ",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "100G",
    updateDateTime: "03/08/2020 04:18:07",
    count: 4
  },
  {
    category: "TOILETRIES",
    isPopular: "NO",
    key: "-M9pSVz724fKYscsYo5M",
    photos: [
      {
        imageName: "658d1060-aea2-11ea-9600-53e79e8cda87.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F658d1060-aea2-11ea-9600-53e79e8cda87.jpg?alt=media&token=13c54b10-010c-4ed1-b731-50814fea17d8"
      }
    ],
    productNameEnglish:
      "Harpic Toilet Cleaner Gel - Lavender Gel (Triple Pack)",
    productPrice: "7.90",
    productSupplier: "BCS SHOP",
    sortOrder: "x",
    sourceSupplier: "MUSTAFA CENTRE",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "3 x 500ml",
    updateDateTime: "03/08/2020 06:39:04",
    count: 4
  },
  {
    category: "SNACKS DRY FOOD",
    key: "-MA-qrE1HieKjeQuTrEM",
    photos: [
      {
        imageName: "d4390c60-b214-11ea-921f-9db4b33fb426.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fd4390c60-b214-11ea-921f-9db4b33fb426.jpg?alt=media&token=4f51f18a-ead2-4643-8f80-e28608e94849"
      }
    ],
    productNameEnglish: "Roller Coaster Potato Rings Cheese",
    productPrice: "2.20",
    productSupplier: "BCS SHOP",
    sortOrder: "h",
    sourceSupplier: "Sheng siong ",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "100g",
    updateDateTime: "04/07/2020 08:18:51",
    count: 4
  },
  {
    author: "+6589050302",
    category: "COSMETICS",
    isPopular: "NO",
    key: "-M9qwX0kiI-lR8hHtXgf",
    photos: [
      {
        imageName: "43ca48f0-aedc-11ea-9b4b-4bd8d539c6a6.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F43ca48f0-aedc-11ea-9b4b-4bd8d539c6a6.jpg?alt=media&token=62dffcf9-d577-426e-8455-1d872a352955"
      }
    ],
    productNameEnglish: "Parachute Coconut Hair Oil",
    productPrice: "5.50",
    productSupplier: "BCS SHOP",
    sortOrder: "x",
    sourceSupplier: "MUSTAFA CENTRE",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "300ML",
    updateDateTime: "Tue 25-08-20 10:02 am",
    count: 4
  },
  {
    availability: "AVAILABLE",
    category: "EGGS DAIRY",
    isPopular: "YES",
    key: "-MA-ktuqryWbJ1oNe27B",
    photos: [
      {
        imageName: "cab1b550-b216-11ea-921f-9db4b33fb426.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fcab1b550-b216-11ea-921f-9db4b33fb426.jpg?alt=media&token=82c4d1d3-fc45-4b34-8ba7-2f3986be66e8"
      }
    ],
    productNameEnglish: "Meiji Fresh Milk - Fullcream",
    productPrice: "3.8",
    productSupplier: "BCS SHOP",
    searchText: "fresh milk দুধ গরুর দুধ",
    sortOrder: "a",
    sourceSupplier: "Sheng siong ",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "830ml",
    updateDateTime: "03/08/2020 04:40:15",
    count: 4
  },
  {
    availability: "AVAILABLE",
    category: "LAUNDRY CLEANING",
    key: "-M9pKnaBOD1D8sHjw_gB",
    photos: [
      {
        imageName: "b025d7b0-ae9d-11ea-9600-53e79e8cda87.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fb025d7b0-ae9d-11ea-9600-53e79e8cda87.jpg?alt=media&token=c863610e-5db1-45af-9b1c-2fd066334842"
      }
    ],
    productNameEnglish: "CIF Cream Surface Cleanser - Lemon",
    productPrice: "2.30",
    productSupplier: "BCS SHOP",
    sortOrder: "x",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "500ml",
    updateDateTime: "03/08/2020 06:44:45",
    count: 4
  },
  {
    category: "COSMETICS",
    key: "-M9gKgvBNYEfi7GuI0gp",
    photos: [
      {
        imageName: "ea7248b0-ad3d-11ea-b044-d71d8f034373.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fea7248b0-ad3d-11ea-b044-d71d8f034373.jpg?alt=media&token=23e8e3f7-ba07-4ee2-a375-4d193ab8a223"
      }
    ],
    productNameEnglish: "Shaving foam sensitive",
    productPrice: "5",
    productSupplier: "BCS SHOP",
    sortOrder: "x",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "200ml",
    updateDateTime: "04/07/2020 10:19:58",
    count: 4
  },
  {
    availability: "AVAILABLE",
    category: "RICE DAAL NOODLES",
    key: "-MFsRVzvqlSw2jAmJbf5",
    photos: [
      {
        imageName: "f979c5b0-e9ae-11ea-88e9-2b8db057b537.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Ff979c5b0-e9ae-11ea-88e9-2b8db057b537.jpg?alt=media&token=596bc825-14ea-4551-a3e8-0cc03582f03e"
      }
    ],
    productNameEnglish: "Jaguar rice",
    productPrice: "35",
    productSupplier: "BCS SHOP",
    searchText: "rice",
    sortOrder: "a",
    supplierContactName: "Ismita",
    supplierContactPhone: "userMobile",
    unit: "25kg",
    updateDateTime: "Wed 02-12-20 10:20 am",
    count: 4
  },
  {
    category: "COOKING OIL INGREDIENTS",
    isPopular: "YES",
    key: "-MA-JybhhoZnd2xV63lY",
    photos: [
      {
        imageName: "cea1f350-b04a-11ea-9737-25db4b55bc7b.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fcea1f350-b04a-11ea-9737-25db4b55bc7b.jpg?alt=media&token=681ee9ef-0064-4948-9650-ab9f11d7211c"
      }
    ],
    productNameEnglish: "PRAN Haleem Masala Mix",
    productPrice: "3.90",
    productSupplier: "BCS SHOP",
    searchText: "হালীম মিক্স ",
    sortOrder: "a",
    sourceSupplier: "RAJDHANI ENTERPRISE PTE LTD",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "200G",
    updateDateTime: "03/08/2020 04:49:29",
    count: 4
  },
  {
    availability: "AVAILABLE",
    category: "RICE DAAL NOODLES",
    isPopular: "YES",
    key: "-M9abk1BKoOu9ucf_i0P",
    photos: [
      {
        imageName: "9cd4b370-ac5e-11ea-bbe4-619ccaa778ae.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F9cd4b370-ac5e-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=11a6a33d-b137-45d3-9d2b-ad3afd188bed"
      }
    ],
    productNameEnglish: "BASIL SEEDS ",
    productPrice: "2.50 ",
    productSupplier: "BCS SHOP",
    sortOrder: "d",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "80gm",
    updateDateTime: "23/07/2020 12:30:54",
    count: 4
  },
  {
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    isPopular: "YES",
    key: "-MA4S3yetf2_0OsXdh_r",
    photos: [
      {
        imageName: "f001f570-bdb2-11ea-8ba8-ddb60ef370d4.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ff001f570-bdb2-11ea-8ba8-ddb60ef370d4.jpg?alt=media&token=898fb46b-1f78-45f0-ab01-9c639e3ce5d3"
      }
    ],
    productNameEnglish: "Chinese Spinach",
    productPrice: "6",
    productSupplier: "BCS SHOP",
    searchText: "শাক সবজি সব্জি ",
    sortOrder: "a",
    sourceSupplier: "Sheng siong ",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1kg",
    updateDateTime: "03/08/2020 04:23:19",
    count: 4
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    isPopular: "YES",
    key: "-MA-HPrZgnI3W4ygoyv-",
    photos: [
      {
        imageName: "422b3310-b049-11ea-9737-25db4b55bc7b.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F422b3310-b049-11ea-9737-25db4b55bc7b.jpg?alt=media&token=db1d4ae7-2a5e-4164-beb4-1151e24ac62e"
      }
    ],
    productNameEnglish: "RADHUNI Kacchi Biryani Masala",
    productPrice: "3.50",
    productSupplier: "BCS SHOP",
    searchText: "খিচুড়ি মসলা",
    sortOrder: "a",
    sourceSupplier: "KHAN PRODUCTS PTE LTD.",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "40g",
    updateDateTime: "03/08/2020 04:51:31",
    count: 4
  },
  {
    availability: "AVAILABLE",
    category: "EGGS DAIRY",
    isPopular: "YES",
    key: "-M9b53-gYj3fNL3pj_SH",
    photos: [
      {
        imageName: "1b77f630-ac71-11ea-8ded-437354ec7423.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F1b77f630-ac71-11ea-8ded-437354ec7423.jpg?alt=media&token=965addb9-5921-433a-9f34-f72bf36b9e9d"
      }
    ],
    productNameEnglish: "HL banana/strawberry milk",
    productPrice: "3.5",
    productSupplier: "BCS SHOP",
    searchText: "fresh milk",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1L",
    updateDateTime: "23/07/2020 12:30:15",
    count: 4
  },
  {
    availability: "AVAILABLE",
    category: "KITCHEN DINING",
    isPopular: "NO",
    key: "-M9Y0JRabxNgOzFRkwKB",
    photos: [
      {
        imageName: "789397f0-c104-11ea-8470-83fbeadd4a74.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F789397f0-c104-11ea-8470-83fbeadd4a74.jpg?alt=media&token=c6042177-aa13-4df6-9285-dc86d85b4507"
      }
    ],
    productNameEnglish: "Rice cooker  big/small (price vary depending on size)",
    productPrice: "32",
    productSupplier: "BCS SHOP",
    searchText: "রাইস কুকার ",
    sortOrder: "x",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "Small",
    updateDateTime: "08/07/2020 06:19:47",
    count: 4
  },
  {
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    isPopular: "YES",
    key: "-MA4Sr5vL2D5WLOZOmOg",
    photos: [
      {
        imageName: "9a953700-bdb2-11ea-8ba8-ddb60ef370d4.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F9a953700-bdb2-11ea-8ba8-ddb60ef370d4.jpg?alt=media&token=1c8727fb-8e93-4f75-92f6-77d32bbcc8cf"
      }
    ],
    productNameEnglish: "Snake Gourd",
    productPrice: "6",
    productSupplier: "BCS SHOP",
    searchText: "kioda",
    sortOrder: "a",
    sourceSupplier: "Veg mart ",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1KG",
    updateDateTime: "03/08/2020 04:22:47",
    count: 4
  },
  {
    availability: "AVAILABLE",
    category: "KITCHEN DINING",
    key: "-M9XOy8oD7hBLxHrPrJX",
    photos: [
      {
        imageName: "5a2486a0-c102-11ea-8470-83fbeadd4a74.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F5a2486a0-c102-11ea-8470-83fbeadd4a74.jpg?alt=media&token=76f61b35-0100-44eb-9d57-c4bac42986dd"
      }
    ],
    productNameEnglish: "Cutting board",
    productPrice: "  5",
    productSupplier: "BCS SHOP",
    sortOrder: "x",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1 pc",
    updateDateTime: "08/07/2020 06:04:18",
    count: 4
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    key: "-M9b5Bp3rmdHU8muuty_",
    photos: [
      {
        imageName: "4b76a4d0-ac71-11ea-83ef-037972cabc05.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F4b76a4d0-ac71-11ea-83ef-037972cabc05.jpg?alt=media&token=a11dd7c0-eddb-4e21-8a2a-d75748c554d6"
      }
    ],
    productNameEnglish: "EX VIRGIN OLIVE OIL (500g)",
    productPrice: "9",
    productSupplier: "BCS SHOP",
    searchText: "অলিভ অয়েল",
    sortOrder: "g",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "500g",
    updateDateTime: "17/07/2020 07:35:50",
    count: 4
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    isPopular: "YES",
    key: "-MA-DAJ7J3Q4gm8p6wKi",
    photos: [
      {
        imageName: "9c1606f0-b046-11ea-9737-25db4b55bc7b.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F9c1606f0-b046-11ea-9737-25db4b55bc7b.jpg?alt=media&token=a1c6f9d6-7e57-4f6a-92d2-541d9b842aed"
      }
    ],
    productNameEnglish: "RADHUNI Chicken Roast Masala",
    productPrice: "3",
    productSupplier: "BCS SHOP",
    searchText: "রোস্ট মসলা",
    sortOrder: "a",
    sourceSupplier: "FAHIM ENTERPRISE PTE LTD",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "35G",
    updateDateTime: "03/08/2020 04:55:51",
    count: 3
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    isPopular: "YES",
    key: "-M9aOOa2t7sa0B0gRCVr",
    productNameEnglish: "TURMERIC POWDER",
    productPrice: "3.80",
    productSupplier: "BCS SHOP",
    searchText: "হলুদের গুঁড়া",
    sortOrder: "a",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1 pkt",
    updateDateTime: "Fri 14-08-20 4:52 pm",
    count: 3
  },
  {
    category: "LAUNDRY CLEANING",
    isPopular: "NO",
    key: "-M9qcstKKSzKgQ2W8Bup",
    photos: [
      {
        imageName: "64199450-aed0-11ea-9cc0-814fbb741388.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F64199450-aed0-11ea-9cc0-814fbb741388.jpg?alt=media&token=1f9802e1-9582-4cfd-8c7d-1728e0481e5a"
      }
    ],
    productNameEnglish: "TOP Concentrated Liquid Detergent",
    productPrice: "4.95",
    productSupplier: "BCS SHOP",
    sortOrder: "d",
    sourceSupplier: "Sheng siong ",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1.5KG",
    updateDateTime: "03/08/2020 05:57:11",
    count: 3
  },
  {
    category: "DRINKS DESSERT",
    key: "-M9fhS6QGXX68eQ9dmb3",
    photos: [
      {
        imageName: "802adf70-ad25-11ea-9a01-db9ea96fa329.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F802adf70-ad25-11ea-9a01-db9ea96fa329.jpg?alt=media&token=7621a176-01e6-40cd-b809-31d3b39e5a1c"
      }
    ],
    productNameEnglish: "POKKA JASMINE GREEN TEA",
    productPrice: "2.30",
    productSupplier: "BCS SHOP",
    sortOrder: "d",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1.5L",
    updateDateTime: "04/07/2020 11:26:34",
    count: 3
  },
  {
    category: "COOKING OIL INGREDIENTS",
    key: "-M9fHP84oZPiAZSRRsOP",
    photos: [
      {
        imageName: "bbcff260-ad14-11ea-9aab-f922f3904dfb.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fbbcff260-ad14-11ea-9aab-f922f3904dfb.jpg?alt=media&token=934ff842-6292-41be-a5f6-9974a4382200"
      }
    ],
    productNameEnglish: "Tamarind",
    productPrice: "8",
    productSupplier: "BCS SHOP",
    sortOrder: "d",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1 box",
    updateDateTime: "05/07/2020 12:07:26",
    count: 3
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    key: "-M9b4vSa-PhukassruCo",
    photos: [
      {
        imageName: "20d2f6c0-ac71-11ea-83ef-037972cabc05.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F20d2f6c0-ac71-11ea-83ef-037972cabc05.jpg?alt=media&token=ff856e15-d9cc-4c1f-85c8-cac13e95f741"
      }
    ],
    productNameEnglish: "OLIVE OIL (500g)",
    productPrice: "8.90",
    productSupplier: "BCS SHOP",
    searchText: "অলিভ অয়েল",
    sortOrder: "g",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "500g",
    updateDateTime: "17/07/2020 07:36:02",
    count: 3
  },
  {
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    isPopular: "YES",
    key: "-MA4Ro3P0gWz-3jP48Hf",
    photos: [
      {
        imageName: "8716b770-bdb3-11ea-8ba8-ddb60ef370d4.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F8716b770-bdb3-11ea-8ba8-ddb60ef370d4.jpg?alt=media&token=a0ca6b1d-bd33-4760-a2c5-d8fda67aea78"
      }
    ],
    productNameEnglish: "Beetroot",
    productPrice: "6.30",
    productSupplier: "BCS SHOP",
    sortOrder: "a",
    sourceSupplier: "Amman trading ",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1kg",
    updateDateTime: "03/08/2020 04:23:27",
    count: 3
  },
  {
    category: "EGGS DAIRY",
    isPopular: "YES",
    key: "-M9Y0vKi7518NwH69ezs",
    photos: [
      {
        imageName: "86d52960-abd2-11ea-8036-6322e2b6fd90.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F86d52960-abd2-11ea-8036-6322e2b6fd90.jpg?alt=media&token=2d3b7e72-63a9-443d-a1b2-2ba5ba38dd63"
      }
    ],
    productNameEnglish: "Honey ",
    productPrice: "11",
    productSupplier: "BCS SHOP",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1L",
    updateDateTime: "04/07/2020 09:16:35",
    count: 3
  },
  {
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    isPopular: "YES",
    key: "-MA4QI8ipDkr4X8KBkor",
    photos: [
      {
        imageName: "c52412a0-bdb4-11ea-8ba8-ddb60ef370d4.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fc52412a0-bdb4-11ea-8ba8-ddb60ef370d4.jpg?alt=media&token=b5d18bfe-7750-4a31-9b59-84a9e88a4192"
      }
    ],
    productNameEnglish: "Water Spinach",
    productPrice: "4.50",
    productSupplier: "BCS SHOP",
    searchText: "shak sak kolmi shak শাক সবজি সব্জি ",
    sortOrder: "a",
    sourceSupplier: "Veg mart ",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1KG",
    updateDateTime: "03/08/2020 04:24:21",
    count: 3
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    isPopular: "YES",
    key: "-MA-CZjNP6303XAWLm3m",
    photos: [
      {
        imageName: "48f81a80-b046-11ea-9737-25db4b55bc7b.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F48f81a80-b046-11ea-9737-25db4b55bc7b.jpg?alt=media&token=8c0b64c1-d561-41b4-8682-1c1d3e49861b"
      }
    ],
    productNameEnglish: "RADHUNI Chicken Masala",
    productPrice: "2.90",
    productSupplier: "BCS SHOP",
    searchText: "চিকেন কারি মসলা ",
    sortOrder: "a",
    sourceSupplier: "RAJDHANI ENTERPRISE PTE LTD",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "20G",
    updateDateTime: "03/08/2020 04:56:19",
    count: 3
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    isPopular: "YES",
    key: "-M9aUAXelq_RZ3rWlftI",
    photos: [
      {
        imageName: "537ba3a0-ac59-11ea-bbe4-619ccaa778ae.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F537ba3a0-ac59-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=1555adaf-446a-4c95-93c1-57199b0e6efd"
      }
    ],
    productNameEnglish: "STAR ANISE ",
    productPrice: "2.70",
    productSupplier: "BCS SHOP",
    sortOrder: "a",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1 pkt",
    updateDateTime: "23/07/2020 12:47:57",
    count: 3
  },
  {
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    isPopular: "YES",
    key: "-MA4Q4kMB-2H30JLy_Tc",
    photos: [
      {
        imageName: "1013ba40-bdb5-11ea-8ba8-ddb60ef370d4.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F1013ba40-bdb5-11ea-8ba8-ddb60ef370d4.jpg?alt=media&token=ca1800da-00c4-4a5d-8e27-541faa9ef57b"
      }
    ],
    productNameEnglish: "Mustard Spinach",
    productPrice: " 4.50",
    productSupplier: "BCS SHOP",
    searchText: "শাক সবজি সব্জি ",
    sortOrder: "a",
    sourceSupplier: "Sai shanmuga",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1KG",
    updateDateTime: "03/08/2020 04:24:56",
    count: 3
  },
  {
    category: "TOILETRIES",
    key: "-M9qQN2dHSWptq7fJzue",
    photos: [
      {
        imageName: "2394d4b0-aec8-11ea-9cc0-814fbb741388.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F2394d4b0-aec8-11ea-9cc0-814fbb741388.jpg?alt=media&token=e0893cba-c5bf-451d-b2b6-02913362973d"
      }
    ],
    productDescription: " (10x200 per pack)",
    productNameEnglish: "PurSoft 4-ply Unscented Toilet Tissue Roll",
    productPrice: "7.95",
    productSupplier: "BCS SHOP",
    sortOrder: "k",
    sourceSupplier: "Sheng siong ",
    supplierContactName: "arif",
    supplierContactPhone: "84124637",
    unit: "10 ROLLS",
    updateDateTime: "03/08/2020 06:10:46",
    count: 3
  },
  {
    category: "COSMETICS",
    key: "-MA3zG1eWkBbKPxN7U2B",
    photos: [
      {
        imageName: "528111c0-b211-11ea-921f-9db4b33fb426.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F528111c0-b211-11ea-921f-9db4b33fb426.jpg?alt=media&token=d655ecbd-cf81-4bf6-86e4-c07f1465b077"
      }
    ],
    productNameEnglish: "Himalaya Oil Control Facial Wash",
    productPrice: "6.95",
    productSupplier: "BCS SHOP",
    searchText: "ফেইস ওয়াশ ",
    sortOrder: "x",
    sourceSupplier: "MUSTAFA CENTRE",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "100ML",
    updateDateTime: "03/08/2020 04:27:51",
    count: 3
  },
  {
    availability: "AVAILABLE",
    category: "EGGS DAIRY",
    isPopular: "YES",
    key: "-MA-kMYufmGnT6XGDUuI",
    photos: [
      {
        imageName: "bdea5130-bc5a-11ea-b7df-33e703b87300.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fbdea5130-bc5a-11ea-b7df-33e703b87300.jpg?alt=media&token=f0c580f0-f44b-4340-8622-95a8c448576d"
      }
    ],
    productNameEnglish: "Meiji Chocolate Fresh Milk - Fullcream",
    productPrice: "6.50",
    productSupplier: "BCS SHOP",
    searchText: "চকলেট দুধ ",
    sortOrder: "a",
    sourceSupplier: "Sheng siong ",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "2L",
    updateDateTime: "03/08/2020 04:41:31",
    count: 3
  },
  {
    category: "MEAT FISH",
    isPopular: "YES",
    key: "-M9zyaGEkwWHN4gqOv1u",
    photos: [
      {
        imageName: "375432e0-b03d-11ea-9737-25db4b55bc7b.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F375432e0-b03d-11ea-9737-25db4b55bc7b.jpg?alt=media&token=4411a332-092b-42e5-ac8f-e1d8eba8890e"
      }
    ],
    productNameEnglish: "Mrigal Carp",
    productPrice: "6",
    productSupplier: "BCS SHOP",
    sortOrder: "a",
    sourceSupplier: "RAJDHANI ENTERPRISE PTE LTD",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1KG",
    updateDateTime: "03/08/2020 05:19:16",
    count: 3
  },
  {
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    key: "-M9f6-hjDca9ThhkT2Hd",
    photos: [
      {
        imageName: "bc718dc0-ad0d-11ea-873f-e1ac34f7defb.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fbc718dc0-ad0d-11ea-873f-e1ac34f7defb.jpg?alt=media&token=37b690be-6f9d-4570-a5fc-9c51cfa9cfaf"
      }
    ],
    productNameEnglish: "Red dragonfruits 1pcs",
    productPrice: "3",
    productSupplier: "BCS SHOP",
    searchText: "ফল ",
    sortOrder: "g",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    updateDateTime: "17/07/2020 02:38:26",
    count: 3
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    key: "-MFibGQ-UkRLc5KS5egA",
    photos: [
      {
        imageName: "78902f00-e834-11ea-a70c-3f9f15f1ac0f.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F78902f00-e834-11ea-a70c-3f9f15f1ac0f.jpg?alt=media&token=8d492700-63b7-4f9c-b6c3-0cc418dd1bba"
      }
    ],
    productNameEnglish: "Shan curry powdser",
    productPrice: "1.30",
    productSupplier: "BCS SHOP",
    searchText: "curry powdser",
    sortOrder: "a",
    supplierContactName: "Ismita",
    supplierContactPhone: "userMobile",
    unit: "1009",
    updateDateTime: "Thu 27-08-20 3:11 pm",
    count: 3
  },
  {
    category: "TOILETRIES",
    key: "-M9qYI1DC5DjkLn0Bs38",
    photos: [
      {
        imageName: "c88cbf10-aecc-11ea-9cc0-814fbb741388.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fc88cbf10-aecc-11ea-9cc0-814fbb741388.jpg?alt=media&token=d62e26c4-b6ff-4dbe-80cc-77dc252ceb46"
      }
    ],
    productDescription: "(20 x185 per pack)",
    productNameEnglish: "Scott Extra Regular 2-ply Toilet Tissue Roll ",
    productPrice: "6.95",
    productSupplier: "BCS SHOP",
    sortOrder: "k",
    sourceSupplier: "Sheng siong ",
    supplierContactName: "arif",
    supplierContactPhone: "84124637",
    unit: "20rolls of 1packet",
    updateDateTime: "03/08/2020 06:03:42",
    count: 3
  },
  {
    category: "FRUITS VEGETABLES ",
    key: "-M9b4ZZZ7PcOh0dRuFGt",
    photos: [
      {
        imageName: "e95d4560-ac70-11ea-83ef-037972cabc05.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fe95d4560-ac70-11ea-83ef-037972cabc05.jpg?alt=media&token=f36c38b9-4c29-4d2e-839e-1e5c8c5d5f0d"
      }
    ],
    productNameEnglish: "LYCHEE ",
    productPrice: "2.50",
    productSupplier: "BCS SHOP",
    sortOrder: "d",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1 tin",
    updateDateTime: "05/07/2020 12:09:39",
    count: 3
  },
  {
    category: "SNACKS DRY FOOD",
    key: "-M9b9Op5cDWf7IC8FFcy",
    photos: [
      {
        imageName: "bf2745e0-ac73-11ea-8ded-437354ec7423.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fbf2745e0-ac73-11ea-8ded-437354ec7423.jpg?alt=media&token=520e2bfc-0d06-498c-a981-3242f6248a5f"
      }
    ],
    productNameEnglish: "Swiss roll cake",
    productPrice: "4",
    productSupplier: "BCS SHOP",
    sortOrder: "d",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "24 pcs1 Pkt",
    updateDateTime: "04/07/2020 08:48:37",
    count: 3
  },
  {
    category: "RICE DAAL NOODLES",
    key: "-M9b6LuJF4v10S5epeVw",
    photos: [
      {
        imageName: "dd707c80-ac71-11ea-8ded-437354ec7423.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fdd707c80-ac71-11ea-8ded-437354ec7423.jpg?alt=media&token=1f3a11e0-40f5-4c9a-8ecc-1162674a012c"
      }
    ],
    productNameEnglish: "Noodles",
    productPrice: "3.8",
    productSupplier: "BCS SHOP",
    sortOrder: "d",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1 Pkt",
    updateDateTime: "04/07/2020 11:32:29",
    count: 3
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    photos: [
      {
        imageName: "c421a070-e82a-11ea-b1ae-e3e3c2d1f850.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Fc421a070-e82a-11ea-b1ae-e3e3c2d1f850.jpg?alt=media&token=07f14e77-8d80-45e6-883c-21c101e6d174"
      }
    ],
    productNameEnglish: "Shan  meat masala ",
    productPrice: "1.50",
    productSupplier: "BCS SHOP",
    searchText: "beef masala",
    sortOrder: "a",
    supplierContactName: "Ismita",
    supplierContactPhone: "userMobile",
    unit: "100g",
    updateDateTime: "Thu 27-08-20 2:01 pm",
    key: "-MFiVVjX_u5zP1rN9Ry4",
    count: 3
  },
  {
    category: "STATIONARY",
    isPopular: "NO",
    key: "-MA97iEs6t-46LTZdr79",
    photos: [
      {
        imageName: "f3f5da60-b1c9-11ea-825a-3b8acfde6ce7.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ff3f5da60-b1c9-11ea-825a-3b8acfde6ce7.jpg?alt=media&token=2126a9bb-b23a-4e19-b90a-dad4ee598980"
      }
    ],
    productNameEnglish: "Zebra Gel Ink Pen 0.5m (Blue, Black, Red)",
    productPrice: "1.70",
    productSupplier: "BCS SHOP",
    searchText: "কলম ",
    sortOrder: "n",
    sourceSupplier: "MUSTAFA CENTRE",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1 Pc",
    updateDateTime: "03/08/2020 04:05:06",
    count: 3
  },
  {
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    isPopular: "YES",
    key: "-MA4TIuNH4iVUoOtOw9y",
    photos: [
      {
        imageName: "354dc920-bdb2-11ea-8ba8-ddb60ef370d4.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F354dc920-bdb2-11ea-8ba8-ddb60ef370d4.jpg?alt=media&token=eb5c5fad-95a9-4526-a381-ec948a1f1588"
      }
    ],
    productNameEnglish: "Corn",
    productPrice: "6",
    productSupplier: "BCS SHOP",
    searchText: "butta bhotta botta",
    sortOrder: "a",
    sourceSupplier: "Sai shanmuga",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1KG",
    updateDateTime: "03/08/2020 04:22:32",
    count: 3
  },
  {
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    isPopular: "YES",
    key: "-MA4YlCmN4oegMgqBchv",
    photos: [
      {
        imageName: "18831770-b117-11ea-810a-c5e0250e7646.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F18831770-b117-11ea-810a-c5e0250e7646.jpg?alt=media&token=306c4a1c-00c9-4de9-b081-8a36cc3198ca"
      }
    ],
    productNameEnglish: "Green Spinach",
    productPrice: "5",
    productSupplier: "BCS SHOP",
    searchText: "ডাটা শাক ",
    sortOrder: "a",
    sourceSupplier: "B&S minimart ",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1KG",
    updateDateTime: "03/08/2020 04:19:36",
    count: 3
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    photos: [
      {
        imageName: "18b54780-e82c-11ea-b1ae-e3e3c2d1f850.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F18b54780-e82c-11ea-b1ae-e3e3c2d1f850.jpg?alt=media&token=bf58c58e-92c1-486b-9dcb-ba6d328154e6"
      }
    ],
    productNameEnglish: "Shan bombay biryani",
    productPrice: "1.50",
    productSupplier: "BCS SHOP",
    searchText: " bombay biryani",
    sortOrder: "a",
    supplierContactName: "Ismita",
    supplierContactPhone: "userMobile",
    unit: "60g",
    updateDateTime: "Thu 27-08-20 2:11 pm",
    key: "-MFiXeZ-jb04oeSw6EvZ",
    count: 3
  },
  {
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    key: "-M9cYvMUq77vUI_OoT1F",
    photos: [
      {
        imageName: "7f025ae0-acaa-11ea-ab51-0f18e1d42bbd.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F7f025ae0-acaa-11ea-ab51-0f18e1d42bbd.jpg?alt=media&token=86f6c9d0-27ce-4dcc-9319-d9bf2021235b"
      }
    ],
    productNameEnglish: "CHERRIES ",
    productPrice: "5",
    productSupplier: "BCS SHOP",
    searchText: " চেরি ",
    sortOrder: "g",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "250gm",
    updateDateTime: "17/07/2020 02:42:16",
    count: 3
  },
  {
    category: "TOILETRIES",
    key: "-M9puZTivnTeQamZ9h6T",
    photos: [
      {
        imageName: "21140d50-aeb4-11ea-9600-53e79e8cda87.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F21140d50-aeb4-11ea-9600-53e79e8cda87.jpg?alt=media&token=81b19c6e-5506-4e8d-9fac-a5c6a206ff24"
      }
    ],
    productDescription: "(4x 130 per pack)",
    productNameEnglish: "PurSoft 3-ply Tissue Soft Pack - Sakura",
    productPrice: "5.85",
    productSupplier: "BCS SHOP",
    sortOrder: "k",
    sourceSupplier: "Giant supermarket ",
    supplierContactName: "arif",
    supplierContactPhone: "84124637",
    unit: "4 box of 1 pack",
    updateDateTime: "03/08/2020 06:24:16",
    count: 3
  },
  {
    category: "COSMETICS",
    key: "-M9gPGIcBzoPH_xk4Hz7",
    photos: [
      {
        imageName: "9f9ab590-ad40-11ea-93aa-6d00775cfd30.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F9f9ab590-ad40-11ea-93aa-6d00775cfd30.jpg?alt=media&token=68fa78d7-9e96-4868-95e6-4412c436c044"
      }
    ],
    productNameEnglish: "Shaving  razor gillette blue ll disposable",
    productPrice: "6.2",
    productSupplier: "BCS SHOP",
    sortOrder: "x",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "5pcs 1 Pkt",
    updateDateTime: "04/07/2020 10:16:13",
    count: 3
  },
  {
    availability: "AVAILABLE",
    category: "MEAT FISH",
    key: "-MGaNOtrs0L79H33eYUy",
    photos: [
      {
        imageName: "a6c3d130-f0b1-11ea-ba7d-67bd2d78e913.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Fa6c3d130-f0b1-11ea-ba7d-67bd2d78e913.jpg?alt=media&token=7709abad-f84a-4486-a87b-be3911a8159d"
      }
    ],
    productNameEnglish: "  Fish sea bass",
    productPrice: "13",
    productSupplier: "BCS SHOP",
    searchText: "sea bass",
    sortOrder: "a",
    supplierContactName: "Ismita",
    supplierContactPhone: "userMobile",
    unit: "1 kg",
    updateDateTime: "Mon 07-09-20 12:41 pm",
    count: 3
  },
  {
    availability: "AVAILABLE",
    category: "TOILETRIES",
    key: "-MBZTrIFVTqwGck8rn8m",
    photos: [
      {
        imageName: "f1102900-bf92-11ea-85e3-735b22b1a0db.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ff1102900-bf92-11ea-85e3-735b22b1a0db.jpg?alt=media&token=50b005e2-febd-48d7-8794-60c091da833b"
      }
    ],
    productNameEnglish: "JOHNSON'S Baby Cotton Touch Bath Hair & Body ",
    productPrice: "10.90",
    productSupplier: "BCS SHOP",
    searchText: "বেবি শাওয়ার জেল বাচ্চাদের সেম্পো ",
    sortOrder: "g",
    supplierContactName: "Ahmed Fayyaz",
    supplierContactPhone: "97861239",
    unit: "500ml",
    updateDateTime: "03/08/2020 03:32:25",
    count: 2
  },
  {
    category: "DRINKS DESSERT",
    key: "-M9gJtbCb0YkR0UOC832",
    photos: [
      {
        imageName: "93e32a50-ad3d-11ea-9a01-db9ea96fa329.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F93e32a50-ad3d-11ea-9a01-db9ea96fa329.jpg?alt=media&token=d465428e-eb58-4e56-a18a-4730941b0d60"
      }
    ],
    productNameEnglish: "NESCAFE WHITE COFFEE GAO SIEW DAI",
    productPrice: "7.30",
    productSupplier: "BCS SHOP",
    sortOrder: "x",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "620g",
    updateDateTime: "04/07/2020 10:20:27",
    count: 2
  },
  {
    availability: "AVAILABLE",
    category: "DRINKS DESSERT",
    key: "-MA5NwKyqKA9eFI0wbuP",
    photos: [
      {
        imageName: "871ca320-b137-11ea-b71d-553b8acbaa9c.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F871ca320-b137-11ea-b71d-553b8acbaa9c.jpg?alt=media&token=bc7e80ca-9767-4d15-8574-d0e5221168cf"
      }
    ],
    productNameEnglish: "Basil Seed Drink - Strawberry",
    productPrice: "1.90",
    productSupplier: "BCS SHOP",
    searchText: "জুস তুকমার ",
    sortOrder: "a",
    sourceSupplier: "Hao mart ",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "290ML",
    updateDateTime: "03/08/2020 04:14:55",
    count: 2
  },
  {
    category: "COSMETICS",
    key: "-MA3zhczyKdhiqCr32ZG",
    photos: [
      {
        imageName: "052bb4c0-b211-11ea-921f-9db4b33fb426.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F052bb4c0-b211-11ea-921f-9db4b33fb426.jpg?alt=media&token=e7f225f8-f2ae-4237-9713-ab74cb16d6d8"
      }
    ],
    productNameEnglish: "Himalaya Purifying Neem Facial Wash",
    productPrice: "8.50",
    productSupplier: "BCS SHOP",
    searchText: "ফেইস ওয়াশ ",
    sortOrder: "x",
    sourceSupplier: "MUSTAFA CENTRE",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "100ml",
    updateDateTime: "03/08/2020 04:27:34",
    count: 2
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    key: "-M9b5ar5vEu4FvrUc5PY",
    photos: [
      {
        imageName: "8aedbea0-ac71-11ea-83ef-037972cabc05.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F8aedbea0-ac71-11ea-83ef-037972cabc05.jpg?alt=media&token=83c21cb4-13c3-4fba-a834-0765f3336e9b"
      }
    ],
    productNameEnglish: "EX VIRGIN OLIVE OIL (1l)",
    productPrice: "16",
    productSupplier: "BCS SHOP",
    searchText: "অলিভ অয়েল",
    sortOrder: "a",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1l",
    updateDateTime: "17/07/2020 07:35:39",
    count: 2
  },
  {
    availability: "AVAILABLE",
    category: "EGGS DAIRY",
    key: "-MBZN9kTGTqkO56A11u1",
    photos: [
      {
        imageName: "0d6df540-bf8f-11ea-85e3-735b22b1a0db.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F0d6df540-bf8f-11ea-85e3-735b22b1a0db.jpg?alt=media&token=8961a300-1fe0-4fa1-bf4d-709c0211f5c9"
      }
    ],
    productNameEnglish: "Skippy Peanut Butter Spread - Grape Stripe",
    productPrice: "7",
    productSupplier: "BCS SHOP",
    searchText: "পিনাট বাটার ",
    sortOrder: "G",
    supplierContactName: "Ahmed Fayyaz",
    supplierContactPhone: "97861239",
    unit: "530gm",
    updateDateTime: "03/08/2020 03:36:01",
    count: 2
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    isPopular: "YES",
    key: "-MABh5F4COBtDnGWP0a5",
    photos: [
      {
        imageName: "58c0c6d0-b22e-11ea-b6a3-23fbd917d0cb.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F58c0c6d0-b22e-11ea-b6a3-23fbd917d0cb.jpg?alt=media&token=735b5ca8-1c8a-4ba7-af19-27cb07214585"
      }
    ],
    productNameEnglish: "Cinnamon Powder ",
    productPrice: "1.50",
    productSupplier: "BCS SHOP",
    searchText: "thenga masala দারচিনি দারুচিনি ",
    sortOrder: "a",
    supplierContactName: "Ahmed Fayyaz",
    supplierContactPhone: "97861239",
    unit: "50gm",
    updateDateTime: "03/08/2020 03:55:24",
    count: 2
  },
  {
    category: "COOKING OIL INGREDIENTS",
    key: "-M9fEv9wilhI77kVkDgi",
    photos: [
      {
        imageName: "79b1c9e0-ad13-11ea-8bc0-03f48af12a9c.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F79b1c9e0-ad13-11ea-8bc0-03f48af12a9c.jpg?alt=media&token=2ffbae79-99c5-4212-b576-e0e505d8c906"
      }
    ],
    productNameEnglish: "KARA UHT NATURAL COCONUT CREAM",
    productPrice: "1",
    productSupplier: "BCS SHOP",
    searchText: "নারিকেল ক্রিম ",
    sortOrder: "d",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "200ml",
    updateDateTime: "17/07/2020 02:32:43",
    count: 2
  },
  {
    availability: "AVAILABLE",
    category: "COSMETICS",
    key: "-M9qa24w0jVeMHfHk1AX",
    photos: [
      {
        imageName: "6a8fb3c0-aece-11ea-b774-7962c3b67908.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F6a8fb3c0-aece-11ea-b774-7962c3b67908.jpg?alt=media&token=2afb5185-b527-40a9-ad71-6e043bc75fd6"
      }
    ],
    productNameEnglish:
      "Oil Control Facial Cleanser Moisturizing Skin Care Deep Cleansing",
    productPrice: "9",
    productSupplier: "BCS SHOP",
    searchText: "ফেইস ওয়াশ ",
    sortOrder: "k",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1 pc of 100ML",
    updateDateTime: "03/08/2020 06:00:28",
    count: 2
  },
  {
    category: "FRUITS VEGETABLES ",
    key: "-M9fIYlyi8xetbpfusCw",
    photos: [
      {
        imageName: "892f5340-ad15-11ea-abb1-91c43b08e32b.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F892f5340-ad15-11ea-abb1-91c43b08e32b.jpg?alt=media&token=4bb9b087-f6d1-4d94-9fe4-1d9e1c8f954b"
      }
    ],
    productNameEnglish: "Starfruit",
    productPrice: "3.7",
    productSupplier: "BCS SHOP",
    searchText: "কামরাঙ্গা কামরাঙা ",
    sortOrder: "d",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1 Pkt",
    updateDateTime: "17/07/2020 02:18:09",
    count: 2
  },
  {
    category: "TOILETRIES",
    key: "-M9qUoKPglLjSU6mkOlJ",
    photos: [
      {
        imageName: "da5e9580-aeca-11ea-9cc0-814fbb741388.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fda5e9580-aeca-11ea-9cc0-814fbb741388.jpg?alt=media&token=71e145eb-7628-449b-ba7a-7fb143f431b9"
      }
    ],
    productDescription: "(10x220 per pack)",
    productNameEnglish: "PurSoft 3-ply Unscented Toilet Tissue Roll",
    productPrice: "7.55",
    productSupplier: "BCS SHOP",
    sortOrder: "k",
    sourceSupplier: "Sheng siong ",
    supplierContactName: "arif",
    supplierContactPhone: "84124637",
    unit: "10 ROLLS",
    updateDateTime: "03/08/2020 06:10:53",
    count: 2
  },
  {
    category: "TOILETRIES",
    key: "-M9gGFKEWkHfoqW5in6t",
    photos: [
      {
        imageName: "2a2ab8a0-ad3b-11ea-b044-d71d8f034373.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F2a2ab8a0-ad3b-11ea-b044-d71d8f034373.jpg?alt=media&token=f35abdf8-f1c8-4c68-b7d0-81829f447870"
      }
    ],
    productNameEnglish:
      "Toothpaste with toothbrush darlie double action travel kit     ",
    productPrice: "5",
    productSupplier: "BCS SHOP",
    sortOrder: "d",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    updateDateTime: "04/07/2020 10:54:32",
    count: 2
  },
  {
    category: "KITCHEN DINING",
    key: "-M9po6TUpI01bzNV0pbR",
    photos: [
      {
        imageName: "2e88b610-aeb0-11ea-9600-53e79e8cda87.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F2e88b610-aeb0-11ea-9600-53e79e8cda87.jpg?alt=media&token=1e157c4b-141d-45fa-a064-4dcad4405183"
      }
    ],
    productDescription: "(4x1pre pack)",
    productNameEnglish: "3M Scotch Brite Scrub Sponges - Heavy Duty",
    productPrice: "4.90",
    productSupplier: "BCS SHOP",
    sortOrder: "x",
    sourceSupplier: "MUSTAFA CENTRE",
    supplierContactName: "arif",
    supplierContactPhone: "84124637",
    unit: "1 packet",
    updateDateTime: "03/08/2020 06:29:20",
    count: 2
  },
  {
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    key: "-M9f6NsuqgGRpQGN_8t1",
    photos: [
      {
        imageName: "169a2f10-c653-11ea-8937-41f6a00ee84d.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F169a2f10-c653-11ea-8937-41f6a00ee84d.jpg?alt=media&token=e2a6c182-c7e7-4795-8fc8-8c003bd260fa"
      }
    ],
    productNameEnglish: "Capsicum green msia 1kg",
    productPrice: "4.5",
    productSupplier: "BCS SHOP",
    sortOrder: "g",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1 kg",
    updateDateTime: "15/07/2020 12:24:50",
    count: 2
  },
  {
    availability: "AVAILABLE",
    category: "KITCHEN DINING",
    isPopular: "NO",
    key: "-MBZMcaPJsYk9yNqB2rR",
    photos: [
      {
        imageName: "8234a190-bf8e-11ea-85e3-735b22b1a0db.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F8234a190-bf8e-11ea-85e3-735b22b1a0db.jpg?alt=media&token=9fc38ddf-89a0-4a9d-96b8-11c71de2c0ae"
      }
    ],
    productNameEnglish: "Kitchen Towel Rolls ",
    productPrice: "4.50",
    productSupplier: "BCS SHOP",
    searchText: "কিচেন তোয়ালে ",
    sortOrder: "G",
    supplierContactName: "Ahmed Fayyaz",
    supplierContactPhone: "97861239",
    unit: "6 roll pack",
    updateDateTime: "03/08/2020 03:37:10",
    count: 2
  },
  {
    category: "COSMETICS",
    key: "-M9gRgxHShbWEYSu17Cn",
    photos: [
      {
        imageName: "33d1b690-ad42-11ea-93aa-6d00775cfd30.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F33d1b690-ad42-11ea-93aa-6d00775cfd30.jpg?alt=media&token=875b5b96-20bd-4317-a434-3d372ee73b39"
      }
    ],
    productNameEnglish: "Shaving Razor gillette mach3 ",
    productPrice: "10.60",
    productSupplier: "BCS SHOP",
    sortOrder: "x",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    updateDateTime: "04/07/2020 10:15:35",
    count: 2
  },
  {
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    key: "-M9f8BRtoL4FZNlxklmG",
    photos: [
      {
        imageName: "3d7676f0-ad0f-11ea-873f-e1ac34f7defb.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F3d7676f0-ad0f-11ea-873f-e1ac34f7defb.jpg?alt=media&token=b0dda013-3aa5-4134-86a9-baf88f84a0f0"
      }
    ],
    productNameEnglish: "Capsicum msia 3pic one set",
    productPrice: "5",
    productSupplier: "BCS SHOP",
    sortOrder: "g",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "3 pcs",
    updateDateTime: "15/07/2020 12:21:53",
    count: 2
  },
  {
    category: "COSMETICS",
    key: "-M9gKOicoJLEhs3LeP7H",
    photos: [
      {
        imageName: "70a89c50-ad3d-11ea-b044-d71d8f034373.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F70a89c50-ad3d-11ea-b044-d71d8f034373.jpg?alt=media&token=c4a59294-5ba1-4a78-8794-0c400f5270df"
      },
      {
        imageName: "7485d680-ad3d-11ea-b044-d71d8f034373.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F7485d680-ad3d-11ea-b044-d71d8f034373.jpg?alt=media&token=3f02f0f4-aa9d-4165-9cbd-320544ceb0c7"
      }
    ],
    productNameEnglish: "Shaving foam gillette foamy lemon lime",
    productPrice: "7",
    productSupplier: "BCS SHOP",
    sortOrder: "x",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "175ml",
    updateDateTime: "04/07/2020 10:20:11",
    count: 2
  },
  {
    category: "EGGS DAIRY",
    key: "-M9fJG42PU0cJpHalor2",
    photos: [
      {
        imageName: "20dde440-ad16-11ea-8bc0-03f48af12a9c.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F20dde440-ad16-11ea-8bc0-03f48af12a9c.jpg?alt=media&token=d3d56b08-6320-4678-8f69-edfcce6be78b"
      }
    ],
    productNameEnglish: "AYAM BRAND COCONUT MILK",
    productPrice: "1.50",
    productSupplier: "BCS SHOP",
    sortOrder: "d",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "200ml",
    updateDateTime: "05/07/2020 12:03:09",
    count: 2
  },
  {
    availability: "AVAILABLE",
    category: "DRINKS DESSERT",
    isPopular: "NO",
    key: "-MA916B8NAJzyeMs1Zke",
    photos: [
      {
        imageName: "e5c26f20-b1c5-11ea-825a-3b8acfde6ce7.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fe5c26f20-b1c5-11ea-825a-3b8acfde6ce7.jpg?alt=media&token=5ecfdd83-beb4-4893-a59c-bdf95216aafa"
      }
    ],
    productNameEnglish: "Vitamilk Soymilk",
    productPrice: "1.50",
    productSupplier: "BCS SHOP",
    sortOrder: "a",
    sourceSupplier: "Hao mart ",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "300ML",
    updateDateTime: "03/08/2020 04:06:48",
    count: 2
  },
  {
    availability: "AVAILABLE",
    category: "RICE DAAL NOODLES",
    key: "-M9bFHt2KBV_U_2AlTyE",
    photos: [
      {
        imageName: "c7527db0-e8dd-11ea-b634-e7e7c4cb042d.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Fc7527db0-e8dd-11ea-b634-e7e7c4cb042d.jpg?alt=media&token=dce8fe2a-07fd-44be-86f3-d60ee842ceee"
      }
    ],
    productNameEnglish: "BAKERS WHEAT FLOUR",
    productPrice: "2",
    productSupplier: "BCS SHOP",
    searchText: "আটা ময়দা",
    sortOrder: "d",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1Kg",
    updateDateTime: "Fri 28-08-20 11:23 am",
    count: 2
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    isPopular: "YES",
    key: "-MA-h-OaWhiWRfI_qBp3",
    photos: [
      {
        imageName: "7ff8ef60-b059-11ea-8357-d5a4954c59fc.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F7ff8ef60-b059-11ea-8357-d5a4954c59fc.jpg?alt=media&token=e7a607ef-2500-4107-95d0-2dd6284fd2f9"
      }
    ],
    productNameEnglish: "PRAN Chicken Masala Powder",
    productPrice: "3.50",
    productSupplier: "BCS SHOP",
    searchText: "চিকেন কারি মসলা ",
    sortOrder: "c",
    sourceSupplier: "GAZIPUR TRADING PTE LTD ",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "100G",
    updateDateTime: "03/08/2020 04:45:00",
    count: 2
  },
  {
    category: "COSMETICS",
    key: "-M9gY6ErV_g_Qj3_Keuw",
    photos: [
      {
        imageName: "1f7f16c0-ad46-11ea-93aa-6d00775cfd30.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F1f7f16c0-ad46-11ea-93aa-6d00775cfd30.jpg?alt=media&token=59053b15-dc2f-46c9-9582-aa081c9e2961"
      }
    ],
    productNameEnglish: "Shaving rezor gillette vector ",
    productPrice: "5",
    productSupplier: "BCS SHOP",
    sortOrder: "k",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    updateDateTime: "04/07/2020 09:42:12",
    count: 2
  },
  {
    category: "COOKING OIL INGREDIENTS",
    key: "-M9fS0nIqI8eUKzfLF7t",
    photos: [
      {
        imageName: "7a48e020-ad1b-11ea-8bc0-03f48af12a9c.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F7a48e020-ad1b-11ea-8bc0-03f48af12a9c.jpg?alt=media&token=eaf48a60-1e24-47dd-992f-a5b47261b712"
      }
    ],
    productNameEnglish: "NATUREL CANOLA OIL",
    productPrice: "9.80",
    productSupplier: "BCS SHOP",
    sortOrder: "d",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "2L",
    updateDateTime: "04/07/2020 11:53:52",
    count: 2
  },
  {
    category: "DRINKS DESSERT",
    key: "-M9fkswjeL4wt6eRouVn",
    photos: [
      {
        imageName: "985ca680-ad27-11ea-9a01-db9ea96fa329.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F985ca680-ad27-11ea-9a01-db9ea96fa329.jpg?alt=media&token=97a8a80b-b5f2-4bf8-9348-13092ef6f040"
      }
    ],
    productNameEnglish: "UFC REFRESH 100% NATURAL COCONUT WATER",
    productPrice: "3.80",
    productSupplier: "BCS SHOP",
    sortOrder: "d",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1L",
    updateDateTime: "04/07/2020 11:24:44",
    count: 2
  },
  {
    category: "KITCHEN DINING",
    key: "-M9fBN8ThHVka9M64fw_",
    photos: [
      {
        imageName: "2111b7c0-ad11-11ea-9aab-f922f3904dfb.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F2111b7c0-ad11-11ea-9aab-f922f3904dfb.jpg?alt=media&token=03cc8cbf-b3ac-4a18-9e9e-ec8e37f819b8"
      }
    ],
    productNameEnglish: "Spoon",
    productPrice: "5",
    productSupplier: "BCS SHOP",
    searchText: "চামচ ",
    sortOrder: "x",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1 pc",
    updateDateTime: "17/07/2020 02:37:47",
    count: 2
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    isPopular: "YES",
    key: "-M9aSvkrW8JCLm9Dvxhy",
    photos: [
      {
        imageName: "7d11cec0-ac58-11ea-bbe4-619ccaa778ae.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F7d11cec0-ac58-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=3b63f196-00de-4f2d-a8f3-55fdca947c35"
      }
    ],
    productNameEnglish: "MUSTARD SEEDS ",
    productPrice: "1.50",
    productSupplier: "BCS SHOP",
    searchText: " সরিষা",
    sortOrder: "a",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1 pkt",
    updateDateTime: "23/07/2020 12:51:08",
    count: 2
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    photos: [
      {
        imageName: "1c08ab80-e81c-11ea-b1ae-e3e3c2d1f850.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F1c08ab80-e81c-11ea-b1ae-e3e3c2d1f850.jpg?alt=media&token=46849882-ebb9-494c-ad90-cad43e536f1d"
      }
    ],
    productNameEnglish: "Shan turmeric powder",
    productPrice: "1.80",
    productSupplier: "BCS SHOP",
    searchText: "turmeric powder",
    sortOrder: "a",
    supplierContactName: "Ismita",
    supplierContactPhone: "userMobile",
    unit: "200g",
    updateDateTime: "Thu 27-08-20 12:16 pm",
    key: "-MFi7SivFrmiI3eW1WxW",
    count: 2
  },
  {
    category: "TOILETRIES",
    key: "-M9gCMyomakJx06w1EuF",
    photos: [
      {
        imageName: "db223f50-ad38-11ea-b044-d71d8f034373.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fdb223f50-ad38-11ea-b044-d71d8f034373.jpg?alt=media&token=af6a4cc1-2e16-4caa-b67b-62e6262c1697"
      }
    ],
    productNameEnglish: "Toothpaste darlie shiny whiteenamel care",
    productPrice: "4.5",
    productSupplier: "BCS SHOP",
    sortOrder: "x",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "140gm",
    updateDateTime: "04/07/2020 11:09:32",
    count: 2
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    isPopular: "YES",
    key: "-M9af2C6QcBOgCNLYrUY",
    photos: [
      {
        imageName: "9d3f4a30-ac60-11ea-bbe4-ef7bbce60778.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F9d3f4a30-ac60-11ea-bbe4-ef7bbce60778.jpg?alt=media&token=80081c6c-38c4-4a13-8fce-16deb8c7238c"
      }
    ],
    productNameEnglish: "Apple cider vinegar ",
    productPrice: "3.5",
    productSupplier: "BCS SHOP",
    sortOrder: "d",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "473ml",
    updateDateTime: "17/07/2020 08:35:47",
    count: 2
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    key: "-MFi4VtLQhsiCgJTHMAp",
    photos: [
      {
        imageName: "338ffe90-e81a-11ea-b1ae-e3e3c2d1f850.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F338ffe90-e81a-11ea-b1ae-e3e3c2d1f850.jpg?alt=media&token=cdd93cdd-734c-4f8b-a9a0-15f3292205ae"
      }
    ],
    productNameEnglish: "Shan garam masala powder",
    productPrice: "2.20",
    productSupplier: "BCS SHOP",
    searchText: "garam masala",
    sortOrder: "a",
    supplierContactName: "Ismita",
    supplierContactPhone: "userMobile",
    unit: "50g",
    updateDateTime: "Thu 27-08-20 1:14 pm",
    count: 2
  },
  {
    category: "RICE DAAL NOODLES",
    key: "-M9b7apudcJmYv59Ojtf",
    photos: [
      {
        imageName: "a4d8c3e0-ac72-11ea-8ded-437354ec7423.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fa4d8c3e0-ac72-11ea-8ded-437354ec7423.jpg?alt=media&token=3fdfb1e2-e845-4f55-afa8-65dabfb98b1b"
      }
    ],
    productNameEnglish: "Cup noodles chicken",
    productPrice: "2",
    productSupplier: "BCS SHOP",
    sortOrder: "d",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1 Pkt",
    updateDateTime: "04/07/2020 11:30:17",
    count: 2
  },
  {
    availability: "AVAILABLE",
    category: "DRINKS DESSERT",
    key: "-M9gEU9ioX8yOm2Yyle8",
    photos: [
      {
        imageName: "462f8810-ad3a-11ea-9a01-db9ea96fa329.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F462f8810-ad3a-11ea-9a01-db9ea96fa329.jpg?alt=media&token=e2518ae1-0f3e-42d6-970a-ae2b3ca8b55b"
      }
    ],
    productNameEnglish: "MILO ACTIV-GO LOWER IN SUGER",
    productPrice: "7",
    productSupplier: "BCS SHOP",
    searchText: "মিলো",
    sortOrder: "d",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "15 x 33g",
    updateDateTime: "17/07/2020 08:47:34",
    count: 2
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    key: "-MEfpcbKWce6xFoMeF0M",
    photos: [
      {
        imageName: "6967e670-ddfe-11ea-a50a-71ea37251d72.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F6967e670-ddfe-11ea-a50a-71ea37251d72.jpg?alt=media&token=869b475b-d16c-4506-adbe-c3a36a93074f"
      }
    ],
    productNameEnglish: "beef masala pran",
    productPrice: "2.50",
    productSupplier: "BCS SHOP",
    searchText: "beef masala",
    sortOrder: "a",
    supplierContactName: "Ismita",
    supplierContactPhone: "userMobile",
    unit: "1 pkt 100g",
    updateDateTime: "Fri 14-08-20 4:16 pm",
    count: 2
  },
  {
    availability: "AVAILABLE",
    category: "RICE DAAL NOODLES",
    key: "-M9hkaEMkQ8ozocccNLY",
    photos: [
      {
        imageName: "6b90c4d0-ad75-11ea-8617-6988f4fcb266.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F6b90c4d0-ad75-11ea-8617-6988f4fcb266.jpg?alt=media&token=ec4a1442-e561-4df4-ac3f-54d6f4aebf45"
      }
    ],
    productNameEnglish: "Royal India Basmati Rice ",
    productPrice: "19.90",
    productSupplier: "BCS SHOP",
    searchText: "চাউল rice",
    sortOrder: "b",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "5Kg",
    updateDateTime: "03/08/2020 06:51:12",
    count: 2
  },
  {
    category: "FRUITS VEGETABLES ",
    isPopular: "YES",
    key: "-MA4Vt8UuRY3ZbTkrlKM",
    photos: [
      {
        imageName: "2abbbc50-bc55-11ea-b7df-33e703b87300.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F2abbbc50-bc55-11ea-b7df-33e703b87300.jpg?alt=media&token=e55ce384-e792-4d17-8245-6c216c702e44"
      }
    ],
    productNameEnglish: "Arugula",
    productPrice: "2.6",
    productSupplier: "BCS SHOP",
    searchText: "শাক সবজি সব্জি ",
    sortOrder: "a",
    sourceSupplier: "Sheng siong ",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "500gm",
    updateDateTime: "17/07/2020 02:14:45",
    count: 2
  },
  {
    category: "DRINKS DESSERT",
    isPopular: "YES",
    key: "-M9gdKMWElwiXoeMBUTl",
    photos: [
      {
        imageName: "0c3c6050-ad4a-11ea-9a01-db9ea96fa329.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F0c3c6050-ad4a-11ea-9a01-db9ea96fa329.jpg?alt=media&token=da35e7b2-d853-4a7f-b7c9-59179208129b"
      }
    ],
    productNameEnglish: "Nescafe Instant Soluble Coffee Jar - Deluxe",
    productPrice: "7.50",
    productSupplier: "BCS SHOP",
    sortOrder: "a",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "200gm Bottle",
    updateDateTime: "Tue 18-08-20 9:46 am",
    count: 2
  },
  {
    category: "DRINKS DESSERT",
    key: "-M9fkE_F7sw40RiQnwnz",
    photos: [
      {
        imageName: "34867be0-ad27-11ea-9a01-db9ea96fa329.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F34867be0-ad27-11ea-9a01-db9ea96fa329.jpg?alt=media&token=edcb9fa4-f5cf-47a1-9cdf-42a48d6c66d2"
      }
    ],
    productNameEnglish: "VITASOY ORIGINAL SOYA BEAN DRINK",
    productPrice: "3.20",
    productSupplier: "BCS SHOP",
    sortOrder: "d",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "6 x 250ml",
    updateDateTime: "04/07/2020 11:25:05",
    count: 2
  },
  {
    category: "DRINKS DESSERT",
    key: "-M9gGl_ykmk2MFL967d-",
    photos: [
      {
        imageName: "ab7f64f0-ad3b-11ea-9a01-db9ea96fa329.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fab7f64f0-ad3b-11ea-9a01-db9ea96fa329.jpg?alt=media&token=28b32328-b7e6-4533-89a6-2a7720829dab"
      }
    ],
    productNameEnglish: "OLD TOWN 3 IN 1 CLASSIC WHITE COFFEE MIX",
    productPrice: "7.50",
    productSupplier: "BCS SHOP",
    sortOrder: "g",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "15x38g",
    updateDateTime: "04/07/2020 10:53:14",
    count: 2
  },
  {
    category: "COOKING OIL INGREDIENTS",
    key: "-M9fUyvL2TFHVdiq4r-Y",
    photos: [
      {
        imageName: "47b061e0-ad1d-11ea-9a01-db9ea96fa329.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F47b061e0-ad1d-11ea-9a01-db9ea96fa329.jpg?alt=media&token=e3e14745-32f5-4c48-84fa-302273e30645"
      }
    ],
    productNameEnglish: "NATUREL SUNFLOWER OIL",
    productPrice: "5.80",
    productSupplier: "BCS SHOP",
    sortOrder: "d",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1L",
    updateDateTime: "04/07/2020 11:51:43",
    count: 2
  },
  {
    category: "STATIONARY",
    isPopular: "NO",
    key: "-MA96ThUvng4JLtbcjqV",
    photos: [
      {
        imageName: "173bf690-b1c9-11ea-825a-3b8acfde6ce7.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F173bf690-b1c9-11ea-825a-3b8acfde6ce7.jpg?alt=media&token=b5014879-f5ae-4b31-afab-d3883bfed06e"
      }
    ],
    productNameEnglish: "Pen Pilot G2 0.5M gel ink rollerball pen",
    productPrice: "2.50",
    productSupplier: "BCS SHOP",
    searchText: "কলম ",
    sortOrder: "n",
    sourceSupplier: "MUSTAFA CENTRE",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1pc",
    updateDateTime: "17/07/2020 02:07:26",
    count: 2
  },
  {
    category: "RICE DAAL NOODLES",
    key: "-M9hjeXdH6PLlcrwMShr",
    photos: [
      {
        imageName: "c9023c80-ad74-11ea-8617-6988f4fcb266.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fc9023c80-ad74-11ea-8617-6988f4fcb266.jpg?alt=media&token=0eab69cb-5644-4eea-82b5-df16dc3ad2e3"
      }
    ],
    productNameEnglish: "Royal Umbrella Jasmine Fragrant Rice ",
    productPrice: "18.3",
    productSupplier: "BCS SHOP",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "5kg",
    updateDateTime: "03/08/2020 06:52:09",
    count: 2
  },
  {
    availability: "AVAILABLE",
    category: "OTHERS",
    key: "-MAywiPOYxcEO50-mrk9",
    photos: [
      {
        imageName: "5131adb0-e8e0-11ea-b634-e7e7c4cb042d.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F5131adb0-e8e0-11ea-b634-e7e7c4cb042d.jpg?alt=media&token=46317372-b7a9-44ec-b42e-d9d4640e5c52"
      }
    ],
    productNameEnglish: "Surgical Face mask",
    productPrice: "18.90",
    productSupplier: "BCS SHOP",
    searchText: "মাস্ক ",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "50pcs of 1packet.",
    updateDateTime: "Fri 28-08-20 1:45 pm",
    count: 1
  },
  {
    category: "TOILETRIES",
    isPopular: "NO",
    key: "-M9qZ4eweURh0156FPwh",
    photos: [
      {
        imageName: "799de0e0-aecd-11ea-9cc0-814fbb741388.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F799de0e0-aecd-11ea-9cc0-814fbb741388.jpg?alt=media&token=9f4d3099-d075-4d13-b04a-edba711d5cbd"
      }
    ],
    productNameEnglish: "Pursoft Kitchen Towel Roll",
    productPrice: "6.20",
    productSupplier: "BCS SHOP",
    sortOrder: "k",
    sourceSupplier: "MUSTAFA CENTRE",
    supplierContactName: "arif",
    supplierContactPhone: "84124637",
    unit: "6pcs of 1packet ",
    updateDateTime: "03/08/2020 06:02:22",
    count: 1
  },
  {
    availability: "AVAILABLE",
    category: "EGGS DAIRY",
    isPopular: "NO",
    key: "-MBZUisJUWEgSH-uDmYN",
    photos: [
      {
        imageName: "b7abd190-bf93-11ea-85e3-735b22b1a0db.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fb7abd190-bf93-11ea-85e3-735b22b1a0db.jpg?alt=media&token=4b714d25-1da0-4055-88cc-df0192a8b02e"
      }
    ],
    productNameEnglish: "Ayam Brand Tuna Mayonnaise - Hot",
    productPrice: "2.65",
    productSupplier: "BCS SHOP",
    searchText: "টুনা মায়োনিস্ ",
    sortOrder: "g",
    supplierContactName: "Ahmed Fayyaz",
    supplierContactPhone: "97861239",
    unit: "100gm containter",
    updateDateTime: "03/08/2020 03:32:08",
    count: 1
  },
  {
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    isPopular: "YES",
    key: "-MA4b6SEakaGudeVUHPy",
    photos: [
      {
        imageName: "28ec8770-b119-11ea-810a-c5e0250e7646.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F28ec8770-b119-11ea-810a-c5e0250e7646.jpg?alt=media&token=2b2007cc-f32f-435b-a46a-4ff6c42a7443"
      }
    ],
    productNameEnglish: "Radicchio",
    productPrice: "6",
    productSupplier: "BCS SHOP",
    sortOrder: "a",
    sourceSupplier: "Sheng siong ",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1KG",
    updateDateTime: "03/08/2020 04:19:09",
    count: 1
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    isPopular: "YES",
    key: "-MA-INBhfRZ_Ufq7sGye",
    photos: [
      {
        imageName: "d91ba430-b049-11ea-9737-25db4b55bc7b.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fd91ba430-b049-11ea-9737-25db4b55bc7b.jpg?alt=media&token=f58486ae-0eb0-4b0a-8280-3013d3695dbf"
      }
    ],
    productNameEnglish: "PRAN Bbq Masala",
    productPrice: "3.60",
    productSupplier: "BCS SHOP",
    searchText: "BBQ মসলা ",
    sortOrder: "a",
    sourceSupplier: "KHAN PRODUCTS PTE LTD.",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "50G",
    updateDateTime: "03/08/2020 04:50:20",
    count: 1
  },
  {
    author: "+6594562455",
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    key: "-M9b11V3Y0kE8aCjjY_1",
    photos: [
      {
        imageName: "c0e255a0-ac6e-11ea-83ef-037972cabc05.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fc0e255a0-ac6e-11ea-83ef-037972cabc05.jpg?alt=media&token=7117ff9a-187c-4536-8bca-e43bb6ad46fb"
      }
    ],
    productNameEnglish: "YELLOW LEMON lime",
    productPrice: "1.80",
    productSupplier: "BCS SHOP",
    searchText: "লেবু ",
    sortOrder: "d",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "2 pcs ",
    updateDateTime: "Sat 08-08-20 11:47 am",
    count: 1
  },
  {
    category: "TOILETRIES",
    key: "-M9bAvuFocwVT1Lt_S9j",
    photos: [
      {
        imageName: "b7134a60-ac74-11ea-8ded-437354ec7423.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fb7134a60-ac74-11ea-8ded-437354ec7423.jpg?alt=media&token=43bf3fb2-c434-44fd-8a0f-0a75e5c7c0a8"
      },
      {
        imageName: "c05f3430-ac74-11ea-8ded-437354ec7423.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fc05f3430-ac74-11ea-8ded-437354ec7423.jpg?alt=media&token=49833320-a797-4748-a3a4-8f4c4659512b"
      }
    ],
    productNameEnglish: "Hand wash",
    productPrice: "4.2",
    productSupplier: "BCS SHOP",
    sortOrder: "d",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "500ml",
    updateDateTime: "04/07/2020 08:45:02",
    count: 1
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    isPopular: "YES",
    key: "-MA-Dnh-n931gdIbkaF9",
    photos: [
      {
        imageName: "01e6f020-b047-11ea-9737-25db4b55bc7b.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F01e6f020-b047-11ea-9737-25db4b55bc7b.jpg?alt=media&token=8e0626a6-ffbf-4565-b402-ecc9a5403ead"
      }
    ],
    productNameEnglish: "RADHUNI Meat Masala",
    productPrice: "3.50",
    productSupplier: "BCS SHOP",
    searchText: "খাসির মাংস মসলা ",
    sortOrder: "a",
    sourceSupplier: "KHAN PRODUCTS PTE LTD.",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "20G",
    updateDateTime: "03/08/2020 04:57:52",
    count: 1
  },
  {
    category: "COOKING OIL INGREDIENTS",
    isPopular: "YES",
    key: "-MA-gbxP3URtD4qfXJQ3",
    photos: [
      {
        imageName: "3d7f9210-b059-11ea-8357-d5a4954c59fc.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F3d7f9210-b059-11ea-8357-d5a4954c59fc.jpg?alt=media&token=99eaa607-195e-4d6c-a4d5-6db3773047b7"
      }
    ],
    productNameEnglish: "PRAN Chicken Roast Masala Powder",
    productPrice: "2.90",
    productSupplier: "BCS SHOP",
    searchText: "চিকেন রোস্ট মসলা",
    sortOrder: "c",
    sourceSupplier: "TERRY TRADING CO PTE LTD",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "35G",
    updateDateTime: "03/08/2020 04:45:29",
    count: 1
  },
  {
    availability: "AVAILABLE",
    category: "RICE DAAL NOODLES",
    key: "-M9m_b44ut235CDhnAM2",
    photos: [
      {
        imageName: "052e9c40-ae32-11ea-8070-f3cc7bbcb5d1.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F052e9c40-ae32-11ea-8070-f3cc7bbcb5d1.jpg?alt=media&token=eb07da47-4065-43f6-bc5b-2fae72aa0a3e"
      }
    ],
    productNameEnglish: "Royal Umbrella Jasmine Fragrant Rice",
    productPrice: "10.90",
    productSupplier: "BCS SHOP",
    searchText: "চাউল rice",
    sortOrder: "b",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "2.5kg",
    updateDateTime: "03/08/2020 06:50:08",
    count: 1
  },
  {
    availability: "AVAILABLE",
    category: "EGGS DAIRY",
    isPopular: "NO",
    key: "-MBZSgMuAhBkuSScVIda",
    photos: [
      {
        imageName: "6b7bfe40-bf92-11ea-85e3-735b22b1a0db.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F6b7bfe40-bf92-11ea-85e3-735b22b1a0db.jpg?alt=media&token=0bc32690-6e45-4876-8478-ce39d63fc9aa"
      }
    ],
    productNameEnglish: "Greenfields Fresh Milk - Chocolate Malt",
    productPrice: "3.30",
    productSupplier: "BCS SHOP",
    searchText: "গ্রীনফিল্ড চকলেট মাল্ট",
    sortOrder: "G",
    supplierContactName: "Ahmed Fayyaz",
    supplierContactPhone: "97861239",
    unit: "1L",
    updateDateTime: "03/08/2020 03:33:35",
    count: 1
  },
  {
    category: "KITCHEN DINING",
    key: "-M9b8c4xiaoUzpBsxhG0",
    photos: [
      {
        imageName: "6253d860-ac73-11ea-83ef-037972cabc05.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F6253d860-ac73-11ea-83ef-037972cabc05.jpg?alt=media&token=af1e5d07-f220-4cb4-9a04-4e604cec50d8"
      }
    ],
    productNameEnglish: "CUTTING BOARD ",
    productPrice: "10 ",
    productSupplier: "BCS SHOP",
    sortOrder: "x",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1 pc",
    updateDateTime: "04/07/2020 08:49:03",
    count: 1
  },
  {
    category: "COSMETICS",
    key: "-M9qmo8m2Y8rF36Tbf4W",
    photos: [
      {
        imageName: "41bad8a0-aed6-11ea-a496-7103817df0c1.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F41bad8a0-aed6-11ea-a496-7103817df0c1.jpg?alt=media&token=6b66c4d5-23da-47ca-a35a-781a8d967487"
      }
    ],
    productNameEnglish: "Himani Navratna Revita Hair Oil",
    productPrice: "9",
    productSupplier: "BCS SHOP",
    sortOrder: "x",
    sourceSupplier: "MUSTAFA CENTRE",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "200ML",
    updateDateTime: "03/08/2020 05:40:44",
    count: 1
  },
  {
    availability: "AVAILABLE",
    category: "COSMETICS",
    key: "-M9qhy-cLtcoJBhXeJtE",
    photos: [
      {
        imageName: "5c6692a0-aed3-11ea-8a8d-4f5b661598fc.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F5c6692a0-aed3-11ea-8a8d-4f5b661598fc.jpg?alt=media&token=e4c1bfcf-2cc8-4898-8221-388a449348dc"
      }
    ],
    productNameEnglish:
      "Nivea Whitening Acne Oil Control + Pore Minimiser Cleanser & Scrub",
    productPrice: "9.9",
    productSupplier: "BCS SHOP",
    searchText: "ফেইস ওয়াশ ",
    sortOrder: "x",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "100ML",
    updateDateTime: "03/08/2020 05:49:48",
    count: 1
  },
  {
    availability: "AVAILABLE",
    category: "COSMETICS",
    key: "-M9qjQc6sQmiIIgkR9b1",
    photos: [
      {
        imageName: "17a96a60-aed4-11ea-8a8d-4f5b661598fc.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F17a96a60-aed4-11ea-8a8d-4f5b661598fc.jpg?alt=media&token=d9c31e7d-444f-499f-b3c4-327b24329b29"
      }
    ],
    productNameEnglish:
      "L`OREAL Men Expert Pure & Matte Charcoal Black Icy Foam",
    productPrice: "11.10",
    productSupplier: "BCS SHOP",
    searchText: "ফেইস ওয়াশ ",
    sortOrder: "d",
    sourceSupplier: "MUSTAFA CENTRE",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "100ML ",
    updateDateTime: "03/08/2020 05:46:24",
    count: 1
  },
  {
    availability: "AVAILABLE",
    category: "SANITARY",
    isPopular: "NO",
    key: "-MA-j9aKGGE3T3ChzTIC",
    photos: [
      {
        imageName: "0fedf400-bc5b-11ea-b7df-33e703b87300.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F0fedf400-bc5b-11ea-b7df-33e703b87300.jpg?alt=media&token=e830a52d-703a-48fa-b45a-5375a2757a05"
      }
    ],
    productNameEnglish: "Shieldtox All Insect Killer Spray - Powergard",
    productPrice: "4.20",
    productSupplier: "BCS SHOP",
    sortOrder: "o",
    sourceSupplier: "MUSTAFA CENTRE",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "270ml",
    updateDateTime: "03/08/2020 04:44:15",
    count: 1
  },
  {
    category: "TOILETRIES",
    key: "-M9fhaow2dFpVyUAre4G",
    photos: [
      {
        imageName: "726617b0-ad25-11ea-b044-d71d8f034373.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F726617b0-ad25-11ea-b044-d71d8f034373.jpg?alt=media&token=f9156b26-6dc4-406e-a45a-751652817148"
      }
    ],
    productNameEnglish: "Tootthpast colgate sensitive pro relief whitening",
    productPrice: "9",
    productSupplier: "BCS SHOP",
    sortOrder: "d",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "110gm",
    updateDateTime: "04/07/2020 11:26:16",
    count: 1
  },
  {
    category: "COOKING OIL INGREDIENTS",
    key: "-M9fOV-yMxcL9A6pqBzA",
    photos: [
      {
        imageName: "5312cc70-ad19-11ea-8bc0-03f48af12a9c.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F5312cc70-ad19-11ea-8bc0-03f48af12a9c.jpg?alt=media&token=7a7ec498-d269-4746-8efe-5de37bf4e9ed"
      }
    ],
    productNameEnglish: "BORGES OLIVE OIL EXTRA LIGHT",
    productPrice: "29",
    productSupplier: "BCS SHOP",
    sortOrder: "d",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "2L",
    updateDateTime: "04/07/2020 11:54:04",
    count: 1
  },
  {
    availability: "AVAILABLE",
    category: "RICE DAAL NOODLES",
    key: "-M9ma8CcI51a_N56Srhs",
    photos: [
      {
        imageName: "61e7cb00-ae32-11ea-8070-f3cc7bbcb5d1.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F61e7cb00-ae32-11ea-8070-f3cc7bbcb5d1.jpg?alt=media&token=56868607-b2b0-401a-8d39-7586d85c1ed7"
      }
    ],
    productNameEnglish: "Paddy Land Jasmine Fragrant Rice",
    productPrice: "8.6",
    productSupplier: "BCS SHOP",
    searchText: "চাউল rice",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "5Kg",
    updateDateTime: "03/08/2020 06:49:22",
    count: 1
  },
  {
    availability: "AVAILABLE",
    category: "RICE DAAL NOODLES",
    key: "-MDeJ5jT1rQq8hlzdcn4",
    photos: [
      {
        imageName: "f1a90000-d3fe-11ea-a0e0-7d366b7a98ae.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ff1a90000-d3fe-11ea-a0e0-7d366b7a98ae.jpg?alt=media&token=08e2aa38-1766-4926-8fdb-3f8c0b40293d"
      }
    ],
    productNameEnglish: "Green Moong Dal",
    productPrice: "4.50",
    productSupplier: "BCS SHOP",
    searchText: "ডাল",
    sortOrder: "a",
    supplierContactName: "Kabir",
    supplierContactPhone: "94562455",
    unit: "1kg ",
    updateDateTime: "03/08/2020 03:04:50",
    count: 1
  },
  {
    category: "DRINKS DESSERT",
    key: "-M9gHdslTGbvMaokHlSy",
    photos: [
      {
        imageName: "34a36d30-ad3c-11ea-9a01-db9ea96fa329.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F34a36d30-ad3c-11ea-9a01-db9ea96fa329.jpg?alt=media&token=3d5c1a5c-0ab6-4b95-a38c-d3bab259cf03"
      }
    ],
    productNameEnglish: "CERES WHISPERS OF SUMMER 100% JUICE",
    productPrice: "2.70",
    productSupplier: "BCS SHOP",
    sortOrder: "x",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1L",
    updateDateTime: "04/07/2020 10:22:07",
    count: 1
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    photos: [
      {
        imageName: "7e731120-e81c-11ea-b1ae-e3e3c2d1f850.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F7e731120-e81c-11ea-b1ae-e3e3c2d1f850.jpg?alt=media&token=9f6aa663-b083-4a98-a759-f034ba6ee7cc"
      }
    ],
    productNameEnglish: "Shan fenugreek leaves",
    productPrice: "1.50",
    productSupplier: "BCS SHOP",
    searchText: "fenugreek leaves",
    sortOrder: "a",
    supplierContactName: "Ismita",
    supplierContactPhone: "userMobile",
    unit: "50g",
    updateDateTime: "Thu 27-08-20 12:19 pm",
    key: "-MFi855Nl5zEHaWo1qSO",
    count: 1
  },
  {
    availability: "AVAILABLE",
    category: "DRINKS DESSERT",
    isPopular: "NO",
    key: "-M9aQByOxtIHQ-5lwDs9",
    photos: [
      {
        imageName: "fc4310c0-ac56-11ea-985e-71484f367323.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Ffc4310c0-ac56-11ea-985e-71484f367323.jpg?alt=media&token=3bd0a4ca-eee5-4113-a4b7-df8a68f2a7c7"
      }
    ],
    productNameEnglish: "Milo ",
    productPrice: "9",
    productSupplier: "BCS SHOP",
    searchText: "মিলো ",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "900gms",
    updateDateTime: "17/07/2020 08:47:16",
    count: 1
  },
  {
    availability: "AVAILABLE",
    category: "COSMETICS",
    key: "-M9ql62AvOC-_TkeZPGZ",
    photos: [
      {
        imageName: "48b0e100-aed5-11ea-8a8d-4f5b661598fc.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F48b0e100-aed5-11ea-8a8d-4f5b661598fc.jpg?alt=media&token=762b21a3-6998-4591-bfa3-a67a33b1806b"
      }
    ],
    productNameEnglish: "Himalaya Men Intense Oil Clear Lemon Face Wash",
    productPrice: "9.2",
    productSupplier: "BCS SHOP",
    searchText: "ফেইস ওয়াশ ",
    sortOrder: "x",
    sourceSupplier: "MUSTAFA CENTRE",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "100ML",
    updateDateTime: "03/08/2020 05:42:58",
    count: 1
  },
  {
    category: "COOKING OIL INGREDIENTS",
    key: "-M9b2rYajYMImsSvokyT",
    photos: [
      {
        imageName: "deacb7f0-ac6f-11ea-83ef-037972cabc05.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fdeacb7f0-ac6f-11ea-83ef-037972cabc05.jpg?alt=media&token=f4d091e6-6f8e-4939-8176-eda885e02668"
      }
    ],
    productNameEnglish: "SWEETENED CREAMER ",
    productPrice: "1.20",
    productSupplier: "BCS SHOP",
    sortOrder: "d",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1 tin",
    updateDateTime: "05/07/2020 12:17:32",
    count: 1
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    key: "-MFoUZc12Nwex7SCUlaW",
    photos: [
      {
        imageName: "90a6ce10-e914-11ea-8fce-359ac42234fb.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F90a6ce10-e914-11ea-8fce-359ac42234fb.jpg?alt=media&token=00299e97-b1f4-44ad-b1df-09ddd50899c9"
      }
    ],
    productNameEnglish: "Shan daal masala ",
    productPrice: "2.60",
    productSupplier: "BCS SHOP",
    searchText: "daal masala",
    sortOrder: "a",
    supplierContactName: "Ismita",
    supplierContactPhone: "userMobile",
    unit: "100g",
    updateDateTime: "Fri 28-08-20 6:04 pm",
    count: 1
  },
  {
    category: "STATIONARY",
    isPopular: "NO",
    key: "-M9qxlJlSduEAkgi-FoD",
    photos: [
      {
        imageName: "194fd850-aedd-11ea-9b4b-4bd8d539c6a6.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F194fd850-aedd-11ea-9b4b-4bd8d539c6a6.jpg?alt=media&token=6322dafb-96e7-4815-b563-68c5b2bbc548"
      }
    ],
    productNameEnglish: "Marker pen ",
    productPrice: "1.5",
    productSupplier: "BCS SHOP",
    sortOrder: "x",
    sourceSupplier: "MUSTAFA CENTRE",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1 Pen",
    updateDateTime: "04/07/2020 08:56:19",
    count: 1
  },
  {
    category: "KITCHEN DINING",
    key: "-MA4sgeQJgpkoZouqO1P",
    photos: [
      {
        imageName: "d17d1a30-b123-11ea-b0bf-cbb30a1eed12.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fd17d1a30-b123-11ea-b0bf-cbb30a1eed12.jpg?alt=media&token=3d227a15-d5ed-4952-8bb1-24e812cf1847"
      }
    ],
    productNameEnglish: "Wooden Angular Spoon (30cm)",
    productPrice: "6.50",
    productSupplier: "BCS SHOP",
    sortOrder: "x",
    sourceSupplier: "Sheng siong ",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "PER PC",
    updateDateTime: "03/08/2020 04:16:51",
    count: 1
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    photos: [
      {
        imageName: "26349da0-e833-11ea-a70c-3f9f15f1ac0f.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F26349da0-e833-11ea-a70c-3f9f15f1ac0f.jpg?alt=media&token=47418b1c-51e8-453c-a50b-da162f423e1d"
      }
    ],
    productNameEnglish: "Malka turmeric powder",
    productPrice: "1.30",
    productSupplier: "BCS SHOP",
    searchText: " turmeric powder",
    sortOrder: "a",
    supplierContactName: "Ismita",
    supplierContactPhone: "userMobile",
    unit: "100g",
    updateDateTime: "Thu 27-08-20 3:01 pm",
    key: "-MFiiCMnPa_ZArGp15n9",
    count: 1
  },
  {
    category: "MEAT FISH",
    isPopular: "YES",
    key: "-MA--EcLlJD8siFnyC5a",
    photos: [
      {
        imageName: "1a588050-b03e-11ea-9737-25db4b55bc7b.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F1a588050-b03e-11ea-9737-25db4b55bc7b.jpg?alt=media&token=35e46cda-8e33-4ea6-ba14-621032a29a0e"
      }
    ],
    productNameEnglish: "Silver Carp",
    productPrice: "6",
    productSupplier: "BCS SHOP",
    sortOrder: "a",
    sourceSupplier: "TERRY TRADING CO PTE LTD",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1KG",
    updateDateTime: "03/08/2020 05:20:09",
    count: 1
  },
  {
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    isPopular: "YES",
    key: "-MA4aIACmAC5fCV5M-7F",
    photos: [
      {
        imageName: "ff0095b0-bc52-11ea-b7df-33e703b87300.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fff0095b0-bc52-11ea-b7df-33e703b87300.jpg?alt=media&token=024e42da-b7bf-47c2-b344-8c14a05f6b5c"
      }
    ],
    productNameEnglish: "Peas",
    productPrice: "6.5",
    productSupplier: "BCS SHOP",
    searchText: "মটর ",
    sortOrder: "a",
    sourceSupplier: "Minaka trading ",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1KG",
    updateDateTime: "03/08/2020 04:19:24",
    count: 1
  },
  {
    category: "FRUITS VEGETABLES ",
    isPopular: "YES",
    key: "-MA0M1ZNeHSwSvsOVwJt",
    photos: [
      {
        imageName: "2054fdf0-b073-11ea-9c7f-87aca56d8623.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F2054fdf0-b073-11ea-9c7f-87aca56d8623.jpg?alt=media&token=860fad18-fcfd-4275-9939-4203727eea0e"
      }
    ],
    productNameEnglish: "Rock Melon",
    productPrice: "7.90",
    productSupplier: "BCS SHOP",
    sortOrder: "a",
    sourceSupplier: "Sheng siong ",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1 pc",
    updateDateTime: "03/08/2020 04:28:16",
    count: 1
  },
  {
    category: "TOILETRIES",
    key: "-M9qf1UxVbQed3GYVmKW",
    photos: [
      {
        imageName: "84476210-aed1-11ea-8a8d-4f5b661598fc.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F84476210-aed1-11ea-8a8d-4f5b661598fc.jpg?alt=media&token=e05d02ac-d02c-4757-a096-f5e3cd59c29a"
      }
    ],
    productNameEnglish: "Colgate Plax Ice Mouthwash",
    productPrice: "6.3",
    productSupplier: "BCS SHOP",
    sortOrder: "k",
    sourceSupplier: "Sheng siong ",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "250ML",
    updateDateTime: "03/08/2020 05:54:06",
    count: 1
  },
  {
    category: "TOILETRIES",
    key: "-M9r-cDBn4vIQlIH5Wh_",
    photos: [
      {
        imageName: "e08affc0-aede-11ea-9cc0-814fbb741388.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fe08affc0-aede-11ea-9cc0-814fbb741388.jpg?alt=media&token=e019ddee-9a47-4bcf-8cf1-e01dd2371534"
      }
    ],
    productNameEnglish: "Dettol Antiseptic Germicide",
    productPrice: "12.55",
    productSupplier: "BCS SHOP",
    sortOrder: "k",
    sourceSupplier: "MUSTAFA CENTRE",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1L",
    updateDateTime: "03/08/2020 05:32:51",
    count: 1
  },
  {
    category: "FRUITS VEGETABLES ",
    isPopular: "YES",
    key: "-MA4X1ylVhS1ea28CGLI",
    photos: [
      {
        imageName: "ab534fa0-bc54-11ea-b7df-33e703b87300.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fab534fa0-bc54-11ea-b7df-33e703b87300.jpg?alt=media&token=9062ee47-ae37-49a1-8749-4b3fd2f81fb5"
      }
    ],
    productNameEnglish: "Raddish ",
    productPrice: "4.50",
    productSupplier: "BCS SHOP",
    searchText: "শাক সবজি সব্জি ",
    sortOrder: "a",
    sourceSupplier: "Giant supermarket ",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1KG",
    updateDateTime: "03/08/2020 04:20:59",
    count: 1
  },
  {
    category: "COOKING OIL INGREDIENTS",
    key: "-M9fEJ2SMkO5D8A_eiQ7",
    photos: [
      {
        imageName: "1ad63050-ad13-11ea-8bc0-03f48af12a9c.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F1ad63050-ad13-11ea-8bc0-03f48af12a9c.jpg?alt=media&token=b4790a09-ae84-4756-87df-3a03864bf3b6"
      }
    ],
    productNameEnglish: "LEE KUM KEE PANDA OYSTER SAUCE",
    productPrice: "3.80",
    productSupplier: "BCS SHOP",
    sortOrder: "d",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "510g",
    updateDateTime: "05/07/2020 12:29:30",
    count: 1
  },
  {
    category: "KITCHEN DINING",
    isPopular: "NO",
    key: "-M9qfo7RSObSm8Oraur9",
    photos: [
      {
        imageName: "08b7cd50-aed2-11ea-8a8d-4f5b661598fc.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F08b7cd50-aed2-11ea-8a8d-4f5b661598fc.jpg?alt=media&token=e73a451b-6a67-4b34-a4ca-f884bb65b1af"
      }
    ],
    productNameEnglish: "Vegetable / Fruit Peeler",
    productPrice: "4.5",
    productSupplier: "BCS SHOP",
    sortOrder: "x",
    sourceSupplier: "MUSTAFA CENTRE",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1PC",
    updateDateTime: "03/08/2020 05:51:41",
    count: 1
  },
  {
    category: "RICE DAAL NOODLES",
    key: "-M9fDXrY0QwDR0Fy97Zl",
    photos: [
      {
        imageName: "9e29fd70-ad12-11ea-8bc0-03f48af12a9c.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F9e29fd70-ad12-11ea-8bc0-03f48af12a9c.jpg?alt=media&token=cad40c24-43a0-4722-8d7e-46309f977a36"
      }
    ],
    productNameEnglish: "SAN REMO PASTA LINGUINE",
    productPrice: "2.60",
    productSupplier: "BCS SHOP",
    sortOrder: "d",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "500g",
    updateDateTime: "05/07/2020 12:30:29",
    count: 1
  },
  {
    category: "RICE DAAL NOODLES",
    key: "-M9fViWxjrPp1dB01tGR",
    photos: [
      {
        imageName: "bc02fa30-ad1d-11ea-9a01-db9ea96fa329.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fbc02fa30-ad1d-11ea-9a01-db9ea96fa329.jpg?alt=media&token=bcd0b863-4411-4a10-86c3-263d8e475175"
      }
    ],
    productNameEnglish: "NATUREL ORGANIC MACARONI",
    productPrice: "3.80",
    productSupplier: "BCS SHOP",
    sortOrder: "d",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "500g",
    updateDateTime: "05/07/2020 12:00:21",
    count: 1
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    photos: [
      {
        imageName: "06bf2ff0-e81d-11ea-b1ae-e3e3c2d1f850.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2F06bf2ff0-e81d-11ea-b1ae-e3e3c2d1f850.jpg?alt=media&token=1ed00fea-c10f-442e-822d-c34ca83dc316"
      }
    ],
    productNameEnglish: "Shan chapli kabab",
    productPrice: "1.50",
    productSupplier: "BCS SHOP",
    searchText: "chapli kabab",
    sortOrder: "a",
    supplierContactName: "Ismita",
    supplierContactPhone: "userMobile",
    unit: "100g",
    updateDateTime: "Thu 27-08-20 12:23 pm",
    key: "-MFi8xY4_rUfIzh2LtYC",
    count: 1
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    photos: [
      {
        imageName: "e6067790-e82c-11ea-b1ae-e3e3c2d1f850.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcsfbtest/o/images%2Fe6067790-e82c-11ea-b1ae-e3e3c2d1f850.jpg?alt=media&token=79917cba-8080-423b-8b87-b8bd4685ff1e"
      }
    ],
    productNameEnglish: "Shan haleem mix",
    productPrice: "2.60",
    productSupplier: "BCS SHOP",
    searchText: "haleem mix",
    sortOrder: "a",
    supplierContactName: "Ismita",
    supplierContactPhone: "userMobile",
    unit: "300g",
    updateDateTime: "Thu 27-08-20 2:16 pm",
    key: "-MFiYxfbB1MBnMi7xRA0",
    count: 1
  },
  {
    category: "COOKING OIL INGREDIENTS",
    isPopular: "YES",
    key: "-MA-faWokfFjVRxskzQs",
    photos: [
      {
        imageName: "a4296b90-b058-11ea-8357-d5a4954c59fc.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fa4296b90-b058-11ea-8357-d5a4954c59fc.jpg?alt=media&token=493121d9-37b6-4122-97cc-0e1d7270aa20"
      }
    ],
    productNameEnglish: "PRAN Tehari Masala",
    productPrice: "3.90",
    productSupplier: "BCS SHOP",
    searchText: "তেহারি মসলা",
    sortOrder: "c",
    sourceSupplier: "RAJDHANI ENTERPRISE PTE LTD",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "50G",
    updateDateTime: "03/08/2020 04:47:09",
    count: 1
  },
  {
    availability: "AVAILABLE",
    category: "RICE DAAL NOODLES",
    key: "-M9fYouusyu6N1mtP-ee",
    photos: [
      {
        imageName: "a0082060-ad1f-11ea-9a01-db9ea96fa329.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fa0082060-ad1f-11ea-9a01-db9ea96fa329.jpg?alt=media&token=5f36bec9-4091-42b6-b726-42e0e716409e"
      }
    ],
    productNameEnglish: "NISSIN SEAFOOD FLAVOUR CUP NOODLES",
    productPrice: "2",
    productSupplier: "BCS SHOP",
    sortOrder: "d",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "Cup 75g",
    updateDateTime: "17/07/2020 06:53:40",
    count: 1
  },
  {
    category: "COOKING OIL INGREDIENTS",
    key: "-M9fX8o43RsfQQVRYJay",
    photos: [
      {
        imageName: "9a69f1c0-ad1e-11ea-9a01-db9ea96fa329.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F9a69f1c0-ad1e-11ea-9a01-db9ea96fa329.jpg?alt=media&token=eff85424-43fc-4615-a3bb-6f69ffe926ac"
      }
    ],
    productNameEnglish: "BORGES OLIVE OIL",
    productPrice: "8.50",
    productSupplier: "BCS SHOP",
    sortOrder: "x",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "500ml",
    updateDateTime: "04/07/2020 11:51:13",
    count: 1
  },
  {
    category: "COOKING OIL INGREDIENTS",
    key: "-M9fQhmeLH__-yY3QLsP",
    photos: [
      {
        imageName: "acaee740-ad1a-11ea-8bc0-03f48af12a9c.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Facaee740-ad1a-11ea-8bc0-03f48af12a9c.jpg?alt=media&token=0fc3a22f-d19c-4c2c-a6ba-f351d97db93d"
      }
    ],
    productNameEnglish: "NARCISSUS RICE VINEGAR",
    productPrice: "1.50",
    productSupplier: "BCS SHOP",
    sortOrder: "d",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "600g",
    updateDateTime: "05/07/2020 12:01:03",
    count: 1
  },
  {
    category: "LAUNDRY CLEANING",
    key: "-M9pXG6GmKhzZ5upS7CK",
    photos: [
      {
        imageName: "4cf653b0-aea5-11ea-9600-53e79e8cda87.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F4cf653b0-aea5-11ea-9600-53e79e8cda87.jpg?alt=media&token=2faef842-57d9-47ce-84e0-70e669614c9e"
      }
    ],
    productNameEnglish: "Ajax Fabuloso Multi Purpose Cleaner - Lavender Fresh",
    productPrice: "7.05",
    productSupplier: "BCS SHOP",
    sortOrder: "x",
    sourceSupplier: "MUSTAFA CENTRE",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1 bottol of 3L",
    updateDateTime: "03/08/2020 06:36:51",
    count: 1
  },
  {
    availability: "AVAILABLE",
    category: "MEAT FISH",
    isPopular: "YES",
    key: "-M9a2_CWuCbIou2qTCuq",
    photos: [
      {
        imageName: "9e45aa90-ac48-11ea-ba1a-4bcfa8bf5006.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F9e45aa90-ac48-11ea-ba1a-4bcfa8bf5006.jpg?alt=media&token=8bca4183-b6de-42fa-b59f-fe1b125e7b31"
      }
    ],
    productNameEnglish: "Fish small ",
    productPrice: "5.5",
    productSupplier: "BCS SHOP",
    sortOrder: "a",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1 packet",
    updateDateTime: "06/07/2020 07:13:04",
    count: 1
  },
  {
    availability: "AVAILABLE",
    category: "COSMETICS",
    key: "-M9qkW5FbzfMwsH1NsOs",
    photos: [
      {
        imageName: "cf6f2950-aed4-11ea-8a8d-4f5b661598fc.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fcf6f2950-aed4-11ea-8a8d-4f5b661598fc.jpg?alt=media&token=21252db9-ae32-4f42-af7c-3b353c66fccd"
      }
    ],
    productNameEnglish: "Himalaya Men Power Glow Licorice Face Wash",
    productPrice: "9.5",
    productSupplier: "BCS SHOP",
    searchText: "ফেইস ওয়াশ ",
    sortOrder: "x",
    sourceSupplier: "MUSTAFA CENTRE",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "100ML",
    updateDateTime: "03/08/2020 05:43:44",
    count: 1
  },
  {
    availability: "AVAILABLE",
    category: "COSMETICS",
    isPopular: "NO",
    key: "-M9qi8NirqjB3PjCGJ1X",
    photos: [
      {
        imageName: "888520e0-aed3-11ea-8a8d-4f5b661598fc.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F888520e0-aed3-11ea-8a8d-4f5b661598fc.jpg?alt=media&token=330079ea-2946-4a4c-b20a-1d1809979bb0"
      }
    ],
    productNameEnglish: "Nivea Multi-Effect 8 Oil Control Face Wash",
    productPrice: "9.9",
    productSupplier: "BCS SHOP",
    searchText: "ফেইস ওয়াশ ",
    sortOrder: "x",
    sourceSupplier: "MUSTAFA CENTRE",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "100ML",
    updateDateTime: "03/08/2020 05:48:30",
    count: 1
  },
  {
    category: "SANITARY",
    key: "-M9gIt0XRkIKwvG7mT3P",
    photos: [
      {
        imageName: "ce7664d0-ad3c-11ea-b044-d71d8f034373.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fce7664d0-ad3c-11ea-b044-d71d8f034373.jpg?alt=media&token=aab092f8-636b-46c0-b6df-f231cb4a47c8"
      }
    ],
    productNameEnglish: "Toothbrush darlie charcoal clean    ",
    productPrice: "5",
    productSupplier: "BCS SHOP",
    sortOrder: "x",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "1pc",
    updateDateTime: "04/07/2020 10:21:04",
    count: 1
  },
  {
    availability: "AVAILABLE",
    category: "FRUITS VEGETABLES ",
    isPopular: "YES",
    key: "-MA4UgzmLJisWqpgWd3O",
    photos: [
      {
        imageName: "4df926a0-bdac-11ea-8ba8-ddb60ef370d4.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F4df926a0-bdac-11ea-8ba8-ddb60ef370d4.jpg?alt=media&token=2a248587-1839-4b03-8bef-5a2d1ef69bd3"
      }
    ],
    productNameEnglish: "Curry Leaves",
    productPrice: "1.60",
    productSupplier: "BCS SHOP",
    sortOrder: "a",
    sourceSupplier: "Veg mart ",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "100G",
    updateDateTime: "03/08/2020 04:21:36",
    count: 1
  },
  {
    category: "DRINKS DESSERT",
    key: "-M9b3SnWKBFpNCAcrE7G",
    photos: [
      {
        imageName: "1d14abb0-ac70-11ea-9366-875156fdc5b0.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F1d14abb0-ac70-11ea-9366-875156fdc5b0.jpg?alt=media&token=2c3a8293-dd81-4091-ad6a-d17764a3f6a3"
      }
    ],
    productNameEnglish: " Orange juice drink  2litres ",
    productPrice: "4.8",
    productSupplier: "BCS SHOP",
    sortOrder: "d",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "2L",
    updateDateTime: "05/07/2020 12:15:42",
    count: 1
  },
  {
    category: "TOILETRIES",
    key: "-M9qW3hb6pRhivor4ItI",
    photos: [
      {
        imageName: "a205baa0-aecb-11ea-9cc0-814fbb741388.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fa205baa0-aecb-11ea-9cc0-814fbb741388.jpg?alt=media&token=a4a75886-cde8-4914-9068-bcb4393bb9ee"
      }
    ],
    productNameEnglish: "Onwards Kitchen Towel Roll ",
    productPrice: "6.50",
    productSupplier: "BCS SHOP",
    sortOrder: "k",
    sourceSupplier: "Sheng siong ",
    supplierContactName: "arif",
    supplierContactPhone: "84124637",
    unit: "8 rolls of 1 packet",
    updateDateTime: "03/08/2020 06:04:40",
    count: 1
  },
  {
    availability: "AVAILABLE",
    category: "MEAT FISH",
    key: "-M9bIu5zRY9p3Btp4DAn",
    photos: [
      {
        imageName: "980b7750-ac79-11ea-90b2-195942e61adb.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F980b7750-ac79-11ea-90b2-195942e61adb.jpg?alt=media&token=027ff7b0-fa85-49af-9498-9ec8277bee00"
      }
    ],
    productNameEnglish: "Chicken nuggets 900gm 1packet ",
    productPrice: "9",
    productSupplier: "BCS SHOP",
    searchText: "চিকেন নাগেট ",
    sortOrder: "d",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "900gm",
    updateDateTime: "17/07/2020 03:14:07",
    count: 1
  },
  {
    category: "LAUNDRY CLEANING",
    key: "-M9plDFNnX5i4BDGvIG7",
    photos: [
      {
        imageName: "6c1e77a0-aeae-11ea-9600-53e79e8cda87.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F6c1e77a0-aeae-11ea-9600-53e79e8cda87.jpg?alt=media&token=9a927ad4-8ecf-4547-98fd-19c87846e81b"
      }
    ],
    productDescription: "(1.6l) REFILL",
    productNameEnglish: "Softlan Anti-Wrinkles Fabric Conditioner",
    productPrice: "3.90",
    productSupplier: "BCS SHOP",
    sortOrder: "x",
    sourceSupplier: "Sheng siong ",
    supplierContactName: "arif",
    supplierContactPhone: "84124637",
    unit: "1 packet of 1.6L",
    updateDateTime: "03/08/2020 06:31:40",
    count: 1
  },
  {
    category: "TOILETRIES",
    key: "-M9fDzi6Dop6f0UEozcs",
    photos: [
      {
        imageName: "aac5d590-ad12-11ea-9aab-f922f3904dfb.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Faac5d590-ad12-11ea-9aab-f922f3904dfb.jpg?alt=media&token=7b3936ca-bf59-4ffd-bdcd-d12fa3308775"
      }
    ],
    productNameEnglish: "Cottony Kleenex 3ply B/T",
    productPrice: "17",
    productSupplier: "BCS SHOP",
    searchText: "টিস্যু পেপার ",
    sortOrder: "d",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    unit: "20roll x 1packet ",
    updateDateTime: "17/07/2020 02:37:11",
    count: 1
  },
  {
    category: "FRUITS VEGETABLES ",
    key: "-M9b4LZs7VKuhHdtk47B",
    photos: [
      {
        imageName: "c71bbd60-ac70-11ea-83ef-037972cabc05.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2Fc71bbd60-ac70-11ea-83ef-037972cabc05.jpg?alt=media&token=519a77a1-35dc-43bd-8959-9129a6d6492c"
      }
    ],
    productNameEnglish: "LONGAN",
    productPrice: "3",
    productSupplier: "BCS SHOP",
    sortOrder: "d",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1 tin",
    updateDateTime: "05/07/2020 12:09:56",
    count: 1
  },
  {
    category: "COSMETICS",
    key: "-M9gN5Ldhfx7tnCST-p7",
    photos: [
      {
        imageName: "724c0130-ad3f-11ea-b044-d71d8f034373.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F724c0130-ad3f-11ea-b044-d71d8f034373.jpg?alt=media&token=1774d9e1-0442-4b0a-bd3e-9bb6a16caef7"
      }
    ],
    productNameEnglish: "Shaving foam denim foam black 300ml",
    productPrice: "5.5",
    productSupplier: "BCS SHOP",
    sortOrder: "x",
    supplierContactName: "ARIF",
    supplierContactPhone: "84124637",
    updateDateTime: "04/07/2020 10:17:17",
    count: 1
  },
  {
    availability: "AVAILABLE",
    category: "COOKING OIL INGREDIENTS",
    isPopular: "YES",
    key: "-M9aTqdEuYIFo6kUyqf-",
    photos: [
      {
        imageName: "1cb17480-ac59-11ea-bbe4-619ccaa778ae.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F1cb17480-ac59-11ea-bbe4-619ccaa778ae.jpg?alt=media&token=7d33c4d9-a403-449c-a06b-9a44907e7357"
      }
    ],
    productNameEnglish: "NUTMEG ",
    productPrice: "1.50",
    productSupplier: "BCS SHOP",
    searchText: "জায়ফল",
    sortOrder: "x",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1 pkt",
    updateDateTime: "23/07/2020 12:49:03",
    count: 1
  },
  {
    category: "LAUNDRY CLEANING",
    key: "-M9pNpff9SWiowz5uO0H",
    photos: [
      {
        imageName: "8b742820-ae9f-11ea-9600-53e79e8cda87.jpg",
        status: "DONE",
        url:
          "https://firebasestorage.googleapis.com/v0/b/bcs-fb-database.appspot.com/o/images%2F8b742820-ae9f-11ea-9600-53e79e8cda87.jpg?alt=media&token=41fa6fac-d443-4ba8-80a8-5e5aede36c4d"
      }
    ],
    productNameEnglish:
      "TOP Concentrated Liquid Detergent Refill - Anti Bacterial",
    productPrice: "4.95",
    productSupplier: "BCS SHOP",
    sortOrder: "x",
    supplierContactName: "IQBAL",
    supplierContactPhone: "89050302",
    unit: "1.6Kg",
    updateDateTime: "03/08/2020 06:43:03",
    count: 1
  }
];



// WEBPACK FOOTER //
// ./src/staticData/tPopularItems.js